<template>
  <v-app class="v-app">
    <!-- 상단 공지 - 마케팅 영역 -->
    <div v-if="top_alert && isMarketingRoute && !$route.meta.standaloneMarketing" data-testid="marketing-top-alert" :style="{height: top_alert_height}" style="position: sticky; top: 0px; z-index: 99; width: 100%; background-color: #F3F5FF">
      <!-- show-over-1441 -->
      <div class="show-over-1441" style="width: 100%; height: 100%">
        <div v-if="fontReady" class="d-flex align-center justify-center" style="width: 100%; height: 100%; gap: 15px">
          <!-- title -->
          <div style="font-size: 15px; font-weight: 600; line-height: 18px; color: #0D0E17">
            ✨ 우리 회사 데이터, <span style="color: #007AFF">AI가 바로 활용할 수 있을까요?</span> | 9.9–9.11 COEX · 2026 Smart work & Contact Center Expo 에서 ReColumn을 만나보세요 →
          </div>
          <!-- btn -->
          <div @click="clickTopAlert()"
            class="d-flex align-center"
            style="height: 30px; padding: 0px 16px; border-radius: 8px; background-color: #162050; cursor: pointer"
          >
            <div style="font-size: 14px; font-weight: 600; line-height: 18px; color: #ffffff">
              초청장 보기
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-1025-under-1440 -->
      <div class="show-over-1025-under-1440" style="width: 100%; height: 100%">
        <div v-if="fontReady" class="d-flex align-center justify-center" style="width: 100%; height: 100%; gap: 15px">
          <!-- title -->
          <div style="font-size: 15px; font-weight: 600; line-height: 18px; color: #0D0E17">
            ✨ 우리 회사 데이터, <span style="color: #007AFF">AI가 바로 활용할 수 있을까요?</span> | 9.9–9.11 COEX · 2026 SWCC Expo 에서 ReColumn을 만나보세요 →
          </div>
          <!-- btn -->
          <div @click="clickTopAlert()"
            class="d-flex align-center"
            style="height: 30px; padding: 0px 16px; border-radius: 8px; background-color: #162050; cursor: pointer"
          >
            <div style="font-size: 14px; font-weight: 600; line-height: 18px; color: #ffffff">
              초청장 보기
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-769-under-1024 -->
      <div class="show-over-769-under-1024" style="width: 100%; height: 100%">
        <div v-if="fontReady" class="d-flex align-center justify-center" style="width: 100%; height: 100%; gap: 15px">
          <!-- title -->
          <div style="font-size: 15px; font-weight: 600; line-height: 18px; color: #0D0E17">
            ✨ 우리 회사 데이터, <span style="color: #007AFF">AI가 바로 활용할 수 있을까요?</span> | SWCC Expo 에서 ReColumn을 만나보세요 →
          </div>
          <!-- btn -->
          <div @click="clickTopAlert()"
            class="d-flex align-center"
            style="height: 30px; padding: 0px 16px; border-radius: 8px; background-color: #162050; cursor: pointer"
          >
            <div style="font-size: 14px; font-weight: 600; line-height: 18px; color: #ffffff">
              초청장 보기
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-481-under-768 -->
      <div class="show-over-481-under-768" style="width: 100%; height: 100%">
        <div v-if="fontReady" class="d-flex align-center justify-center" style="width: 100%; height: 100%; cursor: pointer" @click="clickTopAlert()">
          <!-- title -->
          <div style="font-size: 15px; font-weight: 600; line-height: 18px; color: #0D0E17">
            리컬럼을 SWCC 2026에서 <span style="text-decoration: underline">만나보세요 →</span>
          </div>
        </div>
      </div>
      <!-- show-over-320-under-480 -->
      <div class="show-over-320-under-480" style="width: 100%; height: 100%">
        <div v-if="fontReady" class="d-flex align-center justify-center" style="width: 100%; height: 100%; cursor: pointer" @click="clickTopAlert()">
          <!-- title -->
          <div style="font-size: 15px; font-weight: 600; line-height: 18px; color: #0D0E17">
            리컬럼을 SWCC 2026에서 <span style="text-decoration: underline">만나보세요 →</span>
          </div>
        </div>
      </div>
    </div>
    <!-- navbar - 공개 화면 (show-over-1025) -->
    <div v-if="showPublicNavbar" data-testid="marketing-navbar-desktop" class="show-over-1025"
      style="position: sticky; z-index: 99; height: 60px; width: 100%; background-color: #FFFFFF; border-bottom: 1px solid #E8EAF2"
      :style="top_alert && isMarketingRoute ? {top: top_alert_height} : {top: '0px'}"
    >
      <div class="d-flex align-center justify-center" style="height: 100%">
        <div v-if="fontReady" class="nav-bar d-flex align-center" style="height: 100%">
          <!-- 리컬럼 로고 -->
          <div @click="clickNavLogo($event)" class="d-flex align-center" style="cursor: pointer; margin-right: 24px">
            <!-- logo -->
            <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
            <!-- title -->
            <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
              Re:Column
            </div>
          </div>
          <!-- 메뉴 - 제품(dropdown), 솔루션(dropdown), 고객사례, (가격안내(dropdown)), 뉴스룸 -->
          <div class="d-flex align-center" style="gap: 2px">
            <!-- 제품(dropdown) -->
            <div>
              <v-menu offset-y open-on-hover>
                <template v-slot:activator="{ on, value }">
                  <div v-on="on" class="d-flex align-center">
                    <div class="hover-bg-color d-flex align-center"
                      style="--hover-bg-color: #EFF0F6; height: 40px; border-radius: 8px; padding: 0px 10px; gap: 2px; cursor: pointer"
                    >
                      <div style="font-size: 14px; font-weight: 600; line-height: 18px; color: #0D0E17"
                        :style="$route?.name?.includes('Product') ? {color: '#687EFF'} : {color: '#0D0E17'}"
                      >
                        제품
                      </div>
                      <v-icon :class="value ? 'up' : 'down'" style="font-size: 16px; color: #ABAEC4">
                        mdi-chevron-down
                      </v-icon>
                    </div>
                  </div>
                </template>
                <v-card>
                  <div class="d-flex flex-column" style="width: 280px; padding: 10px 8px; gap: 6px">
                    <!-- 리컬럼 소개서 -->
                    <div @click="manualDownloadDialog = true"
                      class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                    >
                      <!-- icon box -->
                      <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #162050">
                        <v-icon style="font-size: 24px; color: #ffffff">
                          mdi-tray-arrow-down
                        </v-icon>
                      </div>
                      <!-- text box -->
                      <div>
                        <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                          리컬럼 소개서
                        </div>
                        <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                          PDF 다운로드
                        </div>
                      </div>
                    </div>
                    <!-- divider -->
                    <div style="width: 100%; height: 1px; background-color: #E8EAF2; margin: 4px 7px"></div>
                    <!-- 워크플로우 -->
                    <div @click="goProductPage('/product-workflow')"
                      class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                    >
                      <!-- icon box -->
                      <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #AF52DE1F">
                        <v-icon style="font-size: 24px; color: #AF52DE">
                          mdi-play-circle-outline
                        </v-icon>
                      </div>
                      <!-- text box -->
                      <div>
                        <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                          워크플로우
                        </div>
                        <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                          모든 반복 작업을 원클릭으로
                        </div>
                      </div>
                    </div>
                    <!-- 엑셀 서식 -->
                    <div @click="goProductPage('/product-excel-format')"
                      class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                    >
                      <!-- icon box -->
                      <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #5856D61F">
                        <v-icon style="font-size: 24px; color: #5856D6">
                          mdi-palette-outline
                        </v-icon>
                      </div>
                      <!-- text box -->
                      <div>
                        <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                          엑셀 서식
                        </div>
                        <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                          데이터 변경에 자동 대응
                        </div>
                      </div>
                    </div>
                    <!-- 시각화 대시보드 -->
                    <div @click="goProductPage('/product-visualization')"
                      class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                    >
                      <!-- icon box -->
                      <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #FF2D551F">
                        <v-icon style="font-size: 24px; color: #FF2D55">
                          mdi-chart-line
                        </v-icon>
                      </div>
                      <!-- text box -->
                      <div>
                        <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                          시각화 대시보드
                        </div>
                        <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                          자유로운 구성
                        </div>
                      </div>
                    </div>
                    <!-- 데이터 검증 -->
                    <div @click="goProductPage('/product-data-verify')"
                      class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                    >
                      <!-- icon box -->
                      <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #007AFF1F">
                        <v-icon style="font-size: 24px; color: #007AFF">
                          mdi-magnify
                        </v-icon>
                      </div>
                      <!-- text box -->
                      <div>
                        <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                          데이터 검증
                        </div>
                        <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                          두 데이터의 차이 검토
                        </div>
                      </div>
                    </div>
                    <!-- 문서 폼 -->
                    <div @click="goProductPage('/product-document-form')"
                      class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                    >
                      <!-- icon box -->
                      <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #00C7BE1F">
                        <v-icon style="font-size: 24px; color: #00C7BE">
                          mdi-file-outline
                        </v-icon>
                      </div>
                      <!-- text box -->
                      <div>
                        <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                          문서 폼
                        </div>
                        <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                          옵션 선택이 있는 폼 자동 작성
                        </div>
                      </div>
                    </div>
                    <!-- 이메일 유효성 검증 -->
                    <div @click="goProductPage('/product-email-verify')"
                      class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                    >
                      <!-- icon box -->
                      <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #34C7591F">
                        <v-icon style="font-size: 24px; color: #34C759">
                          mdi-at
                        </v-icon>
                      </div>
                      <!-- text box -->
                      <div>
                        <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                          이메일 유효성 검증
                        </div>
                        <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                          형식 및 유효성 검증
                        </div>
                      </div>
                    </div>
                    <!-- 협업 기능 -->
                    <div @click="goProductPage('/product-cooperation')"
                      class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                    >
                      <!-- icon box -->
                      <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #FF95001F">
                        <v-icon style="font-size: 24px; color: #FF9500">
                          mdi-account-multiple
                        </v-icon>
                      </div>
                      <!-- text box -->
                      <div>
                        <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                          협업 기능
                        </div>
                        <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                          작업 내역 및 소통
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-menu>
            </div>
            <!-- 솔루션(dropdown) -->
            <div>
              <v-menu offset-y open-on-hover>
                <template v-slot:activator="{ on, value }">
                  <div v-on="on" class="d-flex align-center">
                    <div class="hover-bg-color d-flex align-center"
                      style="--hover-bg-color: #EFF0F6; height: 40px; border-radius: 8px; padding: 0px 10px; gap: 2px; cursor: pointer"
                    >
                      <div style="font-size: 14px; font-weight: 600; line-height: 18px; color: #0D0E17"
                        :style="$route?.name?.includes('Solution') ? {color: '#687EFF'} : {color: '#0D0E17'}"
                      >
                        솔루션
                      </div>
                      <v-icon :class="value ? 'up' : 'down'" style="font-size: 16px; color: #ABAEC4">
                        mdi-chevron-down
                      </v-icon>
                    </div>
                  </div>
                </template>
                <v-card>
                  <div class="d-flex flex-column" style="width: 280px; padding: 10px 8px; gap: 6px">
                    <!-- 이커머스 -->
                    <div @click="goSolutionPage('/solution-ecommerce')"
                      class="hover-bg-color d-flex align-center" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                      :style="$route.name === 'SolutionEcommerce' ? {backgroundColor: '#F0F2FF'} : {}"
                    >
                      <!-- icon box -->
                      <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #EFF0F6">
                        <v-icon style="font-size: 24px; color: #414458">
                          mdi-shopping
                        </v-icon>
                      </div>
                      <!-- text -->
                      <div style="font-size: 16px; font-weight: 500; line-height: 140%; color: #0D0E17"
                        :style="$route.name === 'SolutionEcommerce' ? {color: '#687EFF'} : {color: '#414458'}"
                      >
                        이커머스
                      </div>
                    </div>
                    <!-- 유통 ∙ 물류 -->
                    <div @click="goSolutionPage('/solution-logistics')"
                      class="hover-bg-color d-flex align-center" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                      :style="$route.name === 'SolutionLogistics' ? {backgroundColor: '#F0F2FF'} : {}"
                    >
                      <!-- icon box -->
                      <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #162050">
                        <v-icon style="font-size: 24px; color: #FFFFFF">
                          mdi-truck-fast
                        </v-icon>
                      </div>
                      <!-- text -->
                      <div style="font-size: 16px; font-weight: 500; line-height: 140%; color: #0D0E17"
                        :style="$route.name === 'SolutionLogistics' ? {color: '#687EFF'} : {color: '#414458'}"
                      >
                        유통 ∙ 물류
                      </div>
                    </div>
                    <!-- 리테일 -->
                    <div @click="goSolutionPage('/solution-retail')"
                      class="hover-bg-color d-flex align-center" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                      :style="$route.name === 'SolutionRetail' ? {backgroundColor: '#F0F2FF'} : {}"
                    >
                      <!-- icon box -->
                      <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #EFF0F6">
                        <v-icon style="font-size: 24px; color: #414458">
                          mdi-store
                        </v-icon>
                      </div>
                      <!-- text -->
                      <div style="font-size: 16px; font-weight: 500; line-height: 140%; color: #0D0E17"
                        :style="$route.name === 'SolutionRetail' ? {color: '#687EFF'} : {color: '#414458'}"
                      >
                        리테일
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-menu>
            </div>
            <!-- 고객사례 -->
            <div @click="goCustomerExample()"
              class="hover-bg-color d-flex align-center"
              style="--hover-bg-color: #EFF0F6; height: 40px; border-radius: 8px; padding: 0px 10px; cursor: pointer; font-size: 14px; font-weight: 600; line-height: 18px"
              :style="$route.name === 'CustomerExample' || $route.name === 'CustomerExampleDetail' ? {color: '#687EFF'} : {color: '#0D0E17'}"
            >
              고객사례
            </div>
            <!-- 가격안내(dropdown) -->
            <div v-if="false">
              <v-menu offset-y open-on-hover>
                <template v-slot:activator="{ on, value }">
                  <div v-on="on" class="d-flex align-center">
                    <div class="hover-bg-color d-flex align-center"
                      style="--hover-bg-color: #EFF0F6; height: 40px; border-radius: 8px; padding: 0px 10px; gap: 2px; cursor: pointer"
                    >
                      <div style="font-size: 14px; font-weight: 600; line-height: 18px"
                        :style="$route.name === 'PlanGuide' || $route.name === 'Voucher' ? {color: '#687EFF'} : {color: '#0D0E17'}"
                      >
                        가격안내
                      </div>
                      <v-icon :class="value ? 'up' : 'down'" style="font-size: 16px; color: #ABAEC4">
                        mdi-chevron-down
                      </v-icon>
                    </div>
                  </div>
                </template>
                <v-card>
                  <div class="d-flex flex-column" style="width: 280px; padding: 10px 8px; gap: 6px">
                    <!-- 플랜 안내 -->
                    <div @click="goPlanGuide()"
                      class="hover-bg-color-F8F9FB d-flex align-start" style="width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                    >
                      <!-- icon box -->
                      <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #EFF0F6">
                        <v-icon style="font-size: 24px; color: #414458">
                          mdi-currency-usd
                        </v-icon>
                      </div>
                      <!-- text box -->
                      <div>
                        <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                          플랜 안내
                        </div>
                        <div style="font-size: 14px; font-weight: 400; line-height: 140%; color: #414458">
                          가장 적합한 플랜을 선택하세요
                        </div>
                      </div>
                    </div>
                    <!-- 바우처 -->
                    <div @click="goVoucher()"
                      class="hover-bg-color-F8F9FB d-flex align-start" style="width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                    >
                      <!-- icon box -->
                      <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #EFF0F6">
                        <v-icon style="font-size: 24px; color: #414458">
                          mdi-ticket-percent-outline
                        </v-icon>
                      </div>
                      <!-- text box -->
                      <div>
                        <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                          바우처
                        </div>
                        <div style="font-size: 14px; font-weight: 400; line-height: 140%; color: #414458">
                          도입 비용 70% 할인
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-menu>
            </div>
            <!-- 뉴스룸 -->
            <div @click="goNewsRoom()"
              class="hover-bg-color d-flex align-center"
              style="--hover-bg-color: #EFF0F6; height: 40px; border-radius: 8px; padding: 0px 10px; cursor: pointer; font-size: 14px; font-weight: 600; line-height: 18px"
              :style="$route.name === 'NewsRoom' || $route.name === 'NewsRoomDetail' ? {color: '#687EFF'} : {color: '#0D0E17'}"
            >
              뉴스룸
            </div>
          </div>
          <v-spacer></v-spacer>
          <!-- 연락처, 로그인 버튼, (2주 무료체험 버튼), 문의하기 버튼 -->
          <div class="d-flex align-center" style="gap: 8px">
            <!-- 연락처 -->
            <div class="d-flex align-center" style="height: 40px; padding: 0px 10px; gap: 4px">
              <v-icon style="font-size: 18px; color: #414458">
                mdi-phone
              </v-icon>
              <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                02-2088-2096
              </div>
            </div>
            <!-- 로그인 버튼 -->
            <div v-if="!$store.getters.isLoggedIn" data-testid="navbar-login-btn" @click="openLoginDialog()"
              class="default-transparent-btn-2 d-flex align-center"
              style="height: 40px; padding: 0px 16px"
            >
              <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                로그인
              </div>
            </div>
            <!-- 워크스페이스 버튼 -->
            <div v-else data-testid="navbar-workspace-btn" @click="goWorkSpace()"
              class="default-transparent-btn-2 d-flex align-center"
              style="height: 40px; padding: 0px 16px"
            >
              <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                워크스페이스
              </div>
            </div>
            <!-- 도입 문의하기 버튼 -->
            <div @click="clickContactBtn()"
              class="hover-icon-slide-btn-2px d-flex align-center justify-center"
              style="height: 40px; padding: 0px 12px 0px 16px; background-color: #162050; border-radius: 4px; gap: 4px; cursor: pointer"
            >
              <div style="font-size: 14px; font-weight: 600; line-height: 18px; color: #FFFFFF">
                도입 문의하기
              </div>
              <v-icon style="font-size: 16px; color: #FFFFFF">
                mdi-arrow-right
              </v-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- navbar - 공개 화면 (show-under-1024) -->
    <div v-if="fontReady && showPublicNavbar" data-testid="marketing-navbar-mobile" class="show-under-1024"
      style="position: sticky; z-index: 99; height: 60px; width: 100%; background-color: #FFFFFF; border-bottom: 1px solid #E8EAF2"
      :style="top_alert && isMarketingRoute ? {top: top_alert_height} : {top: '0px'}"
    >
      <div class="d-flex align-center justify-center" style="height: 100%">
        <div class="nav-bar d-flex align-center" style="height: 100%">
          <!-- 리컬럼 로고 -->
          <div @click="clickNavLogo($event); isShowHamburgerMenu = false" class="d-flex align-center" style="gap: 8px; cursor: pointer">
            <!-- logo -->
            <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain">
            <!-- title -->
            <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
              Re:Column
            </div>
          </div>
          <v-spacer></v-spacer>
          <!-- 워크스페이스 버튼 -->
          <div v-if="$store.getters.isLoggedIn" data-testid="mobile-navbar-workspace-btn" @click="goWorkSpace(); isShowHamburgerMenu = false"
            class="default-transparent-btn-2 d-flex align-center"
            style="height: 36px; padding: 0px 10px; margin-right: 4px"
          >
            <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
              워크스페이스
            </div>
          </div>
          <!-- 메뉴 버튼 (햄버거) -->
          <div @click="isShowHamburgerMenu = !isShowHamburgerMenu"
            class="default-icon-btn d-flex align-center justify-center"
            style="width: 44px; height: 44px"
          >
            <v-icon style="font-size: 28px">
              mdi-menu
            </v-icon>
          </div>
          <!-- 메뉴 -->
          <div v-if="isShowHamburgerMenu"
            style="position: fixed; left: 0px; width: 100vw; height: calc(100vh - 60px); background-color: #ffffff"
            :style="top_alert && isMarketingRoute ? {top: `calc(${top_alert_height} + 60px)`} : {top: '60px'}"
          >
            <!-- 메뉴 - 제품, 솔루션, 고객사례, (가격안내), 뉴스룸 -->
            <div class="d-flex flex-wrap align-start justify-start" style="gap: 40px 20px; width: 100%; padding: 20px 24px">
              <!-- 제품 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 12px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #ABAEC4">
                  제품
                </div>
                <!-- 리컬럼 소개서 -->
                <!-- <div @click="manualDownloadDialog = true; isShowHamburgerMenu = false" -->
                <div @click="clickShowManualDownloadDialogBtn"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em; color: #414458">
                    리컬럼 소개서
                  </div>
                </div>
                <!-- 워크플로우 -->
                <div @click="goProductPage('/product-workflow'); isShowHamburgerMenu = false"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductWorkflow' ? {color: '#687EFF'} : {color: '#414458'}"
                  >
                    워크플로우
                  </div>
                </div>
                <!-- 엑셀 서식 -->
                <div @click="goProductPage('/product-excel-format'); isShowHamburgerMenu = false"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductExcelFormat' ? {color: '#687EFF'} : {color: '#414458'}"
                  >
                    엑셀 서식
                  </div>
                </div>
                <!-- 시각화 대시보드 -->
                <div @click="goProductPage('/product-visualization'); isShowHamburgerMenu = false"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductVisualization' ? {color: '#687EFF'} : {color: '#414458'}"
                  >
                    시각화 대시보드
                  </div>
                </div>
                <!-- 데이터 검증 -->
                <div @click="goProductPage('/product-data-verify'); isShowHamburgerMenu = false"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductDataVerify' ? {color: '#687EFF'} : {color: '#414458'}"
                  >
                    데이터 검증
                  </div>
                </div>
                <!-- 문서 폼 -->
                <div @click="goProductPage('/product-document-form'); isShowHamburgerMenu = false"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductDocumentForm' ? {color: '#687EFF'} : {color: '#414458'}"
                  >
                    문서 폼
                  </div>
                </div>
                <!-- 이메일 유효성 검증 -->
                <div @click="goProductPage('/product-email-verify'); isShowHamburgerMenu = false"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductEmailVerify' ? {color: '#687EFF'} : {color: '#414458'}"
                  >
                    이메일 유효성 검증
                  </div>
                </div>
                <!-- 협업 기능 -->
                <div @click="goProductPage('/product-cooperation'); isShowHamburgerMenu = false"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductCooperation' ? {color: '#687EFF'} : {color: '#414458'}"
                  >
                    협업 기능
                  </div>
                </div>
              </div>
              <!-- 솔루션 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 12px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #ABAEC4">
                  솔루션
                </div>
                <!-- 이커머스 -->
                <div @click="goSolutionPage('/solution-ecommerce'); isShowHamburgerMenu = false"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'SolutionEcommerce' ? {color: '#687EFF'} : {color: '#414458'}"
                  >
                    이커머스
                  </div>
                </div>
                <!-- 유통 ∙ 물류 -->
                <div @click="goSolutionPage('/solution-logistics'); isShowHamburgerMenu = false"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'SolutionLogistics' ? {color: '#687EFF'} : {color: '#414458'}"
                  >
                    유통 ∙ 물류
                  </div>
                </div>
                <!-- 리테일 -->
                <div @click="goSolutionPage('/solution-retail'); isShowHamburgerMenu = false"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'SolutionRetail' ? {color: '#687EFF'} : {color: '#414458'}"
                  >
                    리테일
                  </div>
                </div>
              </div>
              <!-- 고객사례 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 12px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #ABAEC4">
                  고객사례
                </div>
                <!-- 고객사례 -->
                <div @click="goCustomerExample(); isShowHamburgerMenu = false"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'CustomerExample' || $route.name === 'CustomerExampleDetail' ? {color: '#687EFF'} : {color: '#414458'}"
                  >
                    고객사례
                  </div>
                </div>
              </div>
              <!-- 가격안내 -->
              <div v-if="false" style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 12px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #ABAEC4">
                  가격안내
                </div>
                <!-- 플랜안내 -->
                <div @click="goPlanGuide(); isShowHamburgerMenu = false"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'PlanGuide' ? {color: '#687EFF'} : {color: '#414458'}"
                  >
                    플랜안내
                  </div>
                </div>
                <!-- 바우처 -->
                <div @click="goVoucher(); isShowHamburgerMenu = false"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'Voucher' ? {color: '#687EFF'} : {color: '#414458'}"
                  >
                    바우처
                  </div>
                </div>
              </div>
              <!-- 뉴스룸 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 12px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #ABAEC4">
                  뉴스룸
                </div>
                <!-- 뉴스룸 -->
                <div @click="goNewsRoom(); isShowHamburgerMenu = false"
                  class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
                >
                  <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'NewsRoom' || $route.name === 'NewsRoomDetail' ? {color: '#687EFF'} : {color: '#414458'}"
                  >
                    뉴스룸
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 기한 만료 알림 alert - 로그인 후 -->
    <div v-if="isWorkspaceRoute && expireDateEndAlert && $store.getters.isLoggedIn" data-testid="workspace-license-alert" class="d-flex align-center" style="position: sticky; top: 0px; z-index: 99; width: 100%; height: 44px; background-color: #414458">
      <div style="width: calc(32px + 6px)"></div>
      <v-spacer></v-spacer>
      <v-icon style="font-size: 20px; color: #ffffff; margin-right: 4px">
        mdi-alert-circle-outline
      </v-icon>
      <!-- 무료체험 -->
      <div v-if="$store.state.user_info.plan === 'trial'" style="font-size: 14px; font-weight: 700; line-height: 20px; color: #ffffff; margin-right: 16px">
        리컬럼 무료체험이 종료되었습니다. 종료 일자로부터 7일간 읽기 전용 모드가 제공됩니다. (~{{ $store.state.user_info.paid_expire_date | paidExpireDateFilter }})
      </div>
      <!-- 엔터프라이즈 -->
      <div v-else style="font-size: 14px; font-weight: 700; line-height: 20px; color: #ffffff; margin-right: 16px">
        플랜 사용 기한이 만료되어 사용할 수 있는 기능이 제한됩니다. 조직의 결제 담당자 혹은 리컬럼 관리자에게 문의해 주세요.
      </div>
      <!-- 도입 문의하기 버튼 (무료체험) -->
      <div v-if="$store.state.user_info.plan === 'trial'" @click="contactDialog = true"
        class="default-transparent-btn-3 d-flex align-center" style="height: 30px; border-radius: 8px; border: 1px solid #ffffff; padding: 0px 12px; cursor: pointer"
      >
        <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #ffffff">
          도입 문의하기
        </div>
      </div>
      <!-- 관리자에게 문의 버튼 (엔터프라이즈) -->
      <div v-else @click="clickContactAdminBtn()"
        class="default-transparent-btn-3 d-flex align-center" style="height: 30px; border-radius: 8px; border: 1px solid #ffffff; padding: 0px 12px; cursor: pointer"
      >
        <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #ffffff">
          관리자에게 문의
        </div>
      </div>
      <v-spacer></v-spacer>
      <div @click="expireDateEndAlert = false"
        class="default-icon-btn-dark d-flex align-center justify-center"
        style="width: 32px; height: 32px; margin-right: 6px"
      >
        <v-icon style="font-size: 20px">
          mdi-close
        </v-icon>
      </div>
    </div>
    <!-- navbar - 로그인 후 -->
    <div v-if="fontReady && isWorkspaceRoute && $store.getters.isLoggedIn" data-testid="workspace-navbar"
      class="d-flex align-center"
      :class="expireDateEndAlert ? 'top-48' : 'top-0'"
      style="position: sticky; z-index: 99; min-height: 48px; width: 100%; min-width: 1536px; border-bottom: 1px solid #E8EAF2"
      :style="{padding: '0px 20px 0px 20px', backgroundColor: '#F8F9FB'}"
    >
      <!-- 리컬럼 로고 -->
      <div @click="clickNavLogo($event)" @mousedown.middle.prevent="middleClickNavLogo()"
        class="d-flex align-center" style="gap: 6.29px; cursor: pointer"
      >
        <!-- logo -->
        <img src="/assets/recolumn-logo.svg" style="width: 11.79px; height: 18.07px; object-fit: contain">
        <!-- title -->
        <div style="font-size: 18.86px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
          Re:Column
        </div>
      </div>
      <!-- 메뉴 (워크스페이스, 팀 관리, 내 휴지통, 리드 관리 (super_admin 메뉴), 감사 로그 (super_admin 메뉴), 삭제 대장 (super_admin 메뉴), 고객 데이터 삭제 (super_admin 메뉴), CS 문의, 알림, 도움말) -->
      <div v-if="workspaceShellRoute"
        class="d-flex align-center"
        style="position: absolute; left: 50%; transform: translateX(-50%); width: max-content; height: 100%; gap: 4px"
      >
        <!-- 워크스페이스 -->
        <div @click="clickMenu('WorkSpace', '/workspace', $event)"
          class="hover-bg-color-important d-flex align-center justify-center"
          style="--hover-bg-color: #EFF0F6; height: 40px; padding: 0px 12px; border-radius: 999px; cursor: pointer"
          :style="$route.name === 'WorkSpace' ? {backgroundColor: '#EFF0F6'} : {backgroundColor: 'transparent'}"
        >
          <div style="font-size: 14px; font-weight: 500; line-height: 20px"
            :style="$route.name === 'WorkSpace' ? {color: '#414458'} : {color: '#ABAEC4'}"
          >
            {{ $t('workspace') }}
          </div>
        </div>
        <!-- 팀 관리 -->
        <div @click="clickMenu('TeamManagement', '/team-management', $event)"
          class="hover-bg-color-important d-flex align-center justify-center"
          style="--hover-bg-color: #EFF0F6; height: 40px; padding: 0px 12px; border-radius: 999px; cursor: pointer"
          :style="$route.name === 'TeamManagement' ? {backgroundColor: '#EFF0F6'} : {backgroundColor: 'transparent'}"
        >
          <div style="font-size: 14px; font-weight: 500; line-height: 20px"
            :style="$route.name === 'TeamManagement' ? {color: '#414458'} : {color: '#ABAEC4'}"
          >
            {{ $t('teams') }}
          </div>
        </div>
        <!-- 내 휴지통 -->
        <div @click="clickMenu('TotalTrashCan', '/total-trash-can', $event)"
          class="hover-bg-color-important d-flex align-center justify-center"
          style="--hover-bg-color: #EFF0F6; height: 40px; padding: 0px 12px; border-radius: 999px; cursor: pointer"
          :style="$route.name === 'TotalTrashCan' ? {backgroundColor: '#EFF0F6'} : {backgroundColor: 'transparent'}"
        >
          <div style="font-size: 14px; font-weight: 500; line-height: 20px"
            :style="$route.name === 'TotalTrashCan' ? {color: '#414458'} : {color: '#ABAEC4'}"
          >
            {{ $t('deleted') }}
          </div>
        </div>
        <!-- 리드 관리 (super_admin 메뉴) -->
        <div v-if="$store.state.user_info.organization_permission === 'super_admin'" @click="clickMenu('AdminMenu', '/admin-menu', $event)"
          class="hover-bg-color-important d-flex align-center justify-center"
          style="--hover-bg-color: #EFF0F6; height: 40px; padding: 0px 12px; border-radius: 999px; cursor: pointer; position: relative"
          :style="$route.name === 'AdminMenu' ? {backgroundColor: '#EFF0F6'} : {backgroundColor: 'transparent'}"
        >
          <div style="font-size: 14px; font-weight: 500; line-height: 20px"
            :style="$route.name === 'AdminMenu' ? {color: '#414458'} : {color: '#ABAEC4'}"
          >
            <!-- {{ $t('admin') }} -->
            {{ $t('lead') }}
          </div>
          <SuperAdminBadge compact description="리드 관리 메뉴는 Super Admin에게만 표시됩니다." />
          <!-- 알림 뱃지 -->
          <div v-if="lead_badge_cnt" class="d-flex align-center justify-center"
            style="position: absolute; top: 4px; right: 4px; height: 12px; width: fit-content; border-radius: 999px; padding: 0px 3.5px; background-color: #FF3B30"
          >
            <div style="font-size: 10px; font-weight: 700; line-height: 12px; color: #ffffff">
              {{ lead_badge_cnt > 99 ? '99+' : lead_badge_cnt }}
            </div>
          </div>
        </div>
        <!-- 감사 로그 (super_admin 메뉴) -->
        <div v-if="$store.state.user_info.organization_permission === 'super_admin'" @click="clickMenu('AuditLogAdmin', '/audit-log', $event)"
          class="hover-bg-color-important d-flex align-center justify-center"
          style="--hover-bg-color: #EFF0F6; height: 40px; padding: 0px 12px; border-radius: 999px; cursor: pointer"
          :style="$route.name === 'AuditLogAdmin' ? {backgroundColor: '#EFF0F6'} : {backgroundColor: 'transparent'}"
        >
          <div style="font-size: 14px; font-weight: 500; line-height: 20px"
            :style="$route.name === 'AuditLogAdmin' ? {color: '#414458'} : {color: '#ABAEC4'}"
          >
            감사 로그
          </div>
          <SuperAdminBadge compact description="감사 로그 메뉴는 Super Admin에게만 표시됩니다." />
        </div>
        <!-- 삭제 대장 (super_admin 메뉴) -->
        <div v-if="$store.state.user_info.organization_permission === 'super_admin'" @click="clickMenu('DeletionReportAdmin', '/deletion-report', $event)"
          class="hover-bg-color-important d-flex align-center justify-center"
          style="--hover-bg-color: #EFF0F6; height: 40px; padding: 0px 12px; border-radius: 999px; cursor: pointer"
          :style="$route.name === 'DeletionReportAdmin' ? {backgroundColor: '#EFF0F6'} : {backgroundColor: 'transparent'}"
          data-testid="navbar-deletion-report-button"
        >
          <div style="font-size: 14px; font-weight: 500; line-height: 20px"
            :style="$route.name === 'DeletionReportAdmin' ? {color: '#414458'} : {color: '#ABAEC4'}"
          >
            삭제 대장
          </div>
          <SuperAdminBadge compact description="삭제 대장 메뉴는 Super Admin에게만 표시됩니다." />
        </div>
        <!-- 고객 데이터 삭제 (super_admin 메뉴) -->
        <div v-if="$store.state.user_info.organization_permission === 'super_admin'" @click="clickMenu('TenantCustomerDataDeletionAdmin', '/tenant-customer-data-deletion', $event)"
          class="hover-bg-color-important d-flex align-center justify-center"
          style="--hover-bg-color: #EFF0F6; height: 40px; padding: 0px 12px; border-radius: 999px; cursor: pointer"
          :style="$route.name === 'TenantCustomerDataDeletionAdmin' ? {backgroundColor: '#EFF0F6'} : {backgroundColor: 'transparent'}"
          data-testid="navbar-tenant-customer-data-deletion-button"
        >
          <div style="font-size: 14px; font-weight: 500; line-height: 20px"
            :style="$route.name === 'TenantCustomerDataDeletionAdmin' ? {color: '#414458'} : {color: '#ABAEC4'}"
          >
            고객 데이터 삭제
          </div>
          <SuperAdminBadge compact description="고객 데이터 삭제 메뉴는 Super Admin에게만 표시됩니다." />
        </div>
        <!-- CS 문의 -->
        <div @click="clickMenu('CSIssueList', '/cs-issues', $event)"
          class="hover-bg-color-important d-flex align-center justify-center"
          style="--hover-bg-color: #EFF0F6; height: 40px; padding: 0px 12px; border-radius: 999px; cursor: pointer"
          :style="['CSIssueList', 'CSIssueCreate', 'CSIssueDetail', 'CSIssueStaffRoleManagement'].includes($route.name) ? {backgroundColor: '#EFF0F6'} : {backgroundColor: 'transparent'}"
          data-testid="navbar-cs-issue-button"
        >
          <div style="font-size: 14px; font-weight: 500; line-height: 20px"
            :style="['CSIssueList', 'CSIssueCreate', 'CSIssueDetail', 'CSIssueStaffRoleManagement'].includes($route.name) ? {color: '#414458'} : {color: '#ABAEC4'}"
          >
            CS 문의
          </div>
        </div>
        <!-- 알림 -->
        <div @click="clickMenu('NotificationCenter', '/notifications', $event)"
          class="hover-bg-color-important d-flex align-center justify-center"
          style="--hover-bg-color: #EFF0F6; position: relative; height: 40px; padding: 0px 12px; border-radius: 999px; cursor: pointer"
          :style="notificationNavbarActive ? {backgroundColor: '#EFF0F6'} : {backgroundColor: 'transparent'}"
          data-testid="navbar-notification-button"
        >
          <div style="font-size: 14px; font-weight: 500; line-height: 20px"
            :style="notificationNavbarActive ? {color: '#414458'} : {color: '#ABAEC4'}"
          >
            알림
          </div>
          <span
            v-if="notificationUnreadCount > 0"
            class="notification-menu-badge"
            data-testid="navbar-notification-menu-badge"
          >
            {{ notificationUnreadCount > 99 ? '99+' : notificationUnreadCount }}
          </span>
        </div>
        <!-- 도움말 -->
        <div @click="clickMenu('Help', '/help', $event)"
          class="hover-bg-color-important d-flex align-center justify-center"
          style="--hover-bg-color: #EFF0F6; height: 40px; padding: 0px 12px; border-radius: 999px; cursor: pointer"
          :style="$route.name === 'Help' ? {backgroundColor: '#EFF0F6'} : {backgroundColor: 'transparent'}"
        >
          <div style="font-size: 14px; font-weight: 500; line-height: 20px"
            :style="$route.name === 'Help' ? {color: '#414458'} : {color: '#ABAEC4'}"
          >
            {{ $t('use-guide') }}
          </div>
        </div>
      </div>
      <!-- 프로젝트 dropdown (프로젝트 내부) -->
      <div v-if="mainRouter" class="d-flex align-center">
        <div style="height: 14px; width: 1px; background-color: #ABAEC4; margin: 0px 2px 0px 10px"></div>
        <v-menu v-model="projectDropdownMenu" offset-y bottom :close-on-content-click="false" max-width="320px">
          <!-- menu header -->
          <template v-slot:activator="{ on, value }">
            <div v-on="on" @click="value ? '' : getProjectListSimple()"
              class="hover-bg-color d-flex align-center" style="--hover-bg-color: #EFF0F6; height: 34px; padding: 0px 8px; border-radius: 8px; gap: 4px; cursor: pointer"
            >
              <!-- 로고 -->
              <div style="width: 24px; height: 24px; position: relative">
                <img style="width: 24px; height: 24px; object-fit: contain"
                  :src="getAuthorizedImageSrc($store.state.current_project.icon_url, `/assets/project_img/${$store.state.defaultPjtImg}.svg`)"
                >
                <!-- 즐겨찾기 표시 -->
                <!-- <img v-if="$store.state.current_project.favorite" src="/assets/star.svg" style="position: absolute; bottom: -6px; right: -6px; width: 20px; height: 20px; object-fit: contain"> -->
              </div>
              <!-- 프로젝트 이름 -->
              <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #414458">
                {{ $store.state.current_project.name }}
              </div>
              <!-- expand icon -->
              <v-icon :class="value ? 'up' : 'down'" style="font-size: 18px; color: #ABAEC4">
                mdi-chevron-down
              </v-icon>
            </div>
          </template>
          <!-- 프로젝트 검색창 및 목록 -->
          <v-card :style="getNavbarDropdownCardStyle('320px')">
            <!-- 프로젝트 검색창 -->
            <div style="position: sticky; top: 0px; z-index: 1; width: 100%; padding: 10px; background-color: #ffffff">
              <v-text-field v-if="!isSearchingPjt" ref="searchPjtNameInput" v-click-outside="clickOutsidePjtSearchInput"
                v-model="searchPjtNameInput" placeholder="프로젝트 검색하기"
                prepend-inner-icon="mdi-magnify" @click:prepend-inner="searchProject(searchPjtNameInput, 'drawer')"
                height="40px" background-color="#F8F9FB" color="#0D0E17" outlined dense hide-details
                class="search-input-40" style="border-radius: 8px; font-size: 14px"
                @keyup.enter="searchProject(searchPjtNameInput, 'drawer')"
              ></v-text-field>
              <div v-else @click="clickSearchedChip()"
                class="d-flex align-center"
                style="height: 40px; width: 100%; background-color: #F0F2FF; border-radius: 8px; padding-left: 14px; padding-right: 14px; cursor: pointer"
              >
                <v-icon style="font-size: 24px; color: #687EFF; margin-right: 4px">
                  mdi-magnify
                </v-icon>
                <div style="font-size: 14px; font-weight: 600; color: #687EFF">
                  {{ searchPjtNameInput }}
                </div>
                <v-spacer></v-spacer>
                <div @click="clearSearchInput('drawer')"
                  class="default-theme-icon-btn d-flex align-center justify-center"
                  style="width: 32px; height: 32px"
                >
                  <v-icon style="font-size: 20px">mdi-close</v-icon>
                </div>
              </div>
            </div>
            <!-- loading -->
            <div v-if="loadingProjectList" class="d-flex align-center justify-center py-4" style="height: 100%">
              <v-progress-circular
                :size="40"
                color="#687EFF"
                indeterminate
              ></v-progress-circular>
            </div>
            <!-- 목록 -->
            <div v-else class="d-flex flex-column" style="gap: 4px; padding: 0px 10px 10px 10px">
              <div v-for="project_item in projectList" :key="project_item.pk">
                <div @click="clickProjectItem(project_item)"
                  class="project-item d-flex align-center" style="height: 52px; width: 100%; border-radius: 8px; padding: 8px; cursor: pointer"
                  :style="project_item.pk === $store.state.current_project_pk ? {backgroundColor: '#EFF0F6'} : {}"
                >
                  <!-- 로고 -->
                  <div style="width: 36px; height: 36px; position: relative">
                    <img style="width: 36px; height: 36px; object-fit: contain; border-radius: 5.68px; border: 1px solid #E8EAF2"
                      :src="getAuthorizedImageSrc(project_item.icon_url, `/assets/project_img/${$store.state.defaultPjtImg}.svg`)"
                    >
                    <!-- 즐겨찾기 표시 -->
                    <img v-if="project_item.favorite" src="/assets/star.svg" style="position: absolute; bottom: -6px; right: -6px; width: 20px; height: 20px; object-fit: contain">
                  </div>
                  <!-- 프로젝트 이름 / 권한 및 일시 -->
                  <div class="d-flex flex-column align-start justify-space-between" style="width: calc(100% - 36px); height: 34px; margin-left: 8px">
                    <!-- 프로젝트 이름 -->
                    <div style="font-size: 14px; font-weight: 600; line-height: 18px; color: #101010; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                      {{ project_item.name }}
                    </div>
                    <!-- 권한 및 일시 -->
                    <div style="font-size: 12px; font-weight: 400; line-height: 14px; color: #8A8DA8">
                      {{ project_item.level | permissionFilter }} • 
                      {{ projectListOrder.includes('updated_at') ? project_item.updated_at : project_item.created_at | dateFormatFilter }}, 
                      {{ projectListOrder.includes('updated_at') ? project_item.updated_at : project_item.created_at | timeFormatFilter }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-menu>
      </div>
      <!-- 워크플로우 dropdown (워크플로우 설계창) -->
      <div v-if="$route.name === 'RpaMain' || $route.name === 'RpaMain3'" class="d-flex align-center" style="min-width: 0">
        <div style="height: 14px; width: 1px; background-color: #ABAEC4; margin: 0px 2px"></div>
        <v-menu v-model="workflowDropdownMenu" offset-y bottom :close-on-content-click="false" max-width="320px">
          <!-- menu header -->
          <template v-slot:activator="{ on, value }">
            <div v-on="on" data-testid="navbar-workflow-dropdown-activator" @click="value ? '' : getRpaList($store.state.current_project_pk)"
              class="hover-bg-color d-flex align-center" style="--hover-bg-color: #EFF0F6; height: 34px; width: 100%; min-width: 0; max-width: 320px; padding: 0px 8px; border-radius: 8px; gap: 4px; cursor: pointer"
            >
              <!-- 워크플로우 메뉴 아이콘 -->
              <div class="d-flex align-center justify-center" style="min-width: 24px; height: 24px">
                <img :src="`/assets/menu_icon/rpa2_off.svg`" style="width: 16px; height: 16px">
              </div>
              <!-- 워크플로우 제목 -->
              <div class="d-flex align-center" style="flex: 1; min-width: 0">
                <div style="flex: 1; min-width: 0; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                  {{ $store?.state?.current_rpa?.name }}
                </div>
                <v-icon v-if="$store?.state?.current_rpa?.is_hidden"
                  data-testid="navbar-current-workflow-hidden-icon"
                  style="flex-shrink: 0; font-size: 18px; color: #8A8DA8; margin-left: 4px"
                >
                  mdi-eye-off-outline
                </v-icon>
              </div>
              <!-- expand icon -->
              <v-icon :class="value ? 'up' : 'down'" style="flex-shrink: 0; font-size: 18px; color: #ABAEC4">
                mdi-chevron-down
              </v-icon>
            </div>
          </template>
          <!-- 워크플로우 검색창 및 목록 -->
          <v-card :style="getNavbarDropdownCardStyle('320px')">
            <!-- 워크플로우 검색창 -->
            <div style="position: sticky; top: 0px; z-index: 1; width: 100%; padding: 10px; background-color: #ffffff">
              <v-text-field v-if="!isSearchingWorkflow" ref="searchWorkflowNameInput" v-click-outside="clickOutsideWorkflowSearchInput"
                v-model="searchWorkflowNameInput" placeholder="워크플로우 검색하기"
                prepend-inner-icon="mdi-magnify" @click:prepend-inner="searchWorkflow(searchWorkflowNameInput)"
                height="40px" background-color="#F8F9FB" color="#0D0E17" outlined dense hide-details
                class="search-input-40" style="border-radius: 8px; font-size: 14px"
                @keyup.enter="searchWorkflow(searchWorkflowNameInput)"
              ></v-text-field>
              <div v-else @click="clickSearchedChip2()"
                class="d-flex align-center"
                style="height: 40px; width: 100%; background-color: #F0F2FF; border-radius: 8px; padding-left: 14px; padding-right: 14px; cursor: pointer"
              >
                <v-icon style="font-size: 24px; color: #687EFF; margin-right: 4px">
                  mdi-magnify
                </v-icon>
                <div style="font-size: 14px; font-weight: 600; color: #687EFF">
                  {{ searchWorkflowNameInput }}
                </div>
                <v-spacer></v-spacer>
                <div @click="clearSearchInput2()"
                  class="default-theme-icon-btn d-flex align-center justify-center"
                  style="width: 32px; height: 32px"
                >
                  <v-icon style="font-size: 20px">mdi-close</v-icon>
                </div>
              </div>
            </div>
            <!-- loading -->
            <div v-if="loadingWorkflowList" class="d-flex align-center justify-center py-4" style="height: 100%">
              <v-progress-circular
                :size="40"
                color="#687EFF"
                indeterminate
              ></v-progress-circular>
            </div>
            <!-- 목록 -->
            <div v-else class="d-flex flex-column" style="gap: 4px; padding: 0px 10px 10px 10px">
              <div v-for="workflow_item in visibleWorkflowList" :key="workflow_item.id">
                <div @click="clickWorkflowItem(workflow_item)"
                  :data-testid="`navbar-workflow-dropdown-item-${workflow_item.id}`"
                  class="d-flex align-center"
                  :class="
                    workflow_item.id === $store.state.current_rpa.id
                      ? 'navbar-workflow-dropdown-item-selected'
                      : workflow_item.is_hidden
                        ? 'navbar-workflow-dropdown-item-hidden'
                        : 'navbar-workflow-dropdown-item-default'
                  "
                  style="height: 52px; width: 100%; border-radius: 8px; padding: 8px; cursor: pointer"
                >
                  <!-- 워크플로우 이름 / 일시 및 실행횟수 -->
                  <div class="d-flex flex-column align-start justify-space-between" style="height: 34px; width: 100%; margin-left: 8px">
                    <!-- 워크플로우 이름 -->
                    <div class="d-flex align-center" style="width: 100%; min-width: 0">
                      <div style="flex: 1; min-width: 0; font-size: 14px; font-weight: 600; line-height: 18px; color: #101010; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                        {{ workflow_item.name }}
                      </div>
                      <v-icon v-if="workflow_item.is_hidden"
                        :data-testid="`navbar-workflow-dropdown-hidden-icon-${workflow_item.id}`"
                        style="flex-shrink: 0; font-size: 18px; color: #8A8DA8; margin-left: 4px"
                      >
                        mdi-eye-off-outline
                      </v-icon>
                    </div>
                    <!-- 일시 및 실행횟수 -->
                    <div style="font-size: 12px; font-weight: 400; line-height: 14px; color: #8A8DA8">
                      {{ workflow_item.created_at | dateFormatFilter }}, 
                      {{ workflow_item.created_at | timeFormatFilter }}
                        • 실행횟수 {{ workflow_item.cnt }}회
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-menu>
      </div>
      <!-- 인사이트 dropdown (인사이트) -->
      <div v-if="$route.name === 'Insight'" class="d-flex align-center">
        <div style="height: 14px; width: 1px; background-color: #ABAEC4; margin: 0px 2px"></div>
        <v-menu v-model="insightDropdownMenu" offset-y bottom :close-on-content-click="false" max-width="300px">
          <!-- menu header -->
          <template v-slot:activator="{ on, value }">
            <div v-on="on" @click="value ? '' : getInsightList()"
              class="hover-bg-color d-flex align-center" style="--hover-bg-color: #EFF0F6; height: 34px; padding: 0px 8px; border-radius: 8px; gap: 4px; cursor: pointer"
            >
              <!-- 인사이트/폴더 메뉴 아이콘 -->
              <div class="d-flex align-center justify-center" style="min-width: 24px; height: 24px">
                <v-icon v-if="$store.state.current_insight_folder" style="font-size: 16px; color: #162050">mdi-folder</v-icon>
                <img v-else :src="`/assets/menu_icon/insight_off.svg`" style="width: 16px; height: 16px">
              </div>
              <!-- 인사이트/폴더 제목 -->
              <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #414458">
                {{ $store.state.current_insight_folder ? $store.state.current_insight_folder.name : $store?.state?.current_insight?.name }}
              </div>
              <!-- expand icon -->
              <v-icon :class="value ? 'up' : 'down'" style="font-size: 18px; color: #ABAEC4">
                mdi-chevron-down
              </v-icon>
            </div>
          </template>
          <!-- 인사이트 검색창 및 목록 -->
          <v-card :style="getNavbarDropdownCardStyle('300px')">
            <!-- 인사이트 검색창 -->
            <div style="position: sticky; top: 0px; z-index: 1; width: 100%; padding: 10px; background-color: #ffffff">
              <v-text-field v-if="!isSearchingInsight" ref="searchInsightNameInput" v-click-outside="clickOutsideInsightSearchInput"
                v-model="searchInsightNameInput" placeholder="대시보드 이름 검색하기"
                prepend-inner-icon="mdi-magnify" @click:prepend-inner="searchInsight(searchInsightNameInput)"
                height="40px" background-color="#F8F9FB" color="#0D0E17" outlined dense hide-details
                class="search-input-40" style="border-radius: 8px; font-size: 14px"
                @keyup.enter="searchInsight(searchInsightNameInput)"
              ></v-text-field>
              <div v-else @click="clickSearchedChip3()"
                class="d-flex align-center"
                style="height: 40px; width: 100%; background-color: #F0F2FF; border-radius: 8px; padding-left: 14px; padding-right: 14px; cursor: pointer"
              >
                <v-icon style="font-size: 24px; color: #687EFF; margin-right: 4px">
                  mdi-magnify
                </v-icon>
                <div style="font-size: 14px; font-weight: 600; color: #687EFF">
                  {{ searchInsightNameInput }}
                </div>
                <v-spacer></v-spacer>
                <div @click="clearSearchInput3()"
                  class="default-theme-icon-btn d-flex align-center justify-center"
                  style="width: 32px; height: 32px"
                >
                  <v-icon style="font-size: 20px">mdi-close</v-icon>
                </div>
              </div>
            </div>
            <!-- loading -->
            <div v-if="isLoadingInsightList" class="d-flex align-center justify-center py-4" style="height: 100%">
              <v-progress-circular
                :size="40"
                color="#687EFF"
                indeterminate
              ></v-progress-circular>
            </div>
            <!-- 목록: 폴더 + 인사이트 -->
            <div v-else class="d-flex flex-column" style="gap: 8px; padding: 0px 10px 10px 10px">
              <!-- 폴더 -->
              <div v-for="folder_item in folderList" :key="'folder-' + folder_item.id"
                @click="clickFolderItem(folder_item)"
                class="hover-bg-color d-flex align-center"
                style="--hover-bg-color: #F8F9FB; height: 56px; padding: 0px 8px; gap: 10px; border-radius: 8px; cursor: pointer"
                :style="folder_item.id === $store.state.current_insight_folder?.id ? {backgroundColor: '#EFF0F6'} : {}"
              >
                <!-- 아이콘 박스 -->
                <div class="d-flex align-center justify-center"
                  style="min-width: 38px; width: 38px; height: 38px; border-radius: 8px; background-color: #F8F9FB; border: 1px solid #E8EAF2"
                >
                  <v-icon style="font-size: 20px; color: #162050">mdi-folder</v-icon>
                </div>
                <!-- 이름 / 부제 -->
                <div class="d-flex flex-column justify-center" style="gap: 2px; flex: 1; min-width: 0">
                  <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                    {{ folder_item.name }}
                  </div>
                  <div style="font-size: 13px; font-weight: 400; line-height: 17px; color: #8A8DA8; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                    {{ folder_item.updated_at | dateFormatFilter }}
                    {{ folder_item.updated_at | timeFormatFilter }}
                    | {{ folder_item.dashboard_cnt ?? 0 }}개 대시보드
                  </div>
                </div>
              </div>
              <!-- 인사이트 -->
              <div v-for="insight_item in insightList" :key="insight_item.id"
                @click="clickInsightItem(insight_item)"
                class="hover-bg-color d-flex align-center"
                style="--hover-bg-color: #F8F9FB; height: 56px; padding: 0px 8px; gap: 10px; border-radius: 8px; cursor: pointer"
                :style="insight_item.id === $store.state.current_insight?.id ? {backgroundColor: '#EFF0F6'} : {}"
              >
                <!-- 아이콘 박스 -->
                <div class="d-flex align-center justify-center"
                  style="min-width: 38px; width: 38px; height: 38px; border-radius: 8px; background-color: #F8F9FB; border: 1px solid #E8EAF2"
                >
                  <img :src="`/assets/menu_icon/insight_off.svg`" style="width: 20px; height: 20px">
                </div>
                <!-- 이름 / 부제 -->
                <div class="d-flex flex-column justify-center" style="gap: 2px; flex: 1; min-width: 0">
                  <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                    {{ insight_item.name }}
                  </div>
                  <div style="font-size: 13px; font-weight: 400; line-height: 17px; color: #8A8DA8; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                    {{ (insightListOrder.includes('updated_at') ? insight_item.updated_at : insight_item.created_at) | dateFormatFilter }}
                    {{ (insightListOrder.includes('updated_at') ? insight_item.updated_at : insight_item.created_at) | timeFormatFilter }}
                    | {{ insight_item.chart_cnt || 0 }}개 차트
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-menu>
      </div>
      <v-spacer></v-spacer>
      <!-- 프로젝트 전역 CS 문의 -->
      <v-tooltip v-if="mainRouter" bottom>
        <template v-slot:activator="{ on }">
          <button
            v-on="on"
            type="button"
            class="default-icon-btn d-flex align-center justify-center"
            style="width: 36px; height: 36px"
            data-testid="navbar-project-cs-issue-button"
            aria-label="CS 문의"
            @click="openProjectCSIssue"
          >
            <v-icon style="font-size: 19px">mdi-message-alert-outline</v-icon>
          </button>
        </template>
        <span>CS 문의</span>
      </v-tooltip>
      <!-- LLM 질의응답 버튼 -->
      <v-tooltip v-if="mainRouter && showLlmChatButton" bottom>
        <template v-slot:activator="{ on }">
          <div
            v-on="on"
            @click="clickLlmChatBtn()"
            class="default-icon-btn d-flex align-center justify-center"
            style="width: 36px; height: 36px; margin-left: 4px"
            :style="showLlmChatPanel ? { backgroundColor: '#EFF0F6' } : {}"
            data-testid="navbar-llm-chat-button"
            role="button"
            aria-label="AI 질의응답"
          >
            <img :src="showLlmChatPanel ? '/assets/llm_on.svg' : '/assets/llm_off.svg'" alt="" style="width: 20px; height: 20px">
          </div>
        </template>
        <span>AI 질의응답</span>
      </v-tooltip>
      <!-- 도움말(채널톡) 버튼, 공지(노티) 버튼 (프로젝트 내부) -->
      <div v-if="navbarActionRoute" class="d-flex align-center" style="gap: 4px; margin-left: 4px">
        <!-- 도움말(채널톡) 버튼 -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div
              v-on="on"
              class="channel-talk-btn-1 default-icon-btn d-flex align-center justify-center"
              style="width: 36px; height: 36px"
              data-testid="navbar-help-button"
              role="button"
              aria-label="도움말"
            >
              <img :src="`/assets/menu_icon/help_off.svg`" alt="" style="width: 20px; height: 20px">
            </div>
          </template>
          <span>도움말</span>
        </v-tooltip>
        <!-- 공지(노티) 버튼 -->
        <NotificationDropdown />
      </div>
      <!-- 대표 이미지(마이페이지) -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div
            v-on="on"
            data-testid="navbar-profile-btn"
            class="d-flex align-center justify-center"
            style="margin-left: 10px; cursor: pointer"
            role="button"
            aria-label="내 프로필"
            @click="showMypageDialog()"
          >
            <v-avatar :color="$store.state.user_info.personal_color ? `#${$store.state.user_info.personal_color}` : '#2F54EB'" size="32">
              <img v-if="$store.state.user_info.picture && $store.state.user_info.picture.length > 0" :src="$store.state.user_info.picture" referrerpolicy="no-referrer" alt="">
              <div v-else-if="$store.state.user_info.email" style="font-size: 18px; font-weight: 400; line-height: 20px; color: #FFFFFF">
                {{ $store.state.user_info.email[0] }}
              </div>
            </v-avatar>
          </div>
        </template>
        <span>내 프로필</span>
      </v-tooltip>
    </div>
    
    <!-- drawer, main -->
    <div
      key="app-main-content"
      data-testid="app-main-content"
      class="main-content d-flex"
      :class="{'notification-main-content': notificationViewportRoute}"
      :style="isWorkspaceRoute && $store.getters.isLoggedIn ? expireDateEndAlert ? {height: `calc(100vh - 48px - 44px)`} : {height: `calc(100vh - 48px)`} : {}"
    >
      <!-- drawer -->
      <div v-if="mainRouter"
        class="d-flex flex-column align-center"
        style="height: 100%; min-width: 70px; max-width: 70px; overflow: hidden; background-color: #F8F9FB; padding: 16px 5px 20px; gap: 16px"
      >
        <!-- 메뉴 -->
        <div v-for="(menu, menu_idx) in drawerItems.filter(v => v.parent_value !== 'group-custom').slice(0, drawerItemsCnt)" :key="menu_idx">
          <div @click="clickMenu(menu.routeName, menu.to, $event)" @mousedown.middle.prevent="middleClickMenu(menu.to)"
            class="menu-box d-flex flex-column align-center" style="width: 60px; height: 53px; cursor: pointer"
          >
            <!-- icon box -->
            <div class="menu-icon-box d-flex align-center justify-center" style="width: 36px; height: 36px; border-radius: 8px"
              :style="isDrawerMenuActive(menu) ? {backgroundColor: '#E8EAF2'} : {}"
            >
              <img
                v-if="isDrawerMenuActive(menu)"
                :src="getMenuIcon(menu.value, 'on')" style="width: 20px; height: 20px"
              ><!-- :src="`/assets/menu_icon/${menu.value}_on.svg`" style="width: 20px; height: 20px" -->
              <img v-else
                :src="getMenuIcon(menu.value, 'off')" style="width: 20px; height: 20px"
              ><!-- :src="`/assets/menu_icon/${menu.value}_off.svg`" style="width: 20px; height: 20px" -->
            </div>
            <!-- title -->
            <div style="font-size: 12px; font-weight: 500; line-height: 17px; letter-spacing: -0.02em; color: #162050">
              {{
                $i18n.locale === 'ko' ? menu.title : 
                $i18n.locale === 'en' ? menu.title_en : 
                menu.title
              }}
            </div>
          </div>
        </div>
        <!-- 더 보기 -->
        <div v-if="drawerItems.length > drawerItemsCnt">
          <v-menu offset-x right>
            <template v-slot:activator="{ on }">
              <div v-on="on" class="menu-box d-flex flex-column align-center" style="width: 60px; height: 53px; cursor: pointer">
                <!-- icon box -->
                <div class="menu-icon-box d-flex align-center justify-center" style="width: 36px; height: 36px; border-radius: 8px"
                  :style="drawerItems.slice(drawerItemsCnt).some(isDrawerMenuActive) || $route.name === 'Custom' ? {backgroundColor: '#E8EAF2'} : {}"
                >
                  <v-icon style="font-size: 20px; color: #162050">
                    mdi-dots-horizontal
                  </v-icon>
                </div>
                <!-- title -->
                <div style="font-size: 12px; font-weight: 500; line-height: 17px; letter-spacing: -0.02em; color: #162050">
                  {{ $t('more') }}
                </div>
              </div>
            </template>
            <v-card :style="getNavbarDropdownCardStyle('260px')">
              <div class="d-flex flex-column" style="width: 260px; padding: 8px; gap: 4px">
                <!-- 메뉴 -->
                <div v-for="(menu, menu_idx) in drawerItems.filter(v => v.parent_value !== 'group-custom').slice(drawerItemsCnt)" :key="menu_idx">
                  <div @click="clickMenu(menu.routeName, menu.to, $event)" @mousedown.middle.prevent="middleClickMenu(menu.to)"
                    class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 8px; gap: 12px; cursor: pointer"
                    :style="isDrawerMenuActive(menu) ? {backgroundColor: '#F8F9FB'} : {}"
                  >
                    <!-- icon box -->
                    <div class="d-flex align-center justify-center" style="width: 40px; height: 40px; border-radius: 8px; background-color: #EFF0F6">
                      <img :src="getMenuIcon(menu.value, 'on')" style="width: 20px; height: 20px">
                    </div>
                    <!-- title, sub -->
                    <div>
                      <!-- title -->
                      <div style="font-size: 14px; font-weight: 600; line-height: 20px; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 2px">
                        {{
                          $i18n.locale === 'ko' ? menu.title : 
                          $i18n.locale === 'en' ? menu.title_en : 
                          menu.title
                        }}
                      </div>
                      <!-- sub -->
                      <div style="font-size: 12px; font-weight: 400; line-height: 17px; letter-spacing: -0.02em; color: #414458">
                        {{
                          $i18n.locale === 'ko' ? menu.sub : 
                          $i18n.locale === 'en' ? menu.sub_en : 
                          menu.sub
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 커스텀 -->
                <div v-if="drawerItems.filter(v => v.parent_value === 'group-custom').length > 0"
                  @click="clickMenu('Custom', `/custom/${$store.state.current_project_pk}`, $event)"
                  @mousedown.middle.prevent="middleClickMenu(`/custom/${$store.state.current_project_pk}`)"
                  class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 8px; gap: 12px; cursor: pointer"
                  :style="$route.name === 'Custom' ? {backgroundColor: '#F8F9FB'} : {}"
                >
                  <!-- icon box -->
                  <div class="d-flex align-center justify-center" style="width: 40px; height: 40px; border-radius: 8px; background-color: #EFF0F6">
                    <img :src="`/assets/menu_icon/custom_on.svg`" style="width: 20px; height: 20px">
                  </div>
                  <!-- title, sub -->
                  <div>
                    <!-- title -->
                    <div style="font-size: 14px; font-weight: 600; line-height: 20px; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 2px">
                      {{ $t('custom') }}
                    </div>
                    <!-- sub -->
                    <div style="font-size: 12px; font-weight: 400; line-height: 17px; letter-spacing: -0.02em; color: #414458">
                      {{ $t('custom_sub') }}
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </v-menu>
        </div>
        <v-spacer></v-spacer>
        <!-- 휴지통 -->
        <div @click="clickMenu('ProjectTrashCan', `/project-trash-can/${$store.state.current_project_pk}`, $event)"
          @mousedown.middle.prevent="middleClickMenu(`/project-trash-can/${$store.state.current_project_pk}`)"
          class="menu-box d-flex flex-column align-center" style="width: 60px; height: 53px; cursor: pointer"
        >
          <!-- icon box -->
          <div class="menu-icon-box d-flex align-center justify-center" style="width: 36px; height: 36px; border-radius: 8px"
            :style="$route.name === 'ProjectTrashCan' ? {backgroundColor: '#E8EAF2'} : {}"
          >
            <img v-if="$route.name === 'ProjectTrashCan'"
              :src="`/assets/menu_icon/trashcan_on.svg`" style="width: 20px; height: 20px"
            >
            <img v-else
              :src="`/assets/menu_icon/trashcan_off.svg`" style="width: 20px; height: 20px"
            >
          </div>
          <!-- title -->
          <div style="font-size: 12px; font-weight: 500; line-height: 17px; letter-spacing: -0.03em; color: #162050">
            {{ $t('trash-can') }}
          </div>
        </div>
        <!-- 설정 -->
        <div @click="clickMenu('ProjectManagement', `/project-management/${$store.state.current_project_pk}`, $event)"
          @mousedown.middle.prevent="middleClickMenu(`/project-management/${$store.state.current_project_pk}`)"
          class="menu-box d-flex flex-column align-center" style="width: 60px; height: 53px; cursor: pointer"
        >
          <!-- icon box -->
          <div class="menu-icon-box d-flex align-center justify-center" style="width: 36px; height: 36px; border-radius: 8px"
            :style="$route.name === 'ProjectManagement' ? {backgroundColor: '#E8EAF2'} : {}"
          >
            <img v-if="$route.name === 'ProjectManagement'"
              :src="`/assets/menu_icon/setting_on.svg`" style="width: 20px; height: 20px"
            >
            <img v-else
              :src="`/assets/menu_icon/setting_off.svg`" style="width: 20px; height: 20px"
            >
          </div>
          <!-- title -->
          <div style="font-size: 12px; font-weight: 500; line-height: 17px; letter-spacing: -0.03em; color: #162050">
            {{ $t('settings') }}
          </div>
        </div>
      </div>
      <!-- main -->
      <v-main data-testid="app-route-view-main" style="height: 100%"
        :style="
          $route.meta.standaloneMarketing ? {overflow: 'visible'} :
          !isWorkspaceRoute ? {overflow: 'hidden'} :
          mainRouter ? 
          {minWidth: 'calc(1536px - 70px)', maxWidth: 'calc(100% - 70px)'} : 
          {minWidth: '1536px'}
        "
      >
        <router-view ref="routerView"
          v-if="!isWorkspaceRoute || $store.getters.isLoggedIn"
          :key="routeViewKey"
          class="router-view"
          :top_alert="top_alert"
          :top_alert_height="top_alert_height"
          :searchPjtNameInput="searchPjtNameInput"
          :drawerItems="drawerItems"
          @setMypageDialog="setMypageDialog"
          @clickDemoBtn="clickDemoBtn"
          @clickContactBtn="clickContactBtn"
          @clickShowManualDownloadDialogBtn="clickShowManualDownloadDialogBtn"
          @leadBadgeRefreshRequested="getProductInquiryUnprocessedCount"
        />
      </v-main>
    </div>

    <!-- footer -->
    <div v-if="showMarketingFooter" data-testid="marketing-footer" class="footer">
      <!-- show-over-1441 -->
      <div class="show-over-1441" style="width: 100%">
        <div class="d-flex align-center justify-center" style="width: 100%; padding: 56px 0px 64px; background-color: #EFF0F6">
          <div class="d-flex flex-column justify-space-between" style="width: 1100px; height: 100%">
            <!-- 상단 -->
            <div class="d-flex align-start justify-start" style="gap: 72px">
              <!-- 리컬럼 로고 -->
              <div class="d-flex align-center" style="gap: 8px">
                <!-- logo -->
                <img src="/assets/recolumn-logo-black.svg" style="width: 15px; height: 23px">
                <!-- title -->
                <div style="font-size: 24px; font-weight: 600; line-height: 100%; letter-spacing: -0.02em; color: #0D0E17">
                  Re:Column
                </div>
              </div>
              <!-- 메뉴 - 제품, 솔루션, 고객사례, (가격안내), 뉴스룸 -->
              <div class="d-flex flex-wrap align-start justify-start" style="gap: 40px 20px; width: 100%">
                <!-- 제품 -->
                <div style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    제품
                  </div>
                  <!-- 워크플로우 -->
                  <div @click="goProductPage('/product-workflow')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductWorkflow' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      워크플로우
                    </div>
                  </div>
                  <!-- 엑셀 서식 -->
                  <div @click="goProductPage('/product-excel-format')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductExcelFormat' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      엑셀 서식
                    </div>
                  </div>
                  <!-- 시각화 대시보드 -->
                  <div @click="goProductPage('/product-visualization')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductVisualization' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      시각화 대시보드
                    </div>
                  </div>
                  <!-- 데이터 검증 -->
                  <div @click="goProductPage('/product-data-verify')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductDataVerify' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      데이터 검증
                    </div>
                  </div>
                  <!-- 문서 폼 -->
                  <div @click="goProductPage('/product-document-form')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductDocumentForm' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      문서 폼
                    </div>
                  </div>
                  <!-- 이메일 유효성 검증 -->
                  <div @click="goProductPage('/product-email-verify')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductEmailVerify' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      이메일 유효성 검증
                    </div>
                  </div>
                  <!-- 협업 기능 -->
                  <div @click="goProductPage('/product-cooperation')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductCooperation' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      협업 기능
                    </div>
                  </div>
                </div>
                <!-- 솔루션 -->
                <div style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    솔루션
                  </div>
                  <!-- 이커머스 -->
                  <div @click="goSolutionPage('/solution-ecommerce')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'SolutionEcommerce' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      이커머스
                    </div>
                  </div>
                  <!-- 유통 ∙ 물류 -->
                  <div @click="goSolutionPage('/solution-logistics')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'SolutionLogistics' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      유통 ∙ 물류
                    </div>
                  </div>
                </div>
                <!-- 고객사례 -->
                <div style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    고객사례
                  </div>
                  <!-- 고객사례 -->
                  <div @click="goCustomerExample()"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'CustomerExample' || $route.name === 'CustomerExampleDetail' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      고객사례
                    </div>
                  </div>
                </div>
                <!-- 가격안내 -->
                <div v-if="false" style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    가격안내
                  </div>
                  <!-- 플랜안내 -->
                  <div @click="goPlanGuide()"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'PlanGuide' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      플랜안내
                    </div>
                  </div>
                  <!-- 바우처 -->
                  <div @click="goVoucher()"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'Voucher' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      바우처
                    </div>
                  </div>
                </div>
                <!-- 뉴스룸 -->
                <div style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    뉴스룸
                  </div>
                  <!-- 뉴스룸 -->
                  <div @click="goNewsRoom()"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'NewsRoom' || $route.name === 'NewsRoomDetail' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      뉴스룸
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- divider -->
            <div style="width: 100%; height: 1px; margin: 40px 0px; background-color: #FFFFFF4D"></div>
            <!-- 하단 -->
            <div style="position: relative">
              <!-- (주)코그콤 -->
              <div style="font-weight: 600; font-size: 16px; line-height: 145%; color: #0D0E17; margin-bottom: 10px">
                (주)코그콤
              </div>
              <!-- 정보1 -->
              <div class="d-flex align-center" style="margin-bottom: 4px">
                <!-- 대표 정치훈 -->
                <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  대표 정치훈
                </div>
                <!-- divider -->
                <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
                <!-- 전화 02-2088-2096 -->
                <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  전화 02-2088-2096
                </div>
                <!-- divider -->
                <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
                <!-- 메일 contact@cogcom.kr -->
                <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  메일 contact@cogcom.kr
                </div>
                <!-- divider -->
                <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
                <!-- 주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호 -->
                <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호
                </div>
              </div>
              <!-- 정보2 -->
              <div class="d-flex align-center">
                <!-- 사업자등록번호 378-86-01944 -->
                <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  사업자등록번호 378-86-01944
                </div>
                <!-- divider -->
                <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
                <!-- 통신판매업 제2024-서울광진-1178호 -->
                <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  통신판매업 제2024-서울광진-1178호
                </div>
                <!-- divider -->
                <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
                <!-- 이용약관 -->
                <div @click="goTermsOfUse()" style="font-size: 13px; font-weight: 600; line-height: 145%; color: #0D0E17CC; cursor: pointer">
                  이용약관
                </div>
                <!-- divider -->
                <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
                <!-- 개인정보처리방침 -->
                <div @click="goPrivacyPolicy()" style="font-size: 13px; font-weight: 600; line-height: 145%; color: #0D0E17CC; cursor: pointer">
                  개인정보처리방침
                </div>
              </div>
              <!-- 우측 하단 버튼 (코그콤 링크드인, 코그콤 홈페이지) -->
              <div class="d-flex align-center" style="position: absolute; bottom: 6px; right: 0px; gap: 6px">
                <!-- 코그콤 링크드인 버튼 -->
                <div @click="goLinkedInPage()" class="hover-bg-color-0D0E170F d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                  <img src="/assets/linked-in-logo-black.svg" style="width: 20px; height: 20px">
                </div>
                <!-- 코그콤 홈페이지 버튼 -->
                <div @click="goHomepage()" class="hover-bg-color-0D0E170F d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                  <v-icon style="font-size: 24px; color: #0D0E1799">
                    mdi-web
                  </v-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-1025-under-1440 -->
      <div class="show-over-1025-under-1440" style="width: 100%">
        <div class="d-flex align-center justify-center" style="width: 100%; padding: 56px 0px 64px; background-color: #EFF0F6">
          <div class="d-flex flex-column justify-space-between" style="width: calc(100% - calc(50px * 2)); height: 100%">
            <!-- 상단 -->
            <div class="d-flex align-start justify-start" style="gap: 72px">
              <!-- 리컬럼 로고 -->
              <div class="d-flex align-center" style="gap: 8px">
                <!-- logo -->
                <img src="/assets/recolumn-logo-black.svg" style="width: 15px; height: 23px">
                <!-- title -->
                <div style="font-size: 24px; font-weight: 600; line-height: 100%; letter-spacing: -0.02em; color: #0D0E17">
                  Re:Column
                </div>
              </div>
              <!-- 메뉴 - 제품, 솔루션, 고객사례, (가격안내), 뉴스룸 -->
              <div class="d-flex flex-wrap align-start justify-start" style="gap: 40px 20px; width: 100%">
                <!-- 제품 -->
                <div style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    제품
                  </div>
                  <!-- 워크플로우 -->
                  <div @click="goProductPage('/product-workflow')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductWorkflow' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      워크플로우
                    </div>
                  </div>
                  <!-- 엑셀 서식 -->
                  <div @click="goProductPage('/product-excel-format')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductExcelFormat' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      엑셀 서식
                    </div>
                  </div>
                  <!-- 시각화 대시보드 -->
                  <div @click="goProductPage('/product-visualization')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductVisualization' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      시각화 대시보드
                    </div>
                  </div>
                  <!-- 데이터 검증 -->
                  <div @click="goProductPage('/product-data-verify')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductDataVerify' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      데이터 검증
                    </div>
                  </div>
                  <!-- 문서 폼 -->
                  <div @click="goProductPage('/product-document-form')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductDocumentForm' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      문서 폼
                    </div>
                  </div>
                  <!-- 이메일 유효성 검증 -->
                  <div @click="goProductPage('/product-email-verify')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductEmailVerify' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      이메일 유효성 검증
                    </div>
                  </div>
                  <!-- 협업 기능 -->
                  <div @click="goProductPage('/product-cooperation')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductCooperation' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      협업 기능
                    </div>
                  </div>
                </div>
                <!-- 솔루션 -->
                <div style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    솔루션
                  </div>
                  <!-- 이커머스 -->
                  <div @click="goSolutionPage('/solution-ecommerce')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'SolutionEcommerce' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      이커머스
                    </div>
                  </div>
                  <!-- 유통 ∙ 물류 -->
                  <div @click="goSolutionPage('/solution-logistics')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'SolutionLogistics' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      유통 ∙ 물류
                    </div>
                  </div>
                </div>
                <!-- 고객사례 -->
                <div style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    고객사례
                  </div>
                  <!-- 고객사례 -->
                  <div @click="goCustomerExample()"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'CustomerExample' || $route.name === 'CustomerExampleDetail' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      고객사례
                    </div>
                  </div>
                </div>
                <!-- 가격안내 -->
                <div v-if="false" style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    가격안내
                  </div>
                  <!-- 플랜안내 -->
                  <div @click="goPlanGuide()"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'PlanGuide' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      플랜안내
                    </div>
                  </div>
                  <!-- 바우처 -->
                  <div @click="goVoucher()"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'Voucher' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      바우처
                    </div>
                  </div>
                </div>
                <!-- 뉴스룸 -->
                <div style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    뉴스룸
                  </div>
                  <!-- 뉴스룸 -->
                  <div @click="goNewsRoom()"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'NewsRoom' || $route.name === 'NewsRoomDetail' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      뉴스룸
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- divider -->
            <div style="width: 100%; height: 1px; margin: 40px 0px; background-color: #FFFFFF4D"></div>
            <!-- 하단 -->
            <div style="position: relative">
              <!-- (주)코그콤 -->
              <div style="font-weight: 600; font-size: 16px; line-height: 145%; color: #0D0E17; margin-bottom: 10px">
                (주)코그콤
              </div>
              <!-- 정보1 -->
              <div class="d-flex align-center" style="margin-bottom: 4px">
                <!-- 대표 정치훈 -->
                <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  대표 정치훈
                </div>
                <!-- divider -->
                <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
                <!-- 전화 02-2088-2096 -->
                <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  전화 02-2088-2096
                </div>
                <!-- divider -->
                <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
                <!-- 메일 contact@cogcom.kr -->
                <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  메일 contact@cogcom.kr
                </div>
                <!-- divider -->
                <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
                <!-- 주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호 -->
                <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호
                </div>
              </div>
              <!-- 정보2 -->
              <div class="d-flex align-center">
                <!-- 사업자등록번호 378-86-01944 -->
                <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  사업자등록번호 378-86-01944
                </div>
                <!-- divider -->
                <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
                <!-- 통신판매업 제2024-서울광진-1178호 -->
                <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  통신판매업 제2024-서울광진-1178호
                </div>
                <!-- divider -->
                <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
                <!-- 이용약관 -->
                <div @click="goTermsOfUse()" style="font-size: 13px; font-weight: 600; line-height: 145%; color: #0D0E17CC; cursor: pointer">
                  이용약관
                </div>
                <!-- divider -->
                <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
                <!-- 개인정보처리방침 -->
                <div @click="goPrivacyPolicy()" style="font-size: 13px; font-weight: 600; line-height: 145%; color: #0D0E17CC; cursor: pointer">
                  개인정보처리방침
                </div>
              </div>
              <!-- 우측 하단 버튼 (코그콤 링크드인, 코그콤 홈페이지) -->
              <div class="d-flex align-center" style="position: absolute; bottom: 6px; right: 0px; gap: 6px">
                <!-- 코그콤 링크드인 버튼 -->
                <div @click="goLinkedInPage()" class="hover-bg-color-0D0E170F d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                  <img src="/assets/linked-in-logo-black.svg" style="width: 20px; height: 20px">
                </div>
                <!-- 코그콤 홈페이지 버튼 -->
                <div @click="goHomepage()" class="hover-bg-color-0D0E170F d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                  <v-icon style="font-size: 24px; color: #0D0E1799">
                    mdi-web
                  </v-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- show-over-320-under-1024 -->
      <div class="show-over-320-under-1024" style="width: 100%">
        <div class="d-flex align-center justify-center" style="width: 100%; padding: 56px 0px 64px; background-color: #EFF0F6">
          <div class="d-flex flex-column justify-space-between" style="width: calc(100% - calc(24px * 2))">
            <!-- 상단 -->
            <div class="d-flex flex-column align-start justify-start" style="gap: 56px">
              <!-- 리컬럼 로고 -->
              <div class="d-flex align-center" style="gap: 8px">
                <!-- logo -->
                <img src="/assets/recolumn-logo-black.svg" style="width: 15px; height: 23px">
                <!-- title -->
                <div style="font-size: 24px; font-weight: 600; line-height: 100%; letter-spacing: -0.02em; color: #0D0E17">
                  Re:Column
                </div>
              </div>
              <!-- 메뉴 - 제품, 솔루션, 고객사례, (가격안내), 뉴스룸 -->
              <div class="d-flex flex-wrap align-start justify-start" style="gap: 40px 20px; width: 100%">
                <!-- 제품 -->
                <div style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    제품
                  </div>
                  <!-- 워크플로우 -->
                  <div @click="goProductPage('/product-workflow')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductWorkflow' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      워크플로우
                    </div>
                  </div>
                  <!-- 엑셀 서식 -->
                  <div @click="goProductPage('/product-excel-format')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductExcelFormat' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      엑셀 서식
                    </div>
                  </div>
                  <!-- 시각화 대시보드 -->
                  <div @click="goProductPage('/product-visualization')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductVisualization' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      시각화 대시보드
                    </div>
                  </div>
                  <!-- 데이터 검증 -->
                  <div @click="goProductPage('/product-data-verify')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductDataVerify' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      데이터 검증
                    </div>
                  </div>
                  <!-- 문서 폼 -->
                  <div @click="goProductPage('/product-document-form')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductDocumentForm' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      문서 폼
                    </div>
                  </div>
                  <!-- 이메일 유효성 검증 -->
                  <div @click="goProductPage('/product-email-verify')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductEmailVerify' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      이메일 유효성 검증
                    </div>
                  </div>
                  <!-- 협업 기능 -->
                  <div @click="goProductPage('/product-cooperation')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'ProductCooperation' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      협업 기능
                    </div>
                  </div>
                </div>
                <!-- 솔루션 -->
                <div style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    솔루션
                  </div>
                  <!-- 이커머스 -->
                  <div @click="goSolutionPage('/solution-ecommerce')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'SolutionEcommerce' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      이커머스
                    </div>
                  </div>
                  <!-- 유통 ∙ 물류 -->
                  <div @click="goSolutionPage('/solution-logistics')"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'SolutionLogistics' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      유통 ∙ 물류
                    </div>
                  </div>
                </div>
                <!-- 고객사례 -->
                <div style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    고객사례
                  </div>
                  <!-- 고객사례 -->
                  <div @click="goCustomerExample()"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'CustomerExample' || $route.name === 'CustomerExampleDetail' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      고객사례
                    </div>
                  </div>
                </div>
                <!-- 가격안내 -->
                <div v-if="false" style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    가격안내
                  </div>
                  <!-- 플랜안내 -->
                  <div @click="goPlanGuide()"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'PlanGuide' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      플랜안내
                    </div>
                  </div>
                  <!-- 바우처 -->
                  <div @click="goVoucher()"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'Voucher' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      바우처
                    </div>
                  </div>
                </div>
                <!-- 뉴스룸 -->
                <div style="min-width: 120px">
                  <!-- title -->
                  <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                    뉴스룸
                  </div>
                  <!-- 뉴스룸 -->
                  <div @click="goNewsRoom()"
                    class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                  >
                    <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                      :style="$route.name === 'NewsRoom' || $route.name === 'NewsRoomDetail' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                    >
                      뉴스룸
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- divider -->
            <div style="width: 100%; height: 1px; margin: 40px 0px; background-color: #FFFFFF4D"></div>
            <!-- 하단 -->
            <div>
              <!-- (주)코그콤 -->
              <div style="font-weight: 600; font-size: 16px; line-height: 145%; color: #0D0E17; margin-bottom: 10px">
                (주)코그콤
              </div>
              <!-- 정보 -->
              <div style="margin-bottom: 16px">
                <!-- 대표 정치훈 -->
                <span style="word-break: keep-all; font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  대표 정치훈
                </span>
                <!-- divider -->
                <div style="display: inline-block; height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 1px -2px 0px"></div>
                <!-- 전화 02-2088-2096 -->
                <span style="word-break: keep-all; font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  전화 02-2088-2096
                </span>
                <!-- divider -->
                <div style="display: inline-block; height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 1px -2px 0px"></div>
                <!-- 메일 contact@cogcom.kr -->
                <span style="word-break: keep-all; font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  메일 contact@cogcom.kr
                </span>
                <!-- divider -->
                <div style="display: inline-block; height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 1px -2px 0px"></div>
                <!-- 주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호 -->
                <span style="word-break: keep-all; font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호
                </span>
                <!-- divider -->
                <div style="display: inline-block; height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 1px -2px 0px"></div>
                <!-- 사업자등록번호 378-86-01944 -->
                <span style="word-break: keep-all; font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  사업자등록번호 378-86-01944
                </span>
                <!-- divider -->
                <div style="display: inline-block; height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 1px -2px 0px"></div>
                <!-- 통신판매업 제2024-서울광진-1178호 -->
                <span style="word-break: keep-all; font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                  통신판매업 제2024-서울광진-1178호
                </span>
                <!-- divider -->
                <div style="display: inline-block; height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 1px -2px 0px"></div>
                <!-- 이용약관 -->
                <span @click="goTermsOfUse()" style="word-break: keep-all; font-size: 13px; font-weight: 600; line-height: 145%; color: #0D0E17CC; cursor: pointer">
                  이용약관
                </span>
                <!-- divider -->
                <div style="display: inline-block; height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 1px -2px 0px"></div>
                <!-- 개인정보처리방침 -->
                <span @click="goPrivacyPolicy()" style="word-break: keep-all; font-size: 13px; font-weight: 600; line-height: 145%; color: #0D0E17CC; cursor: pointer">
                  개인정보처리방침
                </span>
              </div>
              <!-- 하단 버튼 (코그콤 링크드인, 코그콤 홈페이지) -->
              <div class="d-flex align-center" style="gap: 6px">
                <!-- 코그콤 링크드인 버튼 -->
                <div @click="goLinkedInPage()" class="hover-bg-color-0D0E170F d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                  <img src="/assets/linked-in-logo-black.svg" style="width: 20px; height: 20px">
                </div>
                <!-- 코그콤 홈페이지 버튼 -->
                <div @click="goHomepage()" class="hover-bg-color-0D0E170F d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                  <v-icon style="font-size: 24px; color: #0D0E1799">
                    mdi-web
                  </v-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- LLM 챗봇 -->
    <LlmChatFloatingPanel
      v-if="isWorkspaceRoute && $store.getters.isLoggedIn && showLlmChatPanel"
      data-testid="workspace-llm-panel"
      :messages="currentLlmChatMessages"
      :loading="isSendingLlmChat"
      :conversation-list="llmConversationList"
      :selected-conversation="selectedLlmConversation"
      @send="sendLlmChatMessage"
      @close="closeLlmChatPanel"
      @select-conversation="selectLlmConversation"
      @delete-conversation="deleteLlmConversation"
      @start-new-conversation="startNewLlmConversation"
    />

    <!-- 기한 만료 알림 dialog (n일 이내) -->
    <v-dialog v-if="isWorkspaceRoute" v-model="expireDateEndDialog" max-width="440px">
      <v-card style="border-radius: 16px; position: relative">
        <!-- 취소 버튼 -->
        <div @click="expireDateEndDialog = false"
          class="default-icon-btn d-flex align-center justify-center"
          style="position: absolute; top: 14px; right: 14px; width: 32px; height: 32px"
        >
          <v-icon style="font-size: 24px; color: #8A8DA8">
            mdi-close
          </v-icon>
        </div>
        <div class="d-flex flex-column align-center" style="padding: 40px">
          <!-- 리컬럼 로고 -->
          <div class="d-flex align-center" style="margin-bottom: 24px">
            <!-- logo -->
            <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
            <!-- title -->
            <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
              Re:Column
            </div>
          </div>
          <!-- text -->
          <div style="text-align: center; font-size: 27px; font-weight: 700; line-height: 38px; color: #414458; margin-bottom: 24px">
            무료체험이 종료되었습니다.
          </div>
          <!-- sub -->
          <div style="text-align: center; font-size: 14px; font-weight: 400; line-height: 20px; color: #8A8DA8; margin-bottom: 32px">
            종료 일자로부터 7일간 읽기 전용 모드가 제공됩니다.
            <br>
            지금 정식 도입하면 리컬럼의 모든 기능을 사용하실 수 있습니다.
          </div>
          <!-- 도입 문의하기 버튼 -->
          <div @click="expireDateEndDialog = false; contactDialog = true"
            class="default-gradient-theme-btn d-flex align-center justify-center"
            style="height: 56px; width: 100%"
          >
            <div style="font-size: 18px; font-weight: 700; line-height: 22px; color: #ffffff">
              도입 문의하기
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- 기한 만료 알림 dialog (n일 이후) -->
    <v-dialog v-if="isWorkspaceRoute" v-model="$store.state.expireDateEndDialog" max-width="440px">
      <v-card style="border-radius: 16px; position: relative">
        <!-- 취소 버튼 -->
        <div @click="$store.state.expireDateEndDialog = false"
          class="default-icon-btn d-flex align-center justify-center"
          style="position: absolute; top: 14px; right: 14px; width: 32px; height: 32px"
        >
          <v-icon style="font-size: 24px; color: #8A8DA8">
            mdi-close
          </v-icon>
        </div>
        <div class="d-flex flex-column align-center" style="padding: 40px">
          <!-- 리컬럼 로고 -->
          <div class="d-flex align-center" style="margin-bottom: 24px">
            <!-- logo -->
            <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
            <!-- title -->
            <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
              Re:Column
            </div>
          </div>
          <!-- text -->
          <div style="text-align: center; font-size: 27px; font-weight: 700; line-height: 38px; color: #414458; margin-bottom: 24px">
            무료체험이 종료되었습니다.
          </div>
          <!-- sub -->
          <div style="text-align: center; font-size: 14px; font-weight: 400; line-height: 20px; color: #8A8DA8; margin-bottom: 32px">
            무료체험 및 읽기 전용 모드 제공 기간이 종료되었습니다.
            <br>
            지금 정식 도입하면 계정을 복구하고 계속 사용하실 수 있습니다.
          </div>
          <!-- 도입 문의하기 버튼 -->
          <div @click="$store.state.expireDateEndDialog = false; contactDialog = true"
            class="default-gradient-theme-btn d-flex align-center justify-center"
            style="height: 56px; width: 100%"
          >
            <div style="font-size: 18px; font-weight: 700; line-height: 22px; color: #ffffff">
              도입 문의하기
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!-- 문의하기 dialog (web) -->
    <!-- v-if="window_innerWidth > 440" -->
    <v-dialog v-model="contactDialog" max-width="420px">
      <v-card style="border-radius: 16px; padding: 24px 30px; position: relative">
        <!-- 취소 버튼 -->
        <div @click="contactDialog = false"
          class="default-icon-btn d-flex align-center justify-center"
          style="position: absolute; top: 8px; right: 8px; width: 40px; height: 40px"
        >
          <v-icon style="font-size: 20px; color: #8A8DA8">
            mdi-close
          </v-icon>
        </div>
        <!-- title -->
        <div style="font-weight: 700; font-size: 18px; line-height: 24px; color: #0D0E17; margin-bottom: 4px">
          문의하기
        </div>
        <!-- sub -->
        <div style="font-weight: 400; font-size: 14px; line-height: 20px; color: #414458; margin-bottom: 24px">
          궁금한 점을 편하게 물어보실 수 있도록 연락드립니다.
        </div>
        <!-- 문의 내용 title -->
        <div style="padding-left: 2px; font-weight: 400; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          문의 내용
        </div>
        <!-- 문의 내용 입력창 -->
        <div style="height: 90px; width: 100%; border-radius: 8px; border: 1px solid #E8EAF2; background-color: #ffffff; padding: 12px 16px; margin-bottom: 16px">
          <textarea v-model="contactDialog_inquiryInput" ref="contactDialog_inquiryInput" type="text" placeholder="우리 회사의 보고서 제작 프로세스를 세팅하려면 대략 며칠이 걸리는지 궁금합니다."
            class="input-area focus-hide-placeholder-input" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 140%; color: #414458"
          ></textarea>
        </div>
        <!-- 원하시는 답변 경로 * title -->
        <div style="padding-left: 2px; font-weight: 400; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          원하시는 답변 경로 <span style="color: #687EFF">*</span>
        </div>
        <!-- 원하시는 답변 경로 선택창 -->
        <div style="overflow: hidden auto; border-radius: 8px; border: 1px solid #E8EAF2; background-color: #ffffff; padding: 4px; margin-bottom: 16px">
          <div v-for="item in contactDialog_answerPath_optionList" :key="item.value">
            <div class="hover-bg-color d-flex flex-column" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; cursor: pointer; overflow: hidden"
              :style="contactDialog_answerPath === item.value ? {backgroundColor: '#F0F2FF'} : {}"
              @click="contactDialog_answerPath = item.value"
            >
              <!-- radio btn, text -->
              <div class="d-flex align-center" style="width: 100%; height: 40px">
                <!-- radio btn -->
                <div class="checkbox-btn d-flex align-center justify-center" style="width: 40px; height: 40px">
                  <v-icon v-if="contactDialog_answerPath === item.value" style="font-size: 20px; color: #687EFF">
                    mdi-radiobox-marked
                  </v-icon>
                  <v-icon v-else style="font-size: 20px; color: #D8DAE9">
                    mdi-radiobox-blank
                  </v-icon>
                </div>
                <!-- text -->
                <div style="font-size: 14px; line-height: 18px"
                  :style="contactDialog_answerPath === item.value ? {fontWeight: 600, color: '#687EFF'} : {fontWeight: 500, color: '#414458'}"
                >
                  {{ item.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 통화 가능한 시간 * title - 원하시는 답변 경로 === 전화 (contactDialog_answerPath === '전화') -->
        <div v-if="contactDialog_answerPath === '전화'" style="padding-left: 2px; font-weight: 400; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          통화 가능한 시간 <span style="color: #687EFF">*</span>
        </div>
        <!-- 통화 가능한 시간 입력창 - 원하시는 답변 경로 === 전화 (contactDialog_answerPath === '전화') -->
        <div v-if="contactDialog_answerPath === '전화'" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
          <input v-model="contactDialog_ableTimeInput" ref="contactDialog_ableTimeInput" type="text" placeholder="내일 오전 11시~오후 1시 사이에 가능합니다."
            class="input-area focus-hide-placeholder-input" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
          >
        </div>
        <!-- 연락처 title -->
        <div style="padding-left: 2px; font-weight: 400; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          연락처 <span style="color: #687EFF">*</span>
        </div>
        <!-- 연락처 입력창 -->
        <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 4px">
          <input v-model="contactDialog_contactInput" ref="contactDialog_contactInput" type="text"
            :placeholder="contactDialog_answerPath === '전화' ? '010-1234-5678' : 'contact@cogcom.kr'"
            class="input-area focus-hide-placeholder-input" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
          >
        </div>
        <!-- 개인정보처리방침에 동의합니다. -->
        <div class="d-flex align-center" style="width: 100%; margin-bottom: 12px; transform: translateX(-8px)">
          <div class="checkbox-btn d-flex align-center justify-center" style="width: 36px; height: 36px" @click="contactDialog_privacyPolicy = !contactDialog_privacyPolicy">
            <v-icon v-if="contactDialog_privacyPolicy" style="font-size: 18px; color: #687EFF">
              mdi-checkbox-marked
            </v-icon>
            <v-icon v-else style="font-size: 18px; color: #D8DAE9">
              mdi-checkbox-blank-outline
            </v-icon>
          </div>
          <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #414458">
            <span style="cursor: pointer; text-decoration: underline" @click="openPrivacyPolicy()">개인정보처리방침</span>에 동의합니다.
          </div>
        </div>
        <!-- 문의하기 버튼 -->
        <div @click="clickContactBtnInDialog()"
          class="default-gradient-theme-btn d-flex align-center justify-center"
          style="height: 56px; width: 100%"
          :style="
            contactDialog_answerPath && 
            (contactDialog_answerPath !== '전화' || (contactDialog_answerPath === '전화' && contactDialog_ableTimeInput)) && 
            contactDialog_contactInput && 
            contactDialog_privacyPolicy
            ? {} 
            : {pointerEvents: 'none', cursor: 'none', opacity: '0.4'}
          "
        >
          <div style="font-size: 18px; font-weight: 700; line-height: 22px; color: #ffffff">
            문의하기
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- 문의하기 완료 dialog -->
    <v-dialog v-model="contactDialog_success" max-width="440px">
      <v-card style="border-radius: 16px; position: relative">
        <!-- 취소 버튼 -->
        <div @click="contactDialog_success = false"
          class="default-icon-btn d-flex align-center justify-center"
          style="position: absolute; top: 14px; right: 14px; width: 32px; height: 32px"
        >
          <v-icon style="font-size: 24px; color: #8A8DA8">
            mdi-close
          </v-icon>
        </div>
        <div class="d-flex flex-column align-center" style="padding: 40px 0px">
          <!-- 리컬럼 로고 -->
          <div class="d-flex align-center" style="margin-bottom: 24px">
            <!-- logo -->
            <img src="/assets/recolumn-logo-D8DAE9.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
            <!-- title -->
            <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #D8DAE9; letter-spacing: -0.02em">
              Re:Column
            </div>
          </div>
          <!-- text -->
          <div style="text-align: center; font-size: 27px; font-weight: 700; line-height: 38px; color: #414458; margin-bottom: 24px">
            정상적으로 접수되었습니다!
          </div>
          <!-- sub -->
          <div style="text-align: center; font-size: 14px; font-weight: 400; line-height: 20px; color: #8A8DA8; margin-bottom: 6px">
            도입 문의가 정상적으로 접수되었습니다. <br>
            잠시 기다려주시면 1 영업일 이내에 <br>
            입력하신 연락처로 담당자가 연락 드리겠습니다. <br><br>
            감사합니다.
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- 문의하기 (mobile) -->
    <div v-if="false && contactDialog && window_innerWidth <= 440" style="position: relative; width: 100vw; background-color: #ffffff"
      :style="top_alert ? {marginTop: `calc(${top_alert_height} + 60px)`} : {marginTop: '60px'}"
    >
      <!-- 상단 영역 (title, sub, 취소 버튼) -->
      <div style="position: fixed; z-index: 1; width: 100%; padding: 20px 24px 28px; background-color: #ffffff" :style="top_alert ? {top: `calc(${top_alert_height} + 60px)`} : {top: '60px'}">
        <!-- 취소 버튼 -->
        <div @click="contactDialog = false"
          class="default-icon-btn d-flex align-center justify-center"
          style="position: absolute; top: 8px; right: 8px; width: 40px; height: 40px"
        >
          <v-icon style="font-size: 20px; color: #8A8DA8">
            mdi-close
          </v-icon>
        </div>
        <!-- title -->
        <div style="font-weight: 700; font-size: 22px; line-height: 140%; color: #0D0E17; margin-bottom: 4px">
          문의하기
        </div>
        <!-- sub -->
        <div style="font-weight: 400; font-size: 14px; line-height: 20px; letter-spacing: -0.02em; color: #414458">
          궁금한 점을 편하게 물어보실 수 있도록 연락드립니다.
        </div>
      </div>
      <!-- content -->
      <div style="padding: 107px 24px 104px">
        <!-- 문의 내용 title -->
        <div style="padding-left: 2px; font-weight: 400; font-size: 15px; line-height: 140%; color: #414458; margin-bottom: 8px">
          문의 내용
        </div>
        <!-- 문의 내용 입력창 -->
        <div style="height: 116px; width: 100%; border-radius: 8px; border: 1px solid #E8EAF2; background-color: #ffffff; padding: 10px 14px; margin-bottom: 24px">
          <textarea v-model="contactDialog_inquiryInput" ref="contactDialog_inquiryInput" type="text" placeholder="우리 회사의 보고서 제작 프로세스를 세팅하려면 대략 며칠이 걸리는지 궁금합니다."
            class="input-area-3 focus-hide-placeholder-input" style="width: 100%; height: 100%; font-size: 17px; font-weight: 400; line-height: 140%; color: #414458"
          ></textarea>
        </div>
        <!-- 원하시는 답변 경로 * title -->
        <div style="padding-left: 2px; font-weight: 400; font-size: 15px; line-height: 140%; color: #414458; margin-bottom: 8px">
          원하시는 답변 경로 <span style="color: #687EFF">*</span>
        </div>
        <!-- 원하시는 답변 경로 선택창 -->
        <div style="overflow: hidden auto; border-radius: 8px; border: 1px solid #E8EAF2; background-color: #ffffff; padding: 8px; margin-bottom: 24px">
          <div v-for="item in contactDialog_answerPath_optionList" :key="item.value">
            <div class="hover-bg-color d-flex flex-column" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; cursor: pointer; overflow: hidden"
              :style="contactDialog_answerPath === item.value ? {backgroundColor: '#F0F2FF'} : {}"
              @click="contactDialog_answerPath = item.value"
            >
              <!-- radio btn, text -->
              <div class="d-flex align-center" style="width: 100%; height: 48px">
                <!-- radio btn -->
                <div class="checkbox-btn d-flex align-center justify-center" style="width: 40px; height: 40px">
                  <v-icon v-if="contactDialog_answerPath === item.value" style="font-size: 20px; color: #687EFF">
                    mdi-radiobox-marked
                  </v-icon>
                  <v-icon v-else style="font-size: 20px; color: #D8DAE9">
                    mdi-radiobox-blank
                  </v-icon>
                </div>
                <!-- text -->
                <div style="font-size: 17px; line-height: 140%"
                  :style="contactDialog_answerPath === item.value ? {fontWeight: 600, color: '#687EFF'} : {fontWeight: 500, color: '#414458'}"
                >
                  {{ item.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 통화 가능한 시간 * title - 원하시는 답변 경로 === 전화 (contactDialog_answerPath === '전화') -->
        <div v-if="contactDialog_answerPath === '전화'" style="padding-left: 2px; font-weight: 400; font-size: 15px; line-height: 140%; color: #414458; margin-bottom: 8px">
          통화 가능한 시간 <span style="color: #687EFF">*</span>
        </div>
        <!-- 통화 가능한 시간 입력창 - 원하시는 답변 경로 === 전화 (contactDialog_answerPath === '전화') -->
        <div v-if="contactDialog_answerPath === '전화'" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 24px">
          <input v-model="contactDialog_ableTimeInput" ref="contactDialog_ableTimeInput" type="text" placeholder="내일 오전 11시~오후 1시 사이에 가능합니다."
            class="input-area-3 focus-hide-placeholder-input" style="width: 100%; height: 100%; font-size: 17px; font-weight: 400; line-height: 140%; color: #414458"
          >
        </div>
        <!-- 연락처 title -->
        <div style="padding-left: 2px; font-weight: 400; font-size: 15px; line-height: 140%; color: #414458; margin-bottom: 8px">
          연락처 <span style="color: #687EFF">*</span>
        </div>
        <!-- 연락처 입력창 -->
        <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 10px">
          <input v-model="contactDialog_contactInput" ref="contactDialog_contactInput" type="text"
            :placeholder="contactDialog_answerPath === '전화' ? '010-1234-5678' : 'contact@cogcom.kr'"
            class="input-area-3 focus-hide-placeholder-input" style="width: 100%; height: 100%; font-size: 17px; font-weight: 400; line-height: 140%; color: #414458"
          >
        </div>
        <!-- 개인정보처리방침에 동의합니다. -->
        <div class="d-flex align-center" style="width: 100%; margin-bottom: 0px; transform: translateX(-8px)">
          <div class="checkbox-btn d-flex align-center justify-center" style="width: 36px; height: 36px" @click="contactDialog_privacyPolicy = !contactDialog_privacyPolicy">
            <v-icon v-if="contactDialog_privacyPolicy" style="font-size: 18px; color: #687EFF">
              mdi-checkbox-marked
            </v-icon>
            <v-icon v-else style="font-size: 18px; color: #D8DAE9">
              mdi-checkbox-blank-outline
            </v-icon>
          </div>
          <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #414458">
            <span style="cursor: pointer; text-decoration: underline" @click="openPrivacyPolicy()">개인정보처리방침</span>에 동의합니다.
          </div>
        </div>
      </div>
      <!-- 문의하기 버튼 -->
      <div style="position: fixed; z-index: 1; bottom: 0px; left: 0px; width: 100%; height: calc(56px + 24px + 24px); padding: 0px 24px; background: linear-gradient(rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 15.1%, rgb(255, 255, 255) 100%)"
        class="d-flex align-center justify-center"
      >
        <div @click="clickContactBtnInDialog()"
          class="default-gradient-theme-btn d-flex align-center justify-center"
          style="height: 56px; width: 100%"
          :style="
            contactDialog_answerPath && 
            (contactDialog_answerPath !== '전화' || (contactDialog_answerPath === '전화' && contactDialog_ableTimeInput)) && 
            contactDialog_contactInput && 
            contactDialog_privacyPolicy
            ? {} 
            : {pointerEvents: 'none', cursor: 'none', opacity: '0.4'}
          "
        >
          <div style="font-size: 18px; font-weight: 700; line-height: 22px; color: #ffffff">
            문의하기
          </div>
        </div>
      </div>
    </div>

    <!-- 리컬럼 소개서 받아보기 dialog (web) -->
    <v-dialog v-if="window_innerWidth > 440" v-model="manualDownloadDialog" max-width="420px">
      <v-card style="height: 90vh; max-height: 782px; padding: 24px 22px 24px 22px; position: relative">
        <!-- 취소 버튼 -->
        <div @click="manualDownloadDialog = false"
          class="default-icon-btn d-flex align-center justify-center"
          style="position: absolute; top: 8px; right: 8px; width: 40px; height: 40px"
        >
          <v-icon style="font-size: 20px; color: #8A8DA8">
            mdi-close
          </v-icon>
        </div>
        <!-- title -->
        <div style="font-weight: 700; font-size: 18px; line-height: 24px; color: #0D0E17; margin-bottom: 24px; padding-left: 8px">
          리컬럼 소개서 받아보기
        </div>
        <!-- content (scroll) -->
        <div class="y-scroll-width-4px" style="overflow: hidden auto; height: calc(100% - 48px - 56px); padding: 0px 8px; mask-image: linear-gradient(to bottom, #ffffff 90%, transparent 100%)">
          <!-- 언어 버전 title -->
          <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
            언어 버전
          </div>
          <!-- 언어 버전 dropdown -->
          <div style="width: 100%; height: 40px; margin-bottom: 16px">
            <v-menu offset-y bottom>
              <!-- 선택값 -->
              <template v-slot:activator="{ on, value }">
                <div v-on="on" style="width: 100%; height: 100%; position: relative; cursor: pointer">
                  <!-- 선택값 및 아이콘 -->
                  <div class="d-flex align-center justify-space-between"
                    style="width: 100%; height: 100%; overflow: auto hidden; padding: 0px 8px 0px 12px; border-radius: 8px; border: 1px solid #E8EAF2; cursor: pointer"
                  >
                    <!-- 선택값 -->
                    <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                      {{ manualDownloadDialog_language }}
                    </div>
                    <!-- 아이콘 -->
                    <v-icon :class="value ? 'up' : 'down'" style="font-size: 20px; color: #414458">
                      mdi-chevron-down
                    </v-icon>
                  </div>
                </div>
              </template>
              <!-- 선택 목록 -->
              <v-card style="width: 100%; overflow: hidden auto">
                <!-- 한글(KOR) -->
                <div @click="manualDownloadDialog_language = '한글(KOR)'"
                  class="hover-bg-color-F8F9FB d-flex align-center" style="height: 40px; padding: 0px 12px; cursor: pointer"
                  :style="manualDownloadDialog_language === '한글(KOR)' ? {backgroundColor: '#F0F2FF'} : {}"
                >
                  <!-- text -->
                  <div style="font-size: 14px; font-weight: 500; line-height: 20px; color: #414458"
                    :style="manualDownloadDialog_language === '한글(KOR)' ? {color: '#687EFF', fontWeight: 600} : {}"
                  >
                    한글(KOR)
                  </div>
                </div>
                <!-- 영어(ENG) -->
                <div @click="manualDownloadDialog_language = '영어(ENG)'"
                  class="hover-bg-color-F8F9FB d-flex align-center" style="height: 40px; padding: 0px 12px; cursor: pointer"
                  :style="manualDownloadDialog_language === '영어(ENG)' ? {backgroundColor: '#F0F2FF'} : {}"
                >
                  <!-- text -->
                  <div style="font-size: 14px; font-weight: 500; line-height: 20px; color: #414458"
                    :style="manualDownloadDialog_language === '영어(ENG)' ? {color: '#687EFF', fontWeight: 600} : {}"
                  >
                    영어(ENG)
                  </div>
                </div>
              </v-card>
            </v-menu>
          </div>
          <!-- 이름 title -->
          <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
            이름
          </div>
          <!-- 이름 입력창 (로그인 o) -->
          <div v-if="$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #F8F9FB; margin-bottom: 16px">
            <div style="font-weight: 400; font-size: 14px; line-height: 18px; color: #ABAEC4">
              {{ $store.state.user_info.name }}
            </div>
          </div>
          <!-- 이름 입력창 (로그인 x) -->
          <div v-if="!$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
            <input v-model="manualDownloadDialog_nameInput" ref="manualDownloadDialog_nameInput" type="text"
              :placeholder="nameInputFocused ? '' : '홍길동'"
              @focus="nameInputFocused = true" @blur="nameInputFocused = false"
              class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
            >
          </div>
          <!-- 업무용 이메일 title -->
          <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
            업무용 이메일
          </div>
          <!-- 업무용 이메일 입력창 (로그인 o) -->
          <div v-if="$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #F8F9FB; margin-bottom: 16px">
            <div style="font-weight: 400; font-size: 14px; line-height: 18px; color: #ABAEC4">
              {{ $store.state.user_info.email }}
            </div>
          </div>
          <!-- 업무용 이메일 입력창 (로그인 x) -->
          <div v-if="!$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
            <input v-model="manualDownloadDialog_emailInput" ref="manualDownloadDialog_emailInput" type="text"
              :placeholder="emailInputFocused ? '' : 'contact@cogcom.kr'"
              @focus="emailInputFocused = true" @blur="emailInputFocused = false"
              class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
            >
          </div>
          <!-- 회사 title -->
          <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
            회사
          </div>
          <!-- 회사 입력창 -->
          <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
            <input v-model="manualDownloadDialog_companyInput" ref="manualDownloadDialog_companyInput" type="text" 
              :placeholder="companyInputFocused ? '' : '(주)리컬럼'"
              @focus="companyInputFocused = true" @blur="companyInputFocused = false"
              class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
            >
          </div>
          <!-- 직책 title -->
          <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
            직책
          </div>
          <!-- 직책 입력창 -->
          <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
            <input v-model="manualDownloadDialog_positionInput" ref="manualDownloadDialog_positionInput" type="text" 
              :placeholder="positionInputFocused ? '' : '팀장'"
              @focus="positionInputFocused = true" @blur="positionInputFocused = false"
              class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
            >
          </div>
          <!-- 연락처 title -->
          <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
            연락처
          </div>
          <!-- 연락처 입력창 -->
          <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 10px">
            <input v-model="manualDownloadDialog_phoneNumberInput" ref="manualDownloadDialog_phoneNumberInput" type="text" 
              :placeholder="phoneNumberInputFocused ? '' : '010-1234-5678'"
              @focus="phoneNumberInputFocused = true" @blur="phoneNumberInputFocused = false"
              class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
            >
          </div>
          <!-- 마케팅 정보 수신에 동의합니다. -->
          <div class="d-flex align-start" style="width: 100%; margin-bottom: 10px; transform: translateX(-8px)">
            <div class="checkbox-btn d-flex align-center justify-center" style="min-width: 36px; height: 36px; transform: translateY(-2px)" @click="manualDownloadDialog_marketingReception = !manualDownloadDialog_marketingReception">
              <v-icon v-if="manualDownloadDialog_marketingReception" style="font-size: 18px; color: #687EFF">
                mdi-checkbox-marked
              </v-icon>
              <v-icon v-else style="font-size: 18px; color: #D8DAE9">
                mdi-checkbox-blank-outline
              </v-icon>
            </div>
            <div>
              <div style="font-size: 14px; font-weight: 400; line-height: 32px; color: #414458">
                마케팅 정보 수신에 동의합니다.
              </div>
              <div style="font-size: 13px; font-weight: 400; line-height: 18px; color: #8A8DA8; word-break: keep-all">
                마케팅 정보 수신에 동의하시면 이후 업무에 도움이 되는 최신 자동화 트렌드와 사례 자료를 받으실 수 있습니다.
              </div>
            </div>
          </div>
          <!-- 개인정보처리방침에 동의합니다. -->
          <div class="d-flex align-center" style="width: 100%; margin-bottom: 30px; transform: translateX(-8px)">
            <div class="checkbox-btn d-flex align-center justify-center" style="width: 36px; height: 36px" @click="manualDownloadDialog_privacyPolicy = !manualDownloadDialog_privacyPolicy">
              <v-icon v-if="manualDownloadDialog_privacyPolicy" style="font-size: 18px; color: #687EFF">
                mdi-checkbox-marked
              </v-icon>
              <v-icon v-else style="font-size: 18px; color: #D8DAE9">
                mdi-checkbox-blank-outline
              </v-icon>
            </div>
            <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #414458">
              <span style="cursor: pointer; text-decoration: underline" @click="openPrivacyPolicy()">개인정보처리방침</span>에 동의합니다.
            </div>
          </div>
        </div>
        <!-- 리컬럼 소개서 다운로드 버튼 -->
        <div class="d-flex align-center justify-center">
          <div @click="clickManualDownloadBtn()"
            class="default-gradient-theme-btn d-flex align-center justify-center"
            style="height: 56px; width: 360px"
            :style="
              ($store.state.user_info.name || manualDownloadDialog_nameInput) && ($store.state.user_info.email || manualDownloadDialog_emailInput) &&
              manualDownloadDialog_companyInput && manualDownloadDialog_positionInput && manualDownloadDialog_phoneNumberInput && manualDownloadDialog_privacyPolicy ?
              {} : {pointerEvents: 'none', cursor: 'none', opacity: '0.4'}
            "
          >
            <div style="font-size: 18px; font-weight: 700; line-height: 22px; color: #ffffff">
              리컬럼 소개서 다운로드
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- 리컬럼 소개서 받아보기 (mobile) -->
    <div v-if="manualDownloadDialog && window_innerWidth <= 440" style="position: relative; width: 100vw; background-color: #ffffff"
      :style="top_alert ? {marginTop: `calc(${top_alert_height} + 60px)`} : {marginTop: '60px'}"
    >
      <!-- 상단 영역 (title, 취소 버튼) -->
      <div style="position: fixed; z-index: 1; width: 100%; padding: 24px; background-color: #ffffff" :style="top_alert ? {top: `calc(${top_alert_height} + 60px)`} : {top: '60px'}">
        <!-- 취소 버튼 -->
        <div @click="manualDownloadDialog = false"
          class="default-icon-btn d-flex align-center justify-center"
          style="position: absolute; top: 8px; right: 8px; width: 40px; height: 40px"
        >
          <v-icon style="font-size: 20px; color: #8A8DA8">
            mdi-close
          </v-icon>
        </div>
        <!-- title -->
        <div style="font-weight: 700; font-size: 18px; line-height: 24px; color: #0D0E17">
          리컬럼 소개서 받아보기
        </div>
      </div>
      <!-- content -->
      <div style="padding: 30px 24px 104px">
        <!-- 언어 버전 title -->
        <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          언어 버전
        </div>
        <!-- 언어 버전 dropdown -->
        <div style="width: 100%; height: 40px; margin-bottom: 16px">
          <v-menu offset-y bottom>
            <!-- 선택값 -->
            <template v-slot:activator="{ on, value }">
              <div v-on="on" style="width: 100%; height: 100%; position: relative; cursor: pointer">
                <!-- 선택값 및 아이콘 -->
                <div class="d-flex align-center justify-space-between"
                  style="width: 100%; height: 100%; overflow: auto hidden; padding: 0px 8px 0px 12px; border-radius: 8px; border: 1px solid #E8EAF2; cursor: pointer"
                >
                  <!-- 선택값 -->
                  <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                    {{ manualDownloadDialog_language }}
                  </div>
                  <!-- 아이콘 -->
                  <v-icon :class="value ? 'up' : 'down'" style="font-size: 20px; color: #414458">
                    mdi-chevron-down
                  </v-icon>
                </div>
              </div>
            </template>
            <!-- 선택 목록 -->
            <v-card style="width: 100%; overflow: hidden auto">
              <!-- 한글(KOR) -->
              <div @click="manualDownloadDialog_language = '한글(KOR)'"
                class="hover-bg-color-F8F9FB d-flex align-center" style="height: 40px; padding: 0px 12px; cursor: pointer"
                :style="manualDownloadDialog_language === '한글(KOR)' ? {backgroundColor: '#F0F2FF'} : {}"
              >
                <!-- text -->
                <div style="font-size: 14px; font-weight: 500; line-height: 20px; color: #414458"
                  :style="manualDownloadDialog_language === '한글(KOR)' ? {color: '#687EFF', fontWeight: 600} : {}"
                >
                  한글(KOR)
                </div>
              </div>
              <!-- 영어(ENG) -->
              <div @click="manualDownloadDialog_language = '영어(ENG)'"
                class="hover-bg-color-F8F9FB d-flex align-center" style="height: 40px; padding: 0px 12px; cursor: pointer"
                :style="manualDownloadDialog_language === '영어(ENG)' ? {backgroundColor: '#F0F2FF'} : {}"
              >
                <!-- text -->
                <div style="font-size: 14px; font-weight: 500; line-height: 20px; color: #414458"
                  :style="manualDownloadDialog_language === '영어(ENG)' ? {color: '#687EFF', fontWeight: 600} : {}"
                >
                  영어(ENG)
                </div>
              </div>
            </v-card>
          </v-menu>
        </div>
        <!-- 이름 title -->
        <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          이름
        </div>
        <!-- 이름 입력창 (로그인 o) -->
        <div v-if="$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #F8F9FB; margin-bottom: 16px">
          <div style="font-weight: 400; font-size: 14px; line-height: 18px; color: #ABAEC4">
            {{ $store.state.user_info.name }}
          </div>
        </div>
        <!-- 이름 입력창 (로그인 x) -->
        <div v-if="!$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
          <input v-model="manualDownloadDialog_nameInput" ref="manualDownloadDialog_nameInput" type="text"
            :placeholder="nameInputFocused ? '' : '홍길동'"
            @focus="nameInputFocused = true" @blur="nameInputFocused = false"
            class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
          >
        </div>
        <!-- 업무용 이메일 title -->
        <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          업무용 이메일
        </div>
        <!-- 업무용 이메일 입력창 (로그인 o) -->
        <div v-if="$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #F8F9FB; margin-bottom: 16px">
          <div style="font-weight: 400; font-size: 14px; line-height: 18px; color: #ABAEC4">
            {{ $store.state.user_info.email }}
          </div>
        </div>
        <!-- 업무용 이메일 입력창 (로그인 x) -->
        <div v-if="!$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
          <input v-model="manualDownloadDialog_emailInput" ref="manualDownloadDialog_emailInput" type="text"
            :placeholder="emailInputFocused ? '' : 'contact@cogcom.kr'"
            @focus="emailInputFocused = true" @blur="emailInputFocused = false"
            class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
          >
        </div>
        <!-- 회사 title -->
        <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          회사
        </div>
        <!-- 회사 입력창 -->
        <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
          <input v-model="manualDownloadDialog_companyInput" ref="manualDownloadDialog_companyInput" type="text" 
            :placeholder="companyInputFocused ? '' : '(주)리컬럼'"
            @focus="companyInputFocused = true" @blur="companyInputFocused = false"
            class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
          >
        </div>
        <!-- 직책 title -->
        <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          직책
        </div>
        <!-- 직책 입력창 -->
        <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
          <input v-model="manualDownloadDialog_positionInput" ref="manualDownloadDialog_positionInput" type="text" 
            :placeholder="positionInputFocused ? '' : '팀장'"
            @focus="positionInputFocused = true" @blur="positionInputFocused = false"
            class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
          >
        </div>
        <!-- 연락처 title -->
        <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          연락처
        </div>
        <!-- 연락처 입력창 -->
        <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 10px">
          <input v-model="manualDownloadDialog_phoneNumberInput" ref="manualDownloadDialog_phoneNumberInput" type="text" 
            :placeholder="phoneNumberInputFocused ? '' : '010-1234-5678'"
            @focus="phoneNumberInputFocused = true" @blur="phoneNumberInputFocused = false"
            class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
          >
        </div>
        <!-- 마케팅 정보 수신에 동의합니다. -->
        <div class="d-flex align-start" style="width: 100%; margin-bottom: 10px; transform: translateX(-8px)">
          <div class="checkbox-btn d-flex align-center justify-center" style="min-width: 36px; height: 36px; transform: translateY(-2px)" @click="manualDownloadDialog_marketingReception = !manualDownloadDialog_marketingReception">
            <v-icon v-if="manualDownloadDialog_marketingReception" style="font-size: 18px; color: #687EFF">
              mdi-checkbox-marked
            </v-icon>
            <v-icon v-else style="font-size: 18px; color: #D8DAE9">
              mdi-checkbox-blank-outline
            </v-icon>
          </div>
          <div>
            <div style="font-size: 14px; font-weight: 400; line-height: 32px; color: #414458">
              마케팅 정보 수신에 동의합니다.
            </div>
            <div style="font-size: 13px; font-weight: 400; line-height: 18px; color: #8A8DA8; word-break: keep-all">
              마케팅 정보 수신에 동의하시면 이후 업무에 도움이 되는 최신 자동화 트렌드와 사례 자료를 받으실 수 있습니다.
            </div>
          </div>
        </div>
        <!-- 개인정보처리방침에 동의합니다. -->
        <div class="d-flex align-center" style="width: 100%; margin-bottom: 0px; transform: translateX(-8px)">
          <div class="checkbox-btn d-flex align-center justify-center" style="width: 36px; height: 36px" @click="manualDownloadDialog_privacyPolicy = !manualDownloadDialog_privacyPolicy">
            <v-icon v-if="manualDownloadDialog_privacyPolicy" style="font-size: 18px; color: #687EFF">
              mdi-checkbox-marked
            </v-icon>
            <v-icon v-else style="font-size: 18px; color: #D8DAE9">
              mdi-checkbox-blank-outline
            </v-icon>
          </div>
          <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #414458">
            <span style="cursor: pointer; text-decoration: underline" @click="openPrivacyPolicy()">개인정보처리방침</span>에 동의합니다.
          </div>
        </div>
      </div>
      <!-- 리컬럼 소개서 다운로드 버튼 -->
      <div style="position: fixed; z-index: 1; bottom: 0px; left: 0px; width: 100%; height: calc(56px + 24px + 24px); padding: 0px 24px; background: linear-gradient(rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 15.1%, rgb(255, 255, 255) 100%)"
        class="d-flex align-center justify-center"
      >
        <div @click="clickManualDownloadBtn()" style="height: 56px; width: 100%"
          class="default-gradient-theme-btn d-flex align-center justify-center"
          :style="
            ($store.state.user_info.name || manualDownloadDialog_nameInput) && ($store.state.user_info.email || manualDownloadDialog_emailInput) &&
            manualDownloadDialog_companyInput && manualDownloadDialog_positionInput && manualDownloadDialog_phoneNumberInput && manualDownloadDialog_privacyPolicy ?
            {} : {pointerEvents: 'none', cursor: 'none', opacity: '0.4'}
          "
        >
          <div style="font-size: 18px; font-weight: 700; line-height: 22px; color: #ffffff">
            리컬럼 소개서 다운로드
          </div>
        </div>
      </div>
    </div>

    <!-- 무료체험 요청 dialog -->
    <v-dialog v-model="demoRequestDialog" max-width="440px">
      <v-card v-if="demoRequestDialog" style="border-radius: 10px; position: relative">
        <!-- 취소 버튼 -->
        <div @click="demoRequestDialog = false"
          class="default-icon-btn d-flex align-center justify-center"
          style="position: absolute; top: 14px; right: 14px; width: 32px; height: 32px"
        >
          <v-icon style="font-size: 24px; color: #8A8DA8">
            mdi-close
          </v-icon>
        </div>
        <!-- 이메일 발송 전 -->
        <div v-if="sendTrialEmailFlag === 0" class="d-flex flex-column align-center" style="padding: 40px">
          <!-- 리컬럼 로고 -->
          <div class="d-flex align-center" style="margin-bottom: 14px">
            <!-- logo -->
            <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
            <!-- title -->
            <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
              Re:Column
            </div>
          </div>
          <!-- text -->
          <div style="text-align: center; font-size: 16px; font-weight: 500; line-height: 18px; color: #414458; margin-bottom: 32px">
            2주간 리컬럼의 데이터 업무 자동화를 체험해 보세요!
          </div>
          <!-- 이메일 입력창 -->
          <v-text-field v-model="emailInput" placeholder="이메일을 입력하세요." autofocus
            height="48px" background-color="#FFFFFF" color="#0D0E17" outlined dense hide-details
            class="default-input" style="width: 100%; border-radius: 8px; font-size: 16px; margin-bottom: 24px"
          ></v-text-field>
          <!-- 2주 무료체험 버튼 -->
          <div @click="clickTrialBtn(emailInput)"
            class="default-gradient-theme-btn d-flex align-center justify-center"
            :class="checkEmailValid(emailInput) ? '' : 'disabled-area-opacity-40'"
            style="height: 56px; width: 100%"
          >
            <div style="font-size: 18px; line-height: 22px; padding-left: 4px">
              2주 무료체험
            </div>
            <v-icon style="font-size: 24px; margin-left: 4px">
              mdi-arrow-right
            </v-icon>
          </div>
        </div>
        <!-- 이메일 발송 후 - 무료체험 신청 기록이 없는 경우 -->
        <div v-if="sendTrialEmailFlag === 1" class="d-flex flex-column align-center" style="padding: 40px 35px 52px">
          <!-- 리컬럼 로고 -->
          <div class="d-flex align-center" style="margin-bottom: 24px">
            <!-- logo -->
            <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
            <!-- title -->
            <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
              Re:Column
            </div>
          </div>
          <!-- title -->
          <div style="font-size: 27px; font-weight: 700; line-height: 38px; color: #414458; text-align: center; margin-bottom: 24px">
            곧 무료체험이 시작됩니다.
          </div>
          <!-- text -->
          <div style="font-size: 14px; font-weight: 400; line-height: 20px; color: #8A8DA8; text-align: center; margin-bottom: 14px">
            잠시 기다려주시면 1 영업일 이내에 <br> 입력하신 이메일 계정으로 무료체험 링크를 보내드립니다.
          </div>
          <!-- text -->
          <div style="font-size: 14px; font-weight: 400; line-height: 20px; color: #8A8DA8; text-align: center">
            문사항은 고객센터로 연락주세요. <br> (<span style="text-decoration: underline">contact@cogcom.kr</span>, <span style="text-decoration: underline">02-2088-2096</span>)
          </div>
        </div>
        <!-- 이메일 발송 후 - 무료체험 신청 기록이 있는 경우 -->
        <div v-if="sendTrialEmailFlag === 2" class="d-flex flex-column align-center" style="padding: 40px">
          <!-- 리컬럼 로고 -->
          <div class="d-flex align-center" style="margin-bottom: 24px">
            <!-- logo -->
            <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
            <!-- title -->
            <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
              Re:Column
            </div>
          </div>
          <!-- title -->
          <div style="font-size: 27px; font-weight: 700; line-height: 38px; color: #414458; text-align: center; margin-bottom: 24px">
            무료체험을 연장하고 싶으신가요?
          </div>
          <!-- text -->
          <div style="font-size: 14px; font-weight: 400; line-height: 20px; color: #8A8DA8; text-align: center; margin-bottom: 30px">
            채널톡을 통해 상담을 진행하실 수 있습니다. <br> 문의를 남겨주시면 몇 분 내로 상담사가 직접 응대해 드립니다.
          </div>
          <!-- 리컬럼 매니저 -->
          <div class="d-flex align-center"
            style="width: 300px; height: 56px; border-radius: 10px; border: 1px solid #F8F9FB; box-shadow: 2.11px 4.23px 4.23px 0px #41445829; padding: 0px 10px; margin-bottom: 32px"
          >
            <!-- avatar -->
            <v-avatar color="#D8DDFF" size="34" style="margin-right: 10px">
              <v-icon style="font-size: 20px; color: #ffffff">
                mdi-account
              </v-icon>
            </v-avatar>
            <!-- title / sub -->
            <div>
              <!-- title -->
              <div style="font-weight: 600; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 2px">
                리컬럼 매니저
              </div>
              <!-- sub -->
              <div style="font-weight: 400; font-size: 13px; line-height: 16px; color: #8A8DA8">
                9:00 AM ~ 5:00 PM
              </div>
            </div>
          </div>
          <!-- 채널톡으로 문의하기 버튼 -->
          <div @click="contactChannelTalk()"
            class="default-gradient-theme-btn d-flex align-center justify-center"
            style="height: 56px; width: 100%; border-radius: 10px !important"
          >
            <div style="font-size: 18px; line-height: 22px">
              채널톡으로 문의하기
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!-- 튜토리얼 시작 dialog -->
    <v-dialog v-model="tutorialStartDialog" max-width="556px">
      <v-card style="border-radius: 10px; padding: 22px 28px 24px; position: relative">
        <!-- 취소 버튼 -->
        <div @click="tutorialStartDialog = false"
          class="default-icon-btn d-flex align-center justify-center"
          style="position: absolute; top: 6px; right: 8px; width: 40px; height: 40px"
        >
          <v-icon style="font-size: 20px; color: #8A8DA8 !important">
            mdi-close
          </v-icon>
        </div>
        <!-- title -->
        <div style="font-size: 18px; font-weight: 600; line-height: 24px; color: #0D0E17; margin-bottom: 4px">
          튜토리얼 시작
        </div>
        <!-- sub -->
        <div style="font-size: 14px; font-weight: 500; line-height: 20px; color: #8A8DA8; margin-bottom: 24px">
          튜토리얼을 선택하면 해당 튜토리얼 시작 화면으로 이동하게 됩니다. 작업 중이던 내용이 있다면 작업을 완료한 후 진행해주세요.
        </div>
        <!-- 기본 튜토리얼 -->
        <div @click="clickBasicTutorial()"
          class="tutorial-start-dialog-item d-flex align-center" style="width: 100%; height: 56px; border-radius: 8px; padding: 0px 8px; cursor: pointer; margin-bottom: 8px"
        >
          <!-- icon box -->
          <div class="d-flex align-center justify-center" style="min-width: 60px; height: 42px; border-radius: 8px; background-color: #F0F2FF">
            <v-icon style="font-size: 24px; color: #687EFF">
              mdi-rocket-outline
            </v-icon>
          </div>
          <!-- text box -->
          <div style="margin-left: 10px">
            <div style="font-size: 15px; font-weight: 600; line-height: 18px; color: #414458; margin-bottom: 4px">
              기본 튜토리얼
            </div>
            <div style="font-size: 13px; font-weight: 400; line-height: 16px; color: #8A8DA8">
              프로젝트 접속부터, 자동화 결과물 엑셀 파일 생성까지 안내합니다.
            </div>
          </div>
        </div>
        <!-- 워크플로우 프로세스 둘러보기 -->
        <div @click="clickRpaTutorial()"
          class="tutorial-start-dialog-item d-flex align-center" style="width: 100%; height: 56px; border-radius: 8px; padding: 0px 8px; cursor: pointer; margin-bottom: 8px"
        >
          <!-- icon box -->
          <div class="d-flex align-center justify-center" style="min-width: 60px; height: 42px; border-radius: 8px; background-color: #F0F2FF">
            <v-icon style="font-size: 24px; color: #687EFF">
              mdi-refresh-auto
            </v-icon>
          </div>
          <!-- text box -->
          <div style="margin-left: 10px">
            <div style="font-size: 15px; font-weight: 600; line-height: 18px; color: #414458; margin-bottom: 4px">
              워크플로우 프로세스 둘러보기
            </div>
            <div style="font-size: 13px; font-weight: 400; line-height: 16px; color: #8A8DA8">
              리컬럼 워크플로우가 어떻게 구성되어 있는지 안내합니다.
            </div>
          </div>
        </div>
        <!-- 데이터 보기 모드 및 서식 보기 모드 -->
        <div @click="clickDataModeTutorial()"
          class="tutorial-start-dialog-item d-flex align-center" style="width: 100%; height: 56px; border-radius: 8px; padding: 0px 8px; cursor: pointer; margin-bottom: 8px"
        >
          <!-- icon box -->
          <div class="d-flex align-center justify-center" style="min-width: 60px; height: 42px; border-radius: 8px; background-color: #F0F2FF">
            <v-icon style="font-size: 24px; color: #687EFF">
              mdi-palette-outline
            </v-icon>
          </div>
          <!-- text box -->
          <div style="margin-left: 10px">
            <div style="font-size: 15px; font-weight: 600; line-height: 18px; color: #414458; margin-bottom: 4px">
              데이터 보기 모드 및 서식 보기 모드
            </div>
            <div style="font-size: 13px; font-weight: 400; line-height: 16px; color: #8A8DA8">
              스프레드시트 형식 파일들의 서식 보기, 필터 및 정렬 방법을 안내합니다.
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!-- 로그인 dialog -->
    <v-dialog v-model="loginDialog" max-width="440px">
      <v-card v-if="loginDialog" class="d-flex flex-column align-center justify-center" style="padding: 0px 40px; border-radius: 10px; position: relative">
        <!-- close btn -->
        <div @click="loginDialog = false"
          class="default-icon-btn d-flex align-center justify-center"
          style="width: 32px; height: 32px; position: absolute; top: 14px; right: 14px"
        >
          <v-icon style="font-size: 24px">
            mdi-close
          </v-icon>
        </div>
        <!-- logo 및 title -->
        <div class="d-flex align-center justify-center" style="padding: 42px 0px 30px 0px">
          <!-- logo -->
          <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
          <!-- title -->
          <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
            Re:Column
          </div>
        </div>
        <!-- email input -->
        <div style="width: 100%; margin-bottom: 12px">
          <v-text-field
            data-testid="login-email-input"
            v-model="userEmailInput" placeholder="이메일을 입력하세요." autofocus
            height="40px" background-color="#FFFFFF" color="#0D0E17" outlined dense hide-details
            class="text-input text-input-px-4" style="border-radius: 8px; font-size: 14px"
          ></v-text-field>
        </div>
        <!-- password input -->
        <div style="width: 100%; margin-bottom: 28px">
          <v-text-field data-testid="login-password-input" @keyup.enter="commonLogin(userEmailInput, userPasswordInput)"
            v-model="userPasswordInput" placeholder="비밀번호를 입력하세요."
            :type="showUserPasswordInput ? 'text' : 'password'" :append-icon="showUserPasswordInput ? 'mdi-eye-outline' : 'mdi-eye-off-outline'" @click:append="showUserPasswordInput = !showUserPasswordInput"
            height="40px" background-color="#FFFFFF" color="#D8DAE9" outlined dense hide-details
            class="text-input text-input-px-4" style="border-radius: 8px; font-size: 14px"
          ></v-text-field>
        </div>
        <!-- login btn -->
        <div data-testid="login-submit-btn" @click="commonLogin(userEmailInput, userPasswordInput)"
          class="default-theme-btn d-flex align-center justify-center"
          style="width: 100%; height: 40px; margin-bottom: 12px"
        >
          <div style="font-size: 14px; font-weight: 600; line-height: 18px">
            로그인
          </div>
        </div>
        <!-- 비밀번호 찾기 -->
        <div @click="findPasswordDialog = true; userEmailInput = ''; loginDialog = false"
          style="font-size: 14px; font-weight: 400; line-height: 18px; color: #ABAEC4; cursor: pointer; margin-bottom: 36px"
        >
          비밀번호 찾기
        </div>
        <!-- 간편 로그인 -->
        <div v-if="googleLoginEnabled" class="d-flex align-center" style="position: relative; width: 100%; height: 18px; margin-bottom: 11px">
          <!-- line -->
          <div
            style="width: 100%; height: 1px; background-color: #E8EAF2"
          ></div>
          <!-- title -->
          <div style="position: absolute; top: 0; left: calc(50% - 44px); background-color: #FFFFFF; padding: 0px 11px 0px 12px">
            <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #8A8DA8">
              간편 로그인
            </div>
          </div>
        </div>
        <!-- google login btn -->
        <div v-if="googleLoginEnabled" @click="googleSocialLogin()"
          class="default-white-btn d-flex align-center justify-center"
          style="width: 100%; height: 40px; margin-bottom: 40px"
        >
          <v-img
            src="/assets/google-logo.png" max-width="24px" max-height="24px"
          ></v-img>
          <span style="font-size: 14px; font-weight: 500; line-height: 18px; margin-left: 8px">
            Google 계정으로 로그인
          </span>
        </div>
      </v-card>
    </v-dialog>

    <!-- 비밀번호 찾기 dialog -->
    <v-dialog v-model="findPasswordDialog" max-width="440px" data-testid="find-password-dialog">
      <v-card class="d-flex flex-column align-center justify-center" style="padding: 0px 40px; border-radius: 10px; position: relative">
        <!-- close btn -->
        <div @click="findPasswordDialog = false"
          class="default-icon-btn d-flex align-center justify-center"
          style="width: 32px; height: 32px; position: absolute; top: 14px; right: 14px"
        >
          <v-icon style="font-size: 24px">
            mdi-close
          </v-icon>
        </div>
        <!-- logo 및 title -->
        <div class="d-flex align-center justify-center" style="padding: 42px 0px 30px 0px">
          <!-- logo -->
          <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
          <!-- title -->
          <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
            Re:Column
          </div>
        </div>
        <!-- email input -->
        <div style="width: 100%; margin-bottom: 12px">
          <v-text-field data-testid="find-password-email-input"
            v-model="userEmailInput" placeholder="가입했던 이메일을 입력하세요." autofocus
            height="40px" background-color="#FFFFFF" color="#0D0E17" outlined dense hide-details
            class="text-input text-input-px-4" style="border-radius: 8px; font-size: 14px"
          ></v-text-field>
        </div>
        <!-- 하단 문구 -->
        <div style="width: 100%; padding-left: 4px; margin-bottom: 28px">
          <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #ABAEC4">
            새 비밀번호를 설정할 수 있는 링크가 전송됩니다.
          </div>
        </div>
        <!-- 이메일 발송 버튼 -->
        <div @click="sendFindPasswordEmail(userEmailInput)"
          class="default-theme-btn d-flex align-center justify-center"
          style="width: 100%; height: 40px; margin-bottom: 197px"
        >
          <div style="font-size: 14px; font-weight: 600; line-height: 18px">
            이메일 발송
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!-- 사용 기한 만료 알림 dialog -->
    <v-dialog v-if="isWorkspaceRoute" v-model="$store.state.dateExpirationDialog" data-testid="workspace-date-expiration-dialog" max-width="500px">
      <v-card style="padding: 22px 28px 82px; position: relative">
        <!-- 취소 버튼(absolute) -->
        <div @click="$store.state.dateExpirationDialog = false"
          class="default-icon-btn d-flex align-center justify-center"
          style="position: absolute; top: 6px; right: 8px; width: 40px; height: 40px"
        >
          <v-icon style="font-size: 20px; color: #8A8DA8">
            mdi-close
          </v-icon>
        </div>
        <!-- title -->
        <div style="font-size: 18px; font-weight: 600; line-height: 24px; color: #0D0E17; margin-bottom: 4px">
          사용 기한이 만료된 계정입니다.
        </div>
        <!-- sub title -->
        <div style="font-size: 14px; font-weight: 500; line-height: 20px; color: #8A8DA8; margin-bottom: 24px">
          내용을 복사한 뒤 우측 하단의 채널톡에 전송해 간편하게 문의하실 수 있습니다.
        </div>
        <!-- 이름 title -->
        <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
          이름
        </div>
        <!-- 이름 -->
        <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; margin-bottom: 16px">
          {{ $store.state.user_info.name }}
        </div>
        <!-- 이메일 title -->
        <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
          이메일
        </div>
        <!-- 이메일 -->
        <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; margin-bottom: 16px">
          {{ $store.state.user_info.email }}
        </div>
        <!-- 조직 title -->
        <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
          조직
        </div>
        <!-- 조직 -->
        <div class="d-flex align-center" style="margin-bottom: 16px">
          <!-- root -->
          <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
            {{ $store.state.user_info.organization_root_name }}
          </div>
          <!-- > -->
          <v-icon v-if="$store.state.user_info.organization_root !== $store.state.user_info.organization_sub"
            style="font-size: 18px; color: #8A8DA8; margin: 0px 2px"
          >
            mdi-chevron-right
          </v-icon>
          <!-- sub -->
          <div v-if="$store.state.user_info.organization_root !== $store.state.user_info.organization_sub"
            style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458"
          >
            {{ $store.state.user_info.organization_sub_name }}
          </div>
        </div>
        <!-- 만료일 title -->
        <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
          만료일
        </div>
        <!-- 만료일 -->
        <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; margin-bottom: 16px">
          {{ $store.state.user_info.paid_expire_date | dateFormatFilter }}
        </div>
        <!-- 내용 복사 버튼(absolute) -->
        <div @click="copyDateExpirationDialogContent()"
          class="default-theme-btn d-flex align-center"
          style="position: absolute; bottom: 20px; right: 20px; height: 30px; padding: 0px 12px 0px 10px"
        >
          <v-icon style="font-size: 20px">
            mdi-content-copy
          </v-icon>
          <span style="font-size: 14px; font-weight: 600; line-height: 18px; margin-left: 6px">
            내용 복사
          </span>
        </div>
      </v-card>
    </v-dialog>

    <!-- 비활성화 계정 알림 dialog -->
    <v-dialog v-if="isWorkspaceRoute" v-model="$store.state.deactivatedAccountDialog" data-testid="workspace-deactivated-account-dialog" max-width="440px">
      <v-card class="d-flex flex-column align-center justify-center" style="border-radius: 10px; position: relative">
        <!-- 취소 버튼(absolute) -->
        <div @click="$store.state.deactivatedAccountDialog = false"
          class="default-icon-btn d-flex align-center justify-center"
          style="position: absolute; top: 14px; right: 14px; width: 32px; height: 32px"
        >
          <v-icon style="font-size: 24px; color: #8A8DA8">
            mdi-close
          </v-icon>
        </div>
        <!-- 리컬럼 로고 -->
        <div class="d-flex align-center justify-center" style="padding: 40px 0px 24px 0px">
          <!-- logo -->
          <img src="/assets/recolumn-logo-D8DAE9.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
          <!-- title -->
          <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #D8DAE9; letter-spacing: -0.02em">
            Re:Column
          </div>
        </div>
        <!-- title -->
        <div style="font-size: 27px; font-weight: 700; line-height: 38px; color: #414458; margin-bottom: 24px">
          비활성화된 계정입니다.
        </div>
        <!-- sub title -->
        <div style="text-align: center; font-size: 14px; font-weight: 400; line-height: 20px; color: #8A8DA8; margin-bottom: 66px">
          내 조직 관리자, 혹은 리컬럼 관리자가 비활성화한 계정입니다. <br>
          계정 활성화가 필요하시면 내 조직 관리자에게 문의하시거나, <br>
          리컬럼 고객센터로 연락 바랍니다. <br>
          (<span style="text-decoration: underline">contact@cogcom.kr</span>, <span style="text-decoration: underline">02-2088-2096</span>)
        </div>
      </v-card>
    </v-dialog>

    <!-- 계정 활성화 dialog -->
    <v-dialog v-model="accountActivateDialog" max-width="600px">
      <v-card class="d-flex flex-column px-8 py-10" style="height: 400px">
        <div class="text-center" style="font-size: 28px; font-weight: 600">
          계정 활성화 필요
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex flex-column align-center justify-center">
          <div style="width: 400px" class="mb-12">
            계정이 비활성화 되어있습니다. <br>
            계정 활성화 메일에서 확인 링크를 클릭하세요.
          </div>
          <div class="d-flex align-center justify-center">
            <v-btn @click="reSendAccountActivateEmail()" color="#2F54EB" dark depressed class="mb-2">
              계정 활성화 메일 재발송
            </v-btn>
          </div>
        </div>
        <v-spacer></v-spacer>
      </v-card>
    </v-dialog>

    <!-- 마이페이지 dialog -->
    <v-dialog v-model="mypageDialog" max-width="500px" :retain-focus="false">
      <v-card v-if="mypageDialog" data-testid="mypage-dialog" style="height: 90vh; max-height: 724px; border-radius: 16px; position: relative; padding: 22px 28px 18px">
        <!-- 취소 버튼 -->
        <div @click="mypageDialog = false"
          class="default-icon-btn d-flex align-center justify-center"
          style="position: absolute; top: 6px; right: 8px; width: 40px; height: 40px"
        >
          <v-icon style="font-size: 20px; color: #8A8DA8">
            mdi-close
          </v-icon>
        </div>
        <!-- title -->
        <div style="font-size: 18px; font-weight: 600; line-height: 24px; color: #0D0E17; margin-bottom: 16px">
          마이페이지
        </div>
        <!-- tabs (내 프로필, 세부 설정, 구독 및 결제) -->
        <div class="d-flex align-center justify-start" style="width: fit-content; height: 36px; background-color: #F8F9FB; border-radius: 8px; padding: 0px 2px; gap: 4px; margin-bottom: 14px">
          <!-- 내 프로필 -->
          <div @click="clickedBtnGroupIdx_mypageDialog = 0"
            class="d-flex align-center justify-center"
            :class="clickedBtnGroupIdx_mypageDialog === 0 ? '' : 'default-group-btn'"
            style="height: 32px; border-radius: 8px; padding: 0px 12px; cursor: pointer"
            :style="clickedBtnGroupIdx_mypageDialog === 0 ? {border: '1px solid #E8EAF2', backgroundColor: '#FFFFFF'} : {border: '1px solid transparent', backgroundColor: 'transparent'}"
          >
            <div style="font-size: 14px; line-height: 18px" :style="clickedBtnGroupIdx_mypageDialog === 0 ? {fontWeight: 600, color: '#0D0E17'} : {fontWeight: 500, color: '#414458'}">
              내 프로필
            </div>
          </div>
          <!-- 세부 설정 -->
          <div @click="clickedBtnGroupIdx_mypageDialog = 1"
            data-testid="mypage-detail-tab-btn"
            class="d-flex align-center justify-center"
            :class="clickedBtnGroupIdx_mypageDialog === 1 ? '' : 'default-group-btn'"
            style="height: 32px; border-radius: 8px; padding: 0px 12px; cursor: pointer"
            :style="clickedBtnGroupIdx_mypageDialog === 1 ? {border: '1px solid #E8EAF2', backgroundColor: '#FFFFFF'} : {border: '1px solid transparent', backgroundColor: 'transparent'}"
          >
            <div style="font-size: 14px; line-height: 18px" :style="clickedBtnGroupIdx_mypageDialog === 1 ? {fontWeight: 600, color: '#0D0E17'} : {fontWeight: 500, color: '#414458'}">
              세부 설정
            </div>
          </div>
          <!-- 구독 및 결제 -->
          <div @click="clickedBtnGroupIdx_mypageDialog = 2"
            class="d-flex align-center justify-center"
            :class="clickedBtnGroupIdx_mypageDialog === 2 ? '' : 'default-group-btn'"
            style="height: 32px; border-radius: 8px; padding: 0px 12px; cursor: pointer"
            :style="clickedBtnGroupIdx_mypageDialog === 2 ? {border: '1px solid #E8EAF2', backgroundColor: '#FFFFFF'} : {border: '1px solid transparent', backgroundColor: 'transparent'}"
          >
            <div style="font-size: 14px; line-height: 18px" :style="clickedBtnGroupIdx_mypageDialog === 2 ? {fontWeight: 600, color: '#0D0E17'} : {fontWeight: 500, color: '#414458'}">
              구독 및 결제
            </div>
          </div>
        </div>
        <!-- 내 프로필 -->
        <div v-if="clickedBtnGroupIdx_mypageDialog === 0" style="height: calc(100% - 90px)">
          <!-- 내용 영역 (스크롤) -->
          <div style="height: calc(100% - 16px - 40px); overflow: hidden auto; padding: 8px 4px; margin-bottom: 16px">
            <!-- picture -->
            <v-avatar :color="$store.state.user_info.personal_color ? `#${$store.state.user_info.personal_color}` : '#2F54EB'" size="60" style="margin-bottom: 16px">
              <img v-if="$store.state.user_info.picture && $store.state.user_info.picture.length > 0" :src="$store.state.user_info.picture" referrerpolicy="no-referrer">
              <div v-else-if="$store.state.user_info.email" style="font-size: 18px; font-weight: 400; line-height: 20px; color: #FFFFFF">
                {{ $store.state.user_info.email[0] }}
              </div>
            </v-avatar>
            <!-- 이름 -->
            <div style="margin-bottom: 16px">
              <!-- title -->
              <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
                이름
              </div>
              <!-- 이름 입력창 및 저장하기 버튼 -->
              <div class="d-flex align-center justify-space-between">
                <!-- 이름 입력창 -->
                <input v-model="userInfo_name" data-testid="mypage-name-input" type="text"
                  @click="clickModifyUserName()" @keyup.enter="modifyUserInfo('name')" @keyup.esc="closeModifyUserName()"
                  @focus="isFocusModifyingUserName = true" @blur="isFocusModifyingUserName = false"
                  class="focus-box-shadow-and-border-color-687EFF input-area"
                  style="width: 180px; height: 32px; background-color: #ffffff; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 12px; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
                >
                <!-- <v-text-field v-model="userInfo_name" data-testid="mypage-name-input"
                  @click="clickModifyUserName()" @keyup.enter="modifyUserInfo('name')" @keyup.esc="closeModifyUserName()"
                  @focus="isFocusModifyingUserName = true" @blur="isFocusModifyingUserName = false"
                  :disabled="isWritingWithdrawalCheckText"
                  height="32px" background-color="#FFFFFF" color="#414458" outlined dense hide-details
                  class="default-input-2" style="max-width: 180px; border-radius: 8px; font-size: 14px"
                ></v-text-field> -->
                <!-- 저장하기 버튼 -->
                <div v-if="$store.state.user_info.name !== userInfo_name || isFocusModifyingUserName" @click="modifyUserInfo('name')"
                  data-testid="mypage-name-save-btn"
                  class="default-white-btn d-flex align-center"
                  style="height: 32px; padding: 0px 12px"
                >
                  <span style="font-size: 14px; line-height: 18px">
                    저장하기
                  </span>
                </div>
              </div>
            </div>
            <!-- 이메일 및 로그인 방식 -->
            <div style="margin-bottom: 16px">
              <!-- title -->
              <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
                이메일
              </div>
              <!-- 이메일 및 로그인 방식 -->
              <div class="d-flex align-center" style="gap: 8px">
                <!-- 이메일 -->
                <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                  {{ $store.state.user_info.email }}
                </div>
                <!-- 로그인 방식 -->
                <div v-if="$store.state.user_info.user_type === 'google'" class="d-flex align-center justify-center" style="height: 20px; border-radius: 4px; background-color: #F0F2FF; padding: 0px 6px">
                  <div style="font-size: 12px; font-weight: 500; line-height: 16px; color: #687EFF">
                    구글로그인
                  </div>
                </div>
              </div>
            </div>
            <!-- 비밀번호 변경 -->
            <div
              v-if="canChangePassword"
              data-testid="mypage-password-change-btn"
              class="default-white-btn d-flex align-center justify-center"
              style="width: 100%; height: 36px; margin-bottom: 16px"
              @click="openPasswordChangeDialog"
            >
              <span style="font-size: 14px; font-weight: 500; line-height: 18px">
                비밀번호 변경
              </span>
            </div>
            <!-- divider -->
            <div style="height: 1px; width: 100%; background-color: #E8EAF2; margin-bottom: 16px"></div>
            <!-- 팀 -->
            <div style="margin-bottom: 16px">
              <!-- title -->
              <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
                팀
              </div>
              <!-- 팀 -->
              <div class="d-flex align-center" style="gap: 2px">
                <!-- root -->
                <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                  {{ $store.state.user_info.organization_root_name }}
                </div>
                <!-- arrow -->
                <v-icon v-if="$store.state.user_info.organization_root !== $store.state.user_info.organization_sub" style="font-size: 18px; color: #8A8DA8">
                  mdi-chevron-right
                </v-icon>
                <!-- sub -->
                <div v-if="$store.state.user_info.organization_root !== $store.state.user_info.organization_sub" style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                  {{ $store.state.user_info.organization_sub_name }}
                </div>
              </div>
            </div>
            <!-- 팀 권한 -->
            <div style="margin-bottom: 16px">
              <!-- title -->
              <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
                팀 권한
              </div>
              <!-- 팀 권한 -->
              <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                {{ $store.state.user_info.organization_permission | organizationPermissionFilter }}
              </div>
            </div>
            <!-- 플랜 -->
            <div style="margin-bottom: 16px">
              <!-- title -->
              <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
                플랜
              </div>
              <!-- 플랜 -->
              <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                {{ $store.state.user_info.plan === 'enterprise' ? '엔터프라이즈' : $store.state.user_info.plan === 'trial' ? '무료체험' : '-' }}
              </div>
            </div>
            <!-- 플랜 시작일 -->
            <div style="margin-bottom: 16px">
              <!-- title -->
              <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
                플랜 시작일
              </div>
              <!-- 플랜 시작일 -->
              <div v-if="$store.state.user_info.paid_start_date" style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                {{ $store.state.user_info.paid_start_date | dateFormatFilter }}
              </div>
              <div v-else style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                -
              </div>
            </div>
            <!-- 기한 만료일 -->
            <div style="margin-bottom: 0px">
              <!-- title -->
              <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
                기한 만료일
              </div>
              <!-- 기한 만료일 -->
              <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                {{ $store.state.user_info.paid_expire_date | dateFormatFilter }}
              </div>
            </div>
          </div>
          <!-- 로그아웃 버튼 -->
          <div @click="clickLogoutBtn()" data-testid="mypage-logout-btn"
            class="default-white-btn d-flex align-center justify-center"
            style="width: 100%; height: 40px"
          >
            <span style="font-size: 14px; line-height: 18px">
              로그아웃
            </span>
          </div>
          <!-- 회원탈퇴 버튼 -->
          <!-- <div class="d-flex align-end justify-center" style="width: 100%">
            <div @click="askWithdrawal()"
              style="font-size: 13px; font-weight: 400; line-height: 18px; color: #ABAEC4; cursor: pointer; margin-top: 10px"
            >
              회원탈퇴
            </div>
          </div> -->
        </div>
        <!-- 세부 설정 -->
        <div v-if="clickedBtnGroupIdx_mypageDialog === 1" style="height: calc(100% - 90px)">
          <div class="d-flex flex-column" style="height: 100%">
            <!-- 내용 영역 -->
            <div style="height: calc(100% - 40px); padding: 8px 4px">
              <!-- 언어 -->
              <div class="d-flex align-center justify-space-between" style="margin-bottom: 16px">
                <!-- title, text -->
                <div>
                  <!-- title -->
                  <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; margin-bottom: 4px">
                    언어
                  </div>
                  <!-- text -->
                  <div style="font-size: 13px; font-weight: 400; line-height: 16px; color: #8A8DA8">
                    리컬럼에서 사용할 언어를 설정할 수 있습니다.
                  </div>
                </div>
                <!-- 언어 dropdown -->
                <div style="width: 98px; height: 32px">
                  <v-menu offset-y bottom>
                    <!-- 선택값 -->
                    <template v-slot:activator="{ on, value }">
                      <div v-on="on" style="width: 100%; height: 100%; position: relative; cursor: pointer">
                        <!-- 선택값 및 아이콘 -->
                        <div class="d-flex align-center justify-space-between"
                          style="width: 100%; height: 100%; overflow: auto hidden; padding: 0px 8px 0px 12px; border-radius: 8px; border: 1px solid #E8EAF2; cursor: pointer"
                        >
                          <!-- 선택값 -->
                          <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                            {{ languageList.filter(v => v.value === userInfo_language)[0].text }}
                          </div>
                          <!-- 아이콘 -->
                          <v-icon :class="value ? 'up' : 'down'" style="font-size: 20px; color: #414458">
                            mdi-chevron-down
                          </v-icon>
                        </div>
                      </div>
                    </template>
                    <!-- 선택 목록 -->
                    <v-card style="width: 100%; overflow: hidden auto">
                      <div v-for="item in languageList" :key="item.value" @click="userInfo_language = item.value">
                        <div class="d-flex align-center justify-start" style="min-height: 40px; padding: 0px 16px; cursor: pointer"
                          :style="item.value === userInfo_language ? {backgroundColor: '#F0F2FF'} : {}"
                        >
                          <!-- text -->
                          <div class="list-item-text"
                            style="font-size: 14px; line-height: 18px; font-weight: 500; color: #414458"
                            :style="item.value === userInfo_language ? {color: '#687EFF', fontWeight: 600} : {}"
                          >
                            {{ item.text }}
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-menu>
                </div>
              </div>
              <!-- divider -->
              <div style="height: 1px; width: 100%; background-color: #E8EAF2; margin-bottom: 16px"></div>
              <!-- 마케팅 정보 수신 동의 -->
              <div class="d-flex align-center justify-space-between" style="margin-bottom: 16px">
                <!-- title, text -->
                <div>
                  <!-- title -->
                  <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; margin-bottom: 4px">
                    마케팅 정보 수신 동의
                  </div>
                  <!-- text -->
                  <div style="font-size: 13px; font-weight: 400; line-height: 16px; color: #8A8DA8">
                    리컬럼의 주요 업데이트 소식이 있을 때 이메일을 받습니다.
                  </div>
                </div>
                <!-- 마케팅 정보 수신 동의 toggle -->
                <toggle-button data-testid="mypage-marketing-toggle"
                  v-model="userInfo_marketingAllowed" @change="changeMarketingAllowedToggle(userInfo_marketingAllowed)"
                  :color="{checked: '#687EFF', unchecked: '#E8EAF2'}"
                  :width="40" :height="20"
                />
              </div>
              <div v-if="isSuperAdminUser" class="d-flex align-center justify-space-between" style="margin-bottom: 16px">
                <div>
                  <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; margin-bottom: 4px">
                    디버깅 로그 <SuperAdminBadge />
                  </div>
                  <div style="font-size: 13px; font-weight: 400; line-height: 16px; color: #8A8DA8">
                    현재 브라우저 세션에서만 console 로그를 표시합니다.
                  </div>
                </div>
                <toggle-button data-testid="mypage-console-debug-toggle"
                  v-model="userInfo_consoleDebugEnabled" @change="changeConsoleDebugToggle(userInfo_consoleDebugEnabled)"
                  :color="{checked: '#687EFF', unchecked: '#E8EAF2'}"
                  :width="40" :height="20"
                />
              </div>
            </div>
            <v-spacer></v-spacer>
            <!-- 저장하기 버튼 -->
            <div @click="modifyUserInfo()"
              data-testid="mypage-detail-save-btn"
              class="default-theme-btn d-flex align-center justify-center"
              style="width: 100%; height: 40px"
              :style="
                (
                  $store.state.user_info.language !== userInfo_language || 
                  $store.state.user_info.marketing_allowed !== userInfo_marketingAllowed
                ) ? {} : 
                {pointerEvents: 'none', backgroundColor: '#D8DDFF !important'}
              "
            >
              <div style="font-size: 14px; line-height: 18px">
                저장하기
              </div>
            </div>
          </div>
        </div>
        <!-- 구독 및 결제 -->
        <div v-if="clickedBtnGroupIdx_mypageDialog === 2" class="d-flex flex-column" style="height: calc(100% - 90px)">
          <!-- 상단 내용 (플랜, 플랜 시작일, 기한 만료일) -->
          <div style="padding: 8px 4px; margin-bottom: 16px">
            <!-- 플랜 -->
            <div style="margin-bottom: 16px">
              <!-- title -->
              <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
                플랜
              </div>
              <!-- 플랜 -->
              <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                {{ $store.state.user_info.plan === 'enterprise' ? '엔터프라이즈' : $store.state.user_info.plan === 'trial' ? '무료체험' : '-' }}
              </div>
            </div>
            <!-- 플랜 시작일 -->
            <div style="margin-bottom: 16px">
              <!-- title -->
              <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
                플랜 시작일
              </div>
              <!-- 플랜 시작일 -->
              <div v-if="$store.state.user_info.paid_start_date" style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                {{ $store.state.user_info.paid_start_date | dateFormatFilter }}
              </div>
              <div v-else style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                -
              </div>
            </div>
            <!-- 기한 만료일 -->
            <div style="margin-bottom: 16px">
              <!-- title -->
              <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
                기한 만료일
              </div>
              <!-- 기한 만료일 -->
              <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                {{ $store.state.user_info.paid_expire_date | dateFormatFilter }}
              </div>
            </div>
            <!-- divider -->
            <div style="height: 1px; width: 100%; background-color: #E8EAF2"></div>
          </div>
          <!-- 하단 내용 (내용 영역 (청구 비용) / 결제하기 버튼) -->
          <div style="flex: 1">
            <!-- 내용 영역 (청구 비용) / 결제하기 버튼 -->
            <div v-if="$store.state.user_info.license_manager.id === $store.state.user_info.pk" class="d-flex flex-column" style="height: 100%">
              <!-- 내용 영역 (청구 비용) -->
              <div style="height: calc(100% - 40px); padding: 0px 4px 8px">
                <!-- 청구 비용 -->
                <div style="margin-bottom: 16px">
                  <!-- title -->
                  <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
                    청구 비용
                  </div>
                  <!-- 청구 비용 -->
                  <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                    {{ $store.state.user_info.license_cost ? $store.state.user_info.license_cost : '-' }}원
                  </div>
                </div>
              </div>
              <v-spacer></v-spacer>
              <!-- 결제하기 버튼 -->
              <div
                class="default-theme-btn d-flex align-center justify-center"
                style="width: 100%; height: 40px"
                :style="true ? {} : {pointerEvents: 'none', backgroundColor: '#D8DDFF !important'}"
              >
                <div style="font-size: 14px; line-height: 18px">
                  결제하기
                </div>
              </div>
            </div>
            <!-- 결제 권한 x -->
            <div v-else class="d-flex align-center justify-center" style="height: 100%">
              <div style="font-size: 14px; font-weight: 500; line-height: 16px; color: #ABAEC4">
                나에게 결제 권한이 없습니다.
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!-- 내용 복사 시 표시 snackbar -->
    <v-snackbar v-model="showCopyCompleteSnackbar" color="success" style="height: 90vh; top: 0">
      <div class="d-flex align-center">
        <v-icon>mdi-checkbox-marked-circle</v-icon>
        <div style="font-size: 16px" class="ml-2">
          내용 복사가 완료되었습니다.
        </div>
      </div>
    </v-snackbar>

    <!-- overlay(default) -->
    <v-overlay :value="$store.state.overlay" style="z-index: 9999">
      <div class="d-flex flex-column align-center" style="backdrop-filter: blur(2px)">
        <div class="mb-2 mx-12" style="font-size: 24px; font-weight: 500; color: #0D0E17">
          {{ $store.state.overlayText }}
        </div>
        <v-progress-linear
          color="#0066FF"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </div>
    </v-overlay>

    <!-- overlay(데이터 업로드) -->
    <v-overlay :value="$store.state.dataUploadOverlay" style="z-index: 9999">
      <div class="d-flex flex-column align-center" style="backdrop-filter: blur(2px)">
        <div class="mb-2 mx-12" style="font-size: 24px; font-weight: 500; color: #0D0E17">
          데이터 업로드 중...
        </div>
        <div class="mb-2 mx-12" style="font-size: 24px; font-weight: 500; color: #0D0E17">
          {{ `${$store.state.currentUploadDataCnt} / ${$store.state.totalUploadDataCnt}` }}
        </div>
        <v-progress-linear
          color="#0066FF"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </div>
    </v-overlay>

    <!-- dark-overlay(프로세스 아이템 변경) -->
    <div v-if="$store.state.darkOverlay" class="dark-overlay"></div>

    <!-- dark-overlay(기본 튜토리얼) -->
    <AuthenticatedPasswordChangeDialog
      v-if="canChangePassword"
      v-model="passwordChangeDialog"
      data-testid="authenticated-password-change-dialog"
      @changed="handlePasswordChanged"
    />

    <div v-if="$store.state.user_info.plan === 'trial' && $store.state.tutorialStep > 0 && $store.state.tutorialStep !== 4 && $store.state.tutorialStep !== 5 && $store.state.tutorialStep !== 6" class="tutorial-dark-overlay"></div>
    
    <!-- dark-overlay(rpa 튜토리얼) -->
    <div v-if="$store.state.user_info.plan === 'trial' && $store.state.rpaTutorialStep > 0" class="rpa-tutorial-dark-overlay"
      :style="
        $store.state.rpaTutorialStep === 3 && $store.state.rpaTutorialHighlightRect.x && $store.state.rpaTutorialHighlightRect.y && $store.state.rpaTutorialHighlightRect.w && $store.state.rpaTutorialHighlightRect.h ? 
        {
          clipPath: // 한붓그리기 형식 - 바깥 사각형 좌표 4개, 내부 사각형으로 들어가기 위한 좌표 1개, 내부 사각형 좌표 4개, 내부 사각형으로 들어가기 위한 좌표 1개
          `polygon(
            0% 0%, 100% 0%, 100% 100%, 0% 100%,
            0% ${$store.state.rpaTutorialHighlightRect.y}px, 
            ${$store.state.rpaTutorialHighlightRect.x}px ${$store.state.rpaTutorialHighlightRect.y}px, ${$store.state.rpaTutorialHighlightRect.x}px calc(${$store.state.rpaTutorialHighlightRect.y}px + ${$store.state.rpaTutorialHighlightRect.h}px), calc(${$store.state.rpaTutorialHighlightRect.x}px + ${$store.state.rpaTutorialHighlightRect.w}px) calc(${$store.state.rpaTutorialHighlightRect.y}px + ${$store.state.rpaTutorialHighlightRect.h}px), calc(${$store.state.rpaTutorialHighlightRect.x}px + ${$store.state.rpaTutorialHighlightRect.w}px) ${$store.state.rpaTutorialHighlightRect.y}px,
            0% ${$store.state.rpaTutorialHighlightRect.y}px
          )`
        } : {}
      "
    ></div>
    <!-- clipPath: `polygon(
      0% 0%, 100% 0%, 100% 100%, 0% 100%,
      0% 36px, 
      326px 36px, 326px calc(36px + 250px), calc(326px + 480px) calc(36px + 250px), calc(326px + 480px) 36px,
      0% 36px
    )` -->

    <!-- dark-overlay(데이터 모드 튜토리얼) -->
    <div v-if="$store.state.user_info.plan === 'trial' && $store.state.dataModeTutorialStep > 0" class="tutorial-dark-overlay"></div>

    <!-- 채널톡 관련 -->
    <div class="channel-talk-btn-3" style="display: hidden"></div>

    <!-- 우측 상단 비동기 작업 목록 패널 -->
    <div v-if="showAsyncTaskStatusListPanel"
      style="position: fixed; top: 8px; right: 16px; z-index: 999; width: 300px; padding: 0px 6px; border-radius: 10px; background-color: #ffffff; box-shadow: 4px 4px 8px 0px #0D0E1729"
    >
      <!-- header (expand btn / close btn) -->
      <div class="d-flex align-center justify-space-between" style="height: 44px; padding: 0px 2px 0px 10px; margin-bottom: 1px">
        <!-- title -->
        <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
          {{
            asyncTaskStatusList_filtered?.filter(v => isAsyncTaskInProgress(v))?.length ?
            `${asyncTaskStatusList_filtered?.filter(v => isAsyncTaskInProgress(v))?.length}개 항목 진행 중` :
            '진행 중인 항목 없음'
          }}
        </div>
        <!-- expand btn -->
        <div v-if="asyncTaskStatusList_filtered?.filter(v => isAsyncTaskInProgress(v))?.length" @click="expandAsyncTaskStatusListPanel = !expandAsyncTaskStatusListPanel"
          class="default-icon-btn d-flex align-center justify-center"
          style="width: 32px; height: 32px"
        >
          <v-icon :class="expandAsyncTaskStatusListPanel ? 'down' : 'up'" style="font-size: 18px; color: #8A8DA8 !important">
            mdi-chevron-up
          </v-icon>
        </div>
        <!-- close btn -->
        <div v-else @click="clickCloseBtn_asyncTaskStatusListPanel()" 
          class="default-icon-btn d-flex align-center justify-center"
          style="width: 32px; height: 32px"
        >
          <v-icon style="font-size: 18px; color: #8A8DA8 !important">
            mdi-close
          </v-icon>
        </div>
      </div>
      <!-- list -->
      <v-expand-transition>
        <div v-show="expandAsyncTaskStatusListPanel">
          <!-- list wrapper -->
          <div class="d-flex flex-column" style="max-height: 200px; overflow: hidden auto; gap: 1px; margin-bottom: 4px">
            <div v-for="async_item in asyncTaskStatusList_filtered" :key="async_item.pk">
              <!-- list item -->
              <v-hover v-slot="{ hover }">
                <div @click="clickAsyncItem(async_item)"
                  class="hover-bg-color d-flex align-center" style="--hover-bg-color: #F8F9FB; height: 56px; padding: 0px 8px; border-radius: 8px; gap: 10px; cursor: pointer"
                >
                  <!-- icon box -->
                  <div class="d-flex align-center justify-center" style="min-width: 38px; height: 38px; border-radius: 8px; border: 1px solid #E8EAF2; background-color: #F8F9FB">
                    <v-icon style="font-size: 20px; color: #414458">
                      {{ async_item.task_type | asyncTaskTypeIconFilter }}
                    </v-icon>
                  </div>
                  <!-- name / status -->
                  <div>
                    <!-- name -->
                    <div style="font-weight: 500; font-size: 14px; line-height: 18px; color: #414458" v-line-clamp="1">
                      {{ async_item.name }}
                    </div>
                    <!-- status -->
                    <div style="font-weight: 400; font-size: 13px; line-height: 16px; color: #8A8DA8; margin-top: 2px">
                      {{ async_item | asyncTaskStatusListPanelStatusFilter }}
                    </div>
                  </div>
                  <v-spacer></v-spacer>
                  <!-- status icon (hover btn) -->
                  <div>
                    <div v-if="!hover || isAsyncTaskInProgress(async_item)">
                      <v-progress-circular v-if="isAsyncTaskInProgress(async_item)"
                        :size="20" :width="2" color="#D8DAE9" indeterminate
                      ></v-progress-circular>
                      <v-icon v-else-if="async_item.status === 'Finished'" style="font-size: 20px; color: #0FC314">
                        mdi-check-circle
                      </v-icon>
                      <v-icon v-else-if="async_item.status?.includes('Error') || async_item.status?.includes('Fail')" style="font-size: 20px; color: #FF0000">
                        mdi-alert-circle
                      </v-icon>
                    </div>
                    <div v-else style="min-width: 50px">
                      <div style="font-size: 13px; font-weight: 400; line-height: 16px; color: #414458">
                        {{
                          async_item.status === 'Running' ? '취소하기' : 
                          async_item.status === 'Finished' ? '결과 보기' : 
                          async_item.status?.includes('Error') || async_item.status?.includes('Fail') ? '확인하기' : 
                          ''
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </v-hover>
            </div>
          </div>
        </div>
      </v-expand-transition>
    </div>
  </v-app>
</template>

<script>
import qs from 'qs'
import axios from "axios"
import http from "@/utils/http-common"
import { isGoogleLoginEnabled, loginWithPassword, logoutDjangoSession } from "@/utils/auth-service";
import { getAuthErrorMessage, normalizeAuthErrorCode } from "@/utils/auth-security-policy.mjs";
import { downloadBlobResponse, getCachedAuthorizedImageSrc, normalizeAuthorizedDownloadUrl, preloadAuthorizedImages } from "@/utils/download"
import { applyMenuPermissionsToDrawerItems, getFirstAccessibleProjectMenu, getProjectMenuRoute } from "@/utils/menu-permission"
import { applyConsolePolicy, isConsoleDebugEnabled, setConsoleDebugEnabled } from "@/utils/console-policy"
import { hasInProgressAsyncTasks, isAsyncTaskInProgress } from "@/policies/async-task-panel-policy.mjs"
import { createAsyncTaskPanelSession, shouldResetAsyncTaskTransitionHistory, startAsyncTaskPanelSession, stopAsyncTaskPanelSession } from "@/policies/async-task-panel-session-policy.mjs"
import { shouldShowLlmChatButton } from "@/policies/llm-chat-visibility-policy.mjs"
import { getRouteViewKey, isTableViewStateOnlyChange, shouldReloadNavigation } from "@/policies/navigation-refresh-policy.mjs"
import Swal from "sweetalert2"
import ChannelService from "@/utils/channel-service"
import LlmChatFloatingPanel from "@/components/LlmChatFloatingPanel.vue"
import NotificationDropdown from "@/components/NotificationDropdown.vue"
import AuthenticatedPasswordChangeDialog from "@/components/AuthenticatedPasswordChangeDialog.vue"
import { canChangeAuthenticatedPassword } from "@/features/authenticated-password-change/authenticated-password-change-domain.mjs"
import { notificationCenterStore } from "@/features/notifications/notification-center-store"
import { isNotificationRouteName, NOTIFICATION_ROUTE_NAMES } from "@/features/notifications/notification-center-domain.mjs"
import { openCSIssueDraft } from '@/views/CSIssueReport/cs-issue-repository'
import { isWorkManagementRouteName as isWorkManagementRouteNamePolicy } from '@/views/WorkManagement/work-management-navigation-policy.mjs'
import { getRoutePolicy, ROUTE_AREA, shouldRunWorkspaceServices } from "@/router/route-policy.mjs"

import dayjs from "dayjs"
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Seoul')

import i18n from "@/i18n"

export default {
  name: "App",
  
  components: {
    AuthenticatedPasswordChangeDialog,
    LlmChatFloatingPanel,
    NotificationDropdown,
  },

  computed: {
    routeViewKey() {
      return getRouteViewKey(this.$route)
    },
    routePolicy() {
      return getRoutePolicy(this.$route)
    },
    isMarketingRoute() {
      return this.routePolicy.area === ROUTE_AREA.MARKETING
    },
    isWorkspaceRoute() {
      return this.routePolicy.area === ROUTE_AREA.WORKSPACE
    },
    isAuthRoute() {
      return this.routePolicy.area === ROUTE_AREA.AUTH
    },
    showPublicNavbar() {
      if (this.$route.meta.standaloneMarketing) return false
      if (this.isMarketingRoute) return true
      if (!this.isAuthRoute) return false
      return !['SignUpCorporation', 'LoginProsecution', 'SignUpProsecution'].includes(this.$route.name)
    },
    showMarketingFooter() {
      if (!this.isMarketingRoute) return false
      const routeName = this.$route.name || ''
      return [
        'LandingPage',
        'LandingPage2',
        'Product',
        'Solution',
        'CustomerExample',
        'CustomerExampleDetail',
        'NewsRoom',
        'NewsRoomDetail',
        'PlanGuide',
        'Voucher',
      ].some(name => routeName === name || routeName.startsWith(name))
    },
    showLlmChatButton() {
      return shouldShowLlmChatButton(process.env.NODE_ENV)
    },
    googleLoginEnabled() {
      return isGoogleLoginEnabled()
    },
    isSuperAdminUser() {
      return this.$store.state.user_info?.organization_permission === 'super_admin'
    },
    canChangePassword() {
      return canChangeAuthenticatedPassword(this.$store.state.user_info?.user_type)
    },

    // 프로젝트 제목 (브라우저 탭 표시용)
    workspaceNavbarRouteNames() {
      return [
        'WorkSpace', 'TeamManagement', 'TotalTrashCan', 'AdminMenu', 'AuditLogAdmin', 'DeletionReportAdmin',
        'TenantCustomerDataDeletionAdmin',
        'CSIssueList', 'CSIssueCreate', 'CSIssueDetail', 'CSIssueStaffRoleManagement', 'Help', ...NOTIFICATION_ROUTE_NAMES,
      ]
    },
    workspaceShellRoute() {
      return this.workspaceNavbarRouteNames.includes(this.$route.name)
    },
    notificationViewportRoute() {
      return isNotificationRouteName(this.$route.name)
    },
    notificationNavbarActive() {
      return isNotificationRouteName(this.$route.name)
    },
    notificationUnreadCount() {
      return Number(notificationCenterStore.state.totalUnread || 0)
    },
    navbarActionRoute() {
      return this.mainRouter || this.workspaceShellRoute
    },
    llmContextSummary() {
      const context = this.$store.state.llmRouteContext
      if (this.$route.name === 'DataManagement' && context?.route_name === 'DataManagement' && context?.files?.length) {
        const firstName = context.files[0]?.name || '선택 파일'
        if (context.files.length === 1) return firstName
        return `${firstName} 외 ${context.files.length - 1}개 파일`
      }
      if (this.$store.state.current_project?.name) return this.$store.state.current_project.name
      return ''
    },
    currentLlmChatMessages() {
      if (!this.selectedLlmConversation) return []
      return this.llmConversationMessageMap[this.selectedLlmConversation.id] || []
    },
    projectTitle() {
      let result = ''
      let env = ''
      if (process.env.NODE_ENV === 'localhost') env = '(local)'
      if (process.env.NODE_ENV === 'development') env = '(dev)'
      // 프로젝트 ID가 있는 경로와 ID 없이 열리는 텍스트 분석 메뉴만 프로젝트 내부로 판단한다.
      const isProjectRoute = this.isWorkspaceRoute && (this.$route.params.pk || this.$route.name === 'Scatter')
      if (isProjectRoute && this.$store.state.current_project && this.$store.state.current_project.name) {
        result = `리컬럼(ReColumn) - 빠르고 정확한 데이터 통합 업무 자동화${env} - ${this.$store.state.current_project.name}`
      } else {
        result = `리컬럼(ReColumn) - 빠르고 정확한 데이터 통합 업무 자동화${env}`
      }
      const routePath = this.$route.path.replace(/^\//, '') || '/'
      return `${result} - ${routePath}`
    },

    // 좌측 메뉴 표시 개수 관련
    drawerItemsCnt() {
      let result = 7
      let _window_innerHeight = this.window_innerHeight
      _window_innerHeight -= 48 // navbar
      _window_innerHeight -= 36 // padding
      if (this.expireDateEndAlert) _window_innerHeight -= 44 // 기한 만료 알림
      console.log('drawerItemsCnt _window_innerHeight', _window_innerHeight)
      let menu_box_height = 53 + 16 // height + gap
      result = Math.floor(_window_innerHeight / menu_box_height)
      result -= 3 // 더 보기, 휴지통, 설정 메뉴 버튼 개수만큼 빼기
      if (result > 7) result = 7
      if (result < 0) result = 0
      console.log('drawerItemsCnt result', result)
      return result
    },

    // 좌측 메뉴 관련
    drawerItems: {
      get() {
        let result = applyMenuPermissionsToDrawerItems(
          this.$store.getters.drawerItems,
          this.$store.state.user_info,
          this.$store.state.current_project,
          { activeRouteName: this.$route.name }
        )
        console.log('drawerItems(App.vue)', result)
        this.$nextTick(() => {
          let el = document.querySelector(`.drawer-scroll-list`)
          if (el) {
            el.addEventListener('scroll', this.scrollBlurLogic)
          }
          this.scrollBlurLogic()
        })
        return result
      },
      set(value) {
        console.log('set drawerItems', value)
      }
    },
    mainRouter() {
      return isWorkManagementRouteNamePolicy(this.$route.name) ||
      this.$route.name === 'DashBoard' ||
      this.$route.name === 'TimeLine' || 
      this.$route.name === 'DataManagement' || 
      this.$route.name === 'Process' || 
      this.$route.name === 'WorkManagementLayout' ||
      this.$route.name === 'WorkManagement' ||
      this.$route.name === 'MyWorkItems' ||
      this.$route.name === 'WorkNotifications' ||
      this.$route.name === 'WorkExternalEvents' ||
      this.$route.name === 'WorkDetail' ||
      this.$route.name === 'WorkItemRedirect' ||
      this.$route.name === 'WorkTemplateLayout' ||
      this.$route.name === 'WorkTemplateList' ||
      this.$route.name === 'WorkTemplateCreate' ||
      this.$route.name === 'WorkTemplateDetail' ||
      this.$route.name === 'WorkTemplatePublish' ||
      this.$route.name === 'InsightList' || 
      this.$route.name === 'Insight' || 
      this.$route.name === 'Insight' || 
      this.$route.name === 'AiAgent' || 
      this.$route.name === 'AsyncTaskLogDetail' || 
      this.$route.name === 'RpaList' ||
      this.$route.name === 'Rpa' ||
      this.$route.name === 'RpaMain' ||
      this.$route.name === 'RpaMain3' ||
      this.$route.name === 'RpaOperate' ||
      this.$route.name === 'RpaResult' ||
      this.$route.name === 'RpaTerminology' ||
      this.$route.name === 'RpaTotalResult' ||
      this.$route.name === 'Estimate' ||
      this.$route.name === 'FormList' ||
      this.$route.name === 'Form' ||
      this.$route.name === 'Table' ||
      this.$route.name === 'EmailVerify' ||
      this.$route.name === 'TableDetection' ||
      this.$route.name === 'DetectionResult' ||
      this.$route.name === 'InnerDb' ||
      this.$route.name === 'Ocr' ||
      this.$route.name === 'PdfClassification' ||
      this.$route.name === 'Custom' ||
      this.$route.name === 'IrosSearch' ||
      this.$route.name === 'MouList' ||
      this.$route.name === 'CorporateSalesStatus' ||
      this.$route.name === 'Extraction' || 
      this.$route.name === 'Keyword' || 
      this.$route.name === 'Summary' || 
      this.$route.name === 'Scatter' ||
      this.$route.name === 'ProjectTrashCan' ||
      this.$route.name === 'ProjectManagement'
    },

    // 좌측 메뉴 (무료체험 유저 전용)
    drawerItems_trial: {
      get() {
        let result = [
          { title: '타임라인', value: 'dashboard',
            icon: 'mdi-clock-star-four-points-outline',
            to: `/dashboard/${this.$store.state.current_project_pk}`,
            routeName: 'DashBoard',
          },
          { title: '데이터', value: 'data-management',
            icon: 'mdi-database-outline',
            to: `/data-management/${this.$store.state.current_project_pk}`,
            routeName: 'DataManagement',
            tutorial_step: 7,
          },
          { title: '프로세스', value: 'process',
            icon: 'mdi-sitemap-outline',
            to: `/process/${this.$store.state.current_project_pk}`,
            routeName: 'Process',
          },
          { title: '인사이트', value: 'insight',
            icon: 'mdi-lightbulb-outline',
            to: `/insight/${this.$store.state.current_project_pk}`,
            routeName: 'Insight',
          },
          { title: 'AI Agent', value: 'ai-engine',
            icon: 'mdi-robot-excited-outline',
            to: `/ai-agent/${this.$store.state.current_project_pk}`,
            routeName: 'AiAgent',
          },
          { title: '워크플로우', value: 'rpa2', // RPA2
            icon: 'mdi-play-circle-outline',
            to: `/rpa/${this.$store.state.current_project_pk}`,
            routeName: 'RpaList',
            tutorial_step: 2,
          },
          { title: 'Inner DB', value: 'inner-db',
            icon: 'mdi-database-edit-outline',
            to: `/inner-db/${this.$store.state.current_project_pk}`,
            routeName: 'InnerDb',
          },
          { title: 'OCR', value: 'group-ocr',
            icon: 'mdi-image-sync-outline',
            active: false,
            childActive: false,
            children: [
              { title: 'OCR', value: 'ocr', parent_value: 'group-ocr',
                icon: 'mdi-ocr',
                to: `/ocr/${this.$store.state.current_project_pk}`,
                routeName: 'Ocr',
              },
              { title: 'PDF 분류', value: 'pdf-classification', parent_value: 'group-ocr',
                icon: 'mdi-file-search-outline',
                to: `/pdf-classification/${this.$store.state.current_project_pk}`,
                routeName: 'PdfClassification',
              },
            ],
          },
          { title: '커스텀', value: 'group-custom',
            icon: 'mdi-star-four-points-outline',
            active: false,
            childActive: false,
            children: [
              { title: 'IROS 검색', value: 'iros-search', parent_value: 'group-custom',
                icon: 'mdi-clipboard-text-search-outline',
                to: `/iros-search/${this.$store.state.current_project_pk}`,
                routeName: 'IrosSearch',
              },
              { title: 'MOU 리스트', value: 'mou-list', parent_value: 'group-custom',
                icon: 'mdi-handshake',
                to: `/mou-list/${this.$store.state.current_project_pk}`,
                routeName: 'MouList',
              },
              { title: '법인판매현황', value: 'corporate-sales-status', parent_value: 'group-custom',
                icon: 'mdi-format-list-checks',
                to: `/corporate-sales-status/${this.$store.state.current_project_pk}`,
                routeName: 'CorporateSalesStatus',
              },
            ],
          },
          { title: '텍스트 분석', value: 'group-text-analyze',
            icon: 'mdi-file-document-check-outline',
            active: false,
            childActive: false,
            children: [
              { title: '정보 추출', value: 'extraction', parent_value: 'group-text-analyze',
                icon: 'mdi-alpha-e-circle',
                to: `/extraction/${this.$store.state.current_project_pk}/1`,
                routeName: 'Extraction',
              },
              { title: '키워드', value: 'keyword', parent_value: 'group-text-analyze',
                icon: 'mdi-alpha-k-circle',
                to: `/keyword/${this.$store.state.current_project_pk}/1`,
                routeName: 'Keyword',
              },
              { title: '요약', value: 'summary', parent_value: 'group-text-analyze',
                icon: 'mdi-alpha-s-circle',
                to: `/summary/${this.$store.state.current_project_pk}/1`,
                routeName: 'Summary',
              },
              { title: '텍스트 분석', value: 'scatter', parent_value: 'group-text-analyze',
                icon: 'mdi-chart-scatter-plot',
                to: '/scatter',
                routeName: 'Scatter',
              },
            ],
          },
          { title: 'RPA', value: 'rpa',
            icon: 'mdi-refresh-auto',
            to: `/rpa/${this.$store.state.current_project_pk}`,
            routeName: 'LegacyRpaList',
          },
        ]

        result = applyMenuPermissionsToDrawerItems(
          result,
          this.$store.state.user_info,
          this.$store.state.current_project,
          { showDisabled: true, activeRouteName: this.$route.name }
        )

        console.log('drawerItems_trial', result)
        this.$nextTick(() => {
          let el = document.querySelector(`.drawer-scroll-list`)
          if (el) {
            el.addEventListener('scroll', this.scrollBlurLogic)
          }
          this.scrollBlurLogic()
        })
        return result
      },
      set(value) {
        console.log('set drawerItems_trial', value)
      }
    },

    // 프로젝트 목록 정렬
    projectListOrder: {
      get() {
        let result = this.$store.state.user_info?.sort_json?.projectListOrder ?? '-updated_at'
        console.log('projectListOrder result', result)
        return result
      },
      set(value) {
        this.$store.dispatch('updateUserSortValue', { key: 'projectListOrder', value })
      }
    },
    // 워크플로우 목록 정렬
    rpaListOrder: {
      get() {
        let result = this.$store.state.user_info?.sort_json?.rpaListOrder ?? '-updated_at'
        console.log('rpaListOrder result', result)
        return result
      },
      set(value) {
        this.$store.dispatch('updateUserSortValue', { key: 'rpaListOrder', value })
      }
    },
    // 숨긴 워크플로우 보기 여부
    isShowHiddenRpa() {
      let result = this.$store.state.user_info?.sort_json?.isShowHiddenRpa ?? false
      console.log('isShowHiddenRpa result', result)
      return result
    },
    canShowHiddenRpa() {
      return this.$store.getters.permissionLevel >= 3 && this.isShowHiddenRpa
    },
    visibleWorkflowList() {
      return this.canShowHiddenRpa ? this.workflowList : this.workflowList.filter(v => !v.is_hidden)
    },
    // 인사이트 목록 정렬
    insightListOrder: {
      get() {
        let result = this.$store.state.user_info?.sort_json?.insightListOrder ?? '-updated_at'
        console.log('insightListOrder result', result)
        return result
      },
      set(value) {
        this.$store.dispatch('updateUserSortValue', { key: 'insightListOrder', value })
      }
    },

    // 기한 만료 n일 이내인 경우 표시되는 상단 alert
    expireDateEndAlert: {
      get() {
        let result = this.$store.state.user_info?.sort_json?.expireDateEndAlert ?? false
        console.log('expireDateEndAlert result', result)
        return result
      },
      set(value) {
        this.$store.dispatch('updateUserSortValue', { key: 'expireDateEndAlert', value })
      }
    },
    // 기한 만료 n일 이내인 경우 표시되는 dialog
    expireDateEndDialog: {
      get() {
        let result = this.$store.state.user_info?.sort_json?.expireDateEndDialog ?? false
        console.log('expireDateEndDialog result', result)
        return result
      },
      set(value) {
        this.$store.dispatch('updateUserSortValue', { key: 'expireDateEndDialog', value })
      }
    },

    // 비동기 작업 목록 패널 표시
    showAsyncTaskStatusListPanel: {
      get() {
        return this.$store.state.showAsyncTaskStatusListPanel ?? false
      },
      set(value) {
        this.$store.commit('set_showAsyncTaskStatusListPanel', value)
      }
    },
    asyncTaskStatusList_filtered() {
      let result = []
      if (Array.isArray(this.asyncTaskStatusList)) {
        const hasScopedAsyncTaskPanelSession = this.asyncTaskPanelSession.status === 'tracking'
        const hasProjectContext = Boolean(this.$store.state.current_project_pk || this.asyncTaskPanelSession.projectPk || this.$route.params.pk)
        // 프로젝트 외부
        if (!hasScopedAsyncTaskPanelSession && (!this.mainRouter || !hasProjectContext)) {
          result = this.asyncTaskStatusList.filter(v => 
            !v.is_read &&
            v.task_type === 'project' && 
            (
              isAsyncTaskInProgress(v) ||
              v.status === 'Finished' || 
              v.status?.includes('Error') || v.status?.includes('Fail')
            )
          )
        }
        // 프로젝트 내부
        else {
          result = this.asyncTaskStatusList.filter(v => 
            !v.is_read &&
            (
              isAsyncTaskInProgress(v) ||
              (v.status === 'Finished' && v.task_type === 'project') || 
              (v.status === 'Finished' && v.task_type !== 'project' && v.result) || 
              v.status?.includes('Error') || v.status?.includes('Fail')
            )
          )
        }
      }
      console.log('asyncTaskStatusList_filtered', result)
      return result
    },
  },

  data() {
    return {
      lead_badge_cnt: null,
      userInfo_consoleDebugEnabled: false,

      showLlmChatPanel: false,
      isSendingLlmChat: false,
      selectedLlmConversation: null,
      llmConversationList: [
        { id: 1, title: '매출 데이터에서 주목할 만한 부분', date: '2026-02-24' },
        { id: 2, title: '파일에서 비즈니스 인사이트를 도출할 수 있게 집계', date: '2026-02-24' },
        { id: 3, title: '지금 보고 있는 데이터를 집계할 방법 추천 받기', date: '2026-02-24' },
        { id: 4, title: '이 프로젝트에서 원하는 파일 찾기', date: '2026-02-24' },
      ],
      llmConversationMessageMap: {},
      llmNextConversationId: 4,

      fontReady: false,

      // 상단 공지
      top_alert: false,
      top_alert_height: '50px',
      top_alert_due: '2026-09-11 17:00:00',

      // 마이페이지 dialog 관련
      mypageDialog: false,
      passwordChangeDialog: false,
      clickedBtnGroupIdx_mypageDialog: 0, // 탭 - 0: 내 프로필, 1: 세부 설정, 2: 구독 및 결제
      userInfo_name: '', // 내 프로필 > 이름 수정 관련 (this.$store.state.user_info.name)
      isFocusModifyingUserName: false, // 내 프로필 > 이름 수정 관련
      languageList: [ // 세부 설정 > 언어 dropdown 목록
        { text: '한국어', value: 'ko' },
        { text: '영어', value: 'en' },
      ],
      userInfo_language: 'ko', // 세부 설정 > 언어 dropdown 선택값
      userInfo_marketingAllowed: false, // 세부 설정 > 마케팅 정보 수신 동의 toggle

      // 무료체험 요청하기 dialog 관련
      demoRequestDialog: false,
      emailInput: '',
      sendTrialEmailFlag: 0,

      // 텍스트 복사 성공 alert 관련
      showAlert: false,

      // navbar > hamburger 메뉴 관련
      isShowHamburgerMenu: false,

      // 프로젝트 이름 관련
      showPjtFullName: false,
      isHoverHeaderMenu: false,

      // 프로젝트 dropdown 관련
      projectDropdownMenu: false,
      // 프로젝트 검색 관련
      searchPjtNameInput: '',
      searchedPjtName: '',
      isSearchingPjt: false,
      // 프로젝트 목록
      projectList: [],
      loadingProjectList: false,
      projectIconListPromise: null,
      authorizedImageSrcMap: {},

      // 워크플로우 dropdown 관련
      workflowDropdownMenu: false,
      // 워크플로우 검색 관련
      searchWorkflowNameInput: '',
      searchedWorkflowName: '',
      isSearchingWorkflow: false,
      // 워크플로우 목록
      workflowList: [],
      loadingWorkflowList: false,

      // 인사이트 dropdown 관련
      insightDropdownMenu: false,
      // 인사이트 검색 관련
      searchInsightNameInput: '',
      searchedInsightName: '',
      isSearchingInsight: false,
      // 인사이트 목록
      insightList: [],
      folderList: [],
      isLoadingInsightList: false,

      isShowScrollBlur: false,
      drawer_key: Math.floor(Math.random() * Math.floor(Number.MAX_SAFE_INTEGER)),
      drawer_list_key: Math.floor(Math.random() * Math.floor(Number.MAX_SAFE_INTEGER)),

      loginDialog: false,
      userEmailInput: '',
      userPasswordInput: '',
      showUserPasswordInput: false,

      findPasswordDialog: false,

      accountActivateDialog: false,

      // 내용 복사 시 표시 snackbar
      showCopyCompleteSnackbar: false,

      // 튜토리얼 및 문의하기 메뉴 관련
      tutorialAndContactMenu: false,

      // 튜토리얼 시작 dialog 관련
      tutorialStartDialog: false,

      // 회원탈퇴 버튼 클릭 시 이름 input 창 disable 처리 관련
      isWritingWithdrawalCheckText: false,

      // 비활성화 계정 dialog 관련
      // deactivatedAccountDialog: false,

      // 문의하기 dialog 관련
      contactDialog: false,
      contactDialog_inquiryInput: '', // 문의 내용
      contactDialog_answerPath: '전화', // 원하시는 답변 경로
      contactDialog_answerPath_optionList: [ // 원하시는 답변 경로 옵션 목록
        { text: '전화', value: '전화' },
        { text: '메일', value: '메일' },
        { text: '구글 미트', value: '구글 미트' },
      ],
      contactDialog_ableTimeInput: '', // 통화 가능한 시간
      contactDialog_contactInput: '', // 연락처(전화번호, 이메일)
      contactDialog_privacyPolicy: false, // 개인정보처리방침 동의
      // 문의하기 완료 dialog 관련
      contactDialog_success: false,

      // 리컬럼 소개서 받아보기 dialog 관련
      manualDownloadDialog: false,
      manualDownloadDialog_language: '한글(KOR)', // '영어(ENG)'
      manualDownloadDialog_nameInput: '',
      manualDownloadDialog_emailInput: '',
      manualDownloadDialog_companyInput: '',
      manualDownloadDialog_positionInput: '',
      manualDownloadDialog_phoneNumberInput: '',
      manualDownloadDialog_privacyPolicy: false,
      manualDownloadDialog_marketingReception: false,

      // 공통
      nameInputFocused: false,
      emailInputFocused: false,
      companyInputFocused: false,
      positionInputFocused: false,
      phoneNumberInputFocused: false,

      isMobile: false,
      window_innerWidth: null,
      window_innerHeight: null,

      // 비동기 작업 관련
      // showAsyncTaskStatusListPanel: false, // 우측 상단 비동기 작업 목록 패널 표시 여부
      expandAsyncTaskStatusListPanel: true, // 우측 상단 비동기 작업 목록 패널 expand 여부
      asyncTaskStatusList: [], // 비동기 작업 목록
      asyncTaskStatusListPreviousInProgressKeys: [],
      asyncTaskPanelSession: createAsyncTaskPanelSession(),
      asyncTaskStatusListRefreshInterval: null, // 비동기 작업 목록 조회 api interval 호출 여부
      asyncTaskStatusListRefreshDelay: 5000, // 비동기 작업 목록 조회 api 호출 interval
    }
  },
  
  methods: {
    bootPublicChannelService() {
      const publicChannelConfig = {
        pluginKey: process.env.VUE_APP_CHANNEL_SERVICE_PLUGIN_ID,
        customLauncherSelector: ".channel-talk-btn-3",
      }
      if (this.$store.getters.isLoggedIn) {
        publicChannelConfig.memberId = this.$store.state.user_info.pk
        publicChannelConfig.profile = {
          name: this.$store.state.user_info.name,
        }
      }
      ChannelService.boot(publicChannelConfig)
    },
    projectRouteLabel() {
      const routeName = this.$route.name || ''
      const labels = {
        DashBoard: '타임라인',
        DataManagement: '데이터',
        Rpa: '워크플로우 목록',
        RpaList: '워크플로우 목록',
        RpaMain: '워크플로우 설계',
        RpaMain3: '워크플로우 설계',
        RpaOperate: '워크플로우 실행',
        RpaResult: '워크플로우 결과',
        WorkManagement: '업무',
        InsightList: '인사이트',
        Insight: '인사이트',
        AiAgent: 'AI Agent',
        ProjectManagement: '프로젝트 관리',
      }
      return labels[routeName] || routeName || '프로젝트 화면'
    },
    openProjectCSIssue() {
      const currentProject = this.$store.state.current_project || {}
      const projectId = currentProject.pk ?? currentProject.id ?? this.$store.state.current_project_pk
      const payload = {
        project: projectId == null ? null : {
          id: projectId,
          pk: projectId,
          name: currentProject.name || this.$store.state.current_project_title || '현재 프로젝트',
        },
        originScreen: {
          name: this.projectRouteLabel(),
          routeName: this.$route.name || '',
          path: this.$route.fullPath || this.$route.path || '',
        },
      }
      try {
        const routeContext = this.$refs.routerView?.getCSIssueContext?.()
        if (routeContext && typeof routeContext === 'object') Object.assign(payload, routeContext)
      } catch (error) {
        console.warn('CS 문의 화면 컨텍스트를 수집하지 못했습니다.', error)
      }
      return openCSIssueDraft(this.$router, 'project-navbar', payload)
    },
    isAsyncTaskInProgress(asyncTask = {}) {
      return isAsyncTaskInProgress(asyncTask)
    },
    getAuthorizedImageSrc(src, fallback = '') {
      const normalizedUrl = normalizeAuthorizedDownloadUrl(src)
      if (!normalizedUrl) return fallback

      return this.authorizedImageSrcMap[normalizedUrl] || getCachedAuthorizedImageSrc(normalizedUrl) || fallback
    },
    preloadProjectImageUrls(urls = [], options = {}) {
      const uniqueUrls = Array.from(new Set(
        urls
          .map(url => normalizeAuthorizedDownloadUrl(url))
          .filter(Boolean)
      ))

      if (!uniqueUrls.length) return Promise.resolve([])

      return preloadAuthorizedImages(uniqueUrls, options).then((results) => {
        results.forEach((result) => {
          if (result.status === 'fulfilled' && result.normalizedUrl && result.objectUrl) {
            this.$set(this.authorizedImageSrcMap, result.normalizedUrl, result.objectUrl)
          }
        })

        return results
      })
    },
    getProjectIconListForCache(options = {}) {
      const force = options.force === true

      if (!force && this.$store.state.project_icon_list && this.$store.state.project_icon_list.length) {
        return Promise.resolve(this.$store.state.project_icon_list)
      }
      if (this.projectIconListPromise) return this.projectIconListPromise

      this.projectIconListPromise = http
      .get('annotation/project-icon/', { params: {}, headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
      .then(async res => {
        const projectIconList = res.data.sort((a, b) => a.id - b.id).map(v => ({
          ...v,
          file: normalizeAuthorizedDownloadUrl(v.file),
        }))
        const preloadResults = await this.preloadProjectImageUrls(projectIconList.map(v => v.file), { force })
        const projectIconImageUrls = preloadResults
          .filter(result => result.status === 'fulfilled' && result.normalizedUrl && result.objectUrl)
          .map(result => result.normalizedUrl)

        this.$store.commit('setProjectIconList', projectIconList)
        this.$store.commit('setProjectIconImageUrls', projectIconImageUrls)
        return projectIconList
      })
      .finally(() => {
        this.projectIconListPromise = null
      })

      return this.projectIconListPromise
    },
    ensureProjectIconImages() {
      return this.getProjectIconListForCache()
        .then(() => this.preloadProjectImageUrls([this.$store.state.current_project && this.$store.state.current_project.icon_url]))
    },
    getNavbarDropdownCardStyle(width) {
      const viewportHeight = this.window_innerHeight || (typeof window !== 'undefined' ? window.innerHeight : 620)
      const navHeight = 48
      const alertHeight = this.expireDateEndAlert ? 44 : 0
      const maxHeight = Math.min(600, Math.max(160, viewportHeight - navHeight - alertHeight - 16))
      return {
        width,
        maxHeight: `${maxHeight}px`,
        overflowX: 'hidden',
        overflowY: 'auto',
        position: 'relative',
      }
    },
    isWorkManagementRouteName(routeName = this.$route.name) {
      return isWorkManagementRouteNamePolicy(routeName)
    },
    isDrawerMenuActive(menu) {
      if (!menu) return false
      if (this.$route.name === menu.routeName) return true
      if (this.isWorkManagementRouteName() && (
        menu.value === 'work' ||
        menu.routeName === 'WorkManagement' ||
        String(menu.to || '').includes('/work-management/')
      )) return true
      if (this.$route.name === 'Rpa' && menu.routeName === 'RpaList') return true
      if (this.$route.name === 'RpaMain' && menu.routeName === 'RpaList') return true
      if (this.$route.name === 'RpaMain3' && menu.routeName === 'RpaList') return true
      if (this.$route.name === 'Form' && menu.routeName === 'FormList') return true
      if (this.$route.name === 'Insight' && menu.routeName === 'InsightList') return true
      if (this.$route.name === 'AsyncTaskLogDetail' && menu.routeName === 'AiAgent') return true
      return false
    },
    clickLlmChatBtn() {
      this.showLlmChatPanel = !this.showLlmChatPanel
    },
    closeLlmChatPanel() {
      this.showLlmChatPanel = false
    },
    getLlmMessageTimeText() {
      const now = new Date()
      const period = now.getHours() < 12 ? '오전' : '오후'
      const hour = now.getHours() % 12 || 12
      const minute = String(now.getMinutes()).padStart(2, '0')
      return `오늘 ${period} ${hour}:${minute}`
    },
    createLlmMessage(role, content) {
      return {
        id: `${role}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        role,
        content,
        timeText: this.getLlmMessageTimeText(),
      }
    },
    getLlmConversationTitle(message) {
      const normalizedMessage = String(message || '').replace(/\s+/g, ' ').trim()
      if (!normalizedMessage) return '새 대화'
      if (normalizedMessage.length <= 24) return normalizedMessage
      return `${normalizedMessage.slice(0, 24)}...`
    },
    ensureLlmConversation() {
      if (this.selectedLlmConversation) return this.selectedLlmConversation

      const conversation = {
        id: this.llmNextConversationId,
        title: '새 대화',
        date: dayjs().format('YYYY-MM-DD'),
      }
      this.llmNextConversationId += 1
      this.llmConversationList = [conversation, ...this.llmConversationList]
      this.selectedLlmConversation = conversation
      this.$set(this.llmConversationMessageMap, conversation.id, [])

      return conversation
    },
    loadDummyLlmConversationMessages(conversation) {
      if (!conversation || this.llmConversationMessageMap[conversation.id]) return

      this.$set(this.llmConversationMessageMap, conversation.id, [
        this.createLlmMessage('user', conversation.title),
        this.createLlmMessage('assistant', '선택한 대화의 더미 대화 내역입니다. 실제 API 연동 전까지 기본 응답으로 표시됩니다.'),
      ])
    },
    selectLlmConversation(conversation) {
      this.selectedLlmConversation = conversation
      this.loadDummyLlmConversationMessages(conversation)
    },
    startNewLlmConversation() {
      this.selectedLlmConversation = null
      this.isSendingLlmChat = false
    },
    deleteLlmConversation(conversation) {
      if (!conversation) return

      this.llmConversationList = this.llmConversationList.filter(v => v.id !== conversation.id)
      if (this.llmConversationMessageMap[conversation.id]) {
        this.$delete(this.llmConversationMessageMap, conversation.id)
      }
      if (this.selectedLlmConversation?.id === conversation.id) {
        this.startNewLlmConversation()
      }
    },
    buildLlmChatRequestBody(message) {
      const body = {
        message,
        route_name: this.$route.name,
        project: this.$store.state.current_project_pk || this.$route.params?.pk || null,
        route_params: { ...(this.$route.params || {}) },
        route_query: { ...(this.$route.query || {}) },
      }

      const routeContext = this.$store.state.llmRouteContext
      if (routeContext && routeContext.route_name === this.$route.name) {
        body.context = {}
        if (routeContext.file_ids) body.context.file_ids = routeContext.file_ids
        if (routeContext.files) body.context.files = routeContext.files
      }

      return body
    },
    sendLlmChatMessage(message) {
      if (!message || this.isSendingLlmChat) return

      const conversation = this.ensureLlmConversation()
      if (!this.llmConversationMessageMap[conversation.id]) {
        this.$set(this.llmConversationMessageMap, conversation.id, [])
      }

      if (conversation.title === '새 대화') {
        conversation.title = this.getLlmConversationTitle(message)
      }

      const requestBody = {
        conversation_id: conversation.id,
        message,
      }
      console.log('sendLlmChatMessage dummy request body', requestBody)

      const nextMessages = [
        ...(this.llmConversationMessageMap[conversation.id] || []),
        this.createLlmMessage('user', message),
      ]
      this.$set(this.llmConversationMessageMap, conversation.id, nextMessages)
      this.isSendingLlmChat = true

      window.setTimeout(() => {
        if (!this.llmConversationList.some(v => v.id === conversation.id)) {
          this.isSendingLlmChat = false
          return
        }

        const messages = this.llmConversationMessageMap[conversation.id] || []
        this.$set(this.llmConversationMessageMap, conversation.id, [
          ...messages,
          this.createLlmMessage('assistant', '요청하신 내용을 기준으로 생성한 기본 더미 응답입니다. 실제 LLM API 연동 전까지 이 응답이 표시됩니다.'),
        ])
        this.isSendingLlmChat = false
      }, 500)
    },
    getProductInquiryUnprocessedCount() {
      return new Promise((resolve, reject) => {
        console.log('getProductInquiryUnprocessedCount')
        http.get('account/product-inquiry/unprocessed-count/',
          {
            headers: { Authorization: 'Bearer ' + this.$store.state.access_token },
          }
        )
        .then(async res => {
          console.log('getProductInquiryUnprocessedCount res', res)
          this.lead_badge_cnt = res.data.total
          console.log('lead_badge_cnt', this.lead_badge_cnt)
          resolve(res)
        })
        .catch(err => {
          if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) {
            this.methodRecall()
            .then(() => this.getProductInquiryUnprocessedCount())
            .catch(e => { if (e === 1) { this.$store.commit('logout'); this.$router.push('/').catch(() => {}) } })
          }
          reject(err)
        })
      })
    },
    refreshLeadBadgeCountIfNeeded(routeName = this.$route.name) {
      if (
        this.$store.getters.isLoggedIn &&
        this.$store.state.user_info.organization_permission === 'super_admin' &&
        this.workspaceNavbarRouteNames.includes(routeName)
      ) {
        this.getProductInquiryUnprocessedCount()
      }
    },
    refreshNotificationSummaryIfNeeded() {
      if (!this.$store.getters.isLoggedIn || !this.navbarActionRoute) return Promise.resolve()
      return notificationCenterStore.refreshSummary({
        userId: this.$store.state.user_info?.pk || this.$store.state.user_info?.id,
        permission: this.$store.state.user_info?.organization_permission,
      })
    },

    // 상단 공지 클릭
    clickTopAlert() {
      console.log('clickTopAlert')
      let fileUrl = ''
      // 링크
      fileUrl = 'https://www.recolumn.com/assets/swcc2026_invitation.jpg'
      // HTML 파일 경로
      // fileUrl = '/WIS 2025_Online Invitation_KR.html' // public 폴더 기준
      // 이미지 파일 경로
      // fileUrl = '/NextRise2025.png' // public 폴더 기준

      // 새 창에서 열기
      window.open(fileUrl, '_blank')
    },
    // 상단 공지 클릭
    clickTopAlert_sub() {
      console.log('clickTopAlert_sub')
      let fileUrl = ''
      // 링크
      // fileUrl = 'https://www.nextrise.co.kr/ko'
      // HTML 파일 경로
      // fileUrl = '/WIS 2025_Online Invitation_KR.html' // public 폴더 기준
      // 이미지 파일 경로
      // fileUrl = '/NextRise2025.png' // public 폴더 기준

      // 새 창에서 열기
      window.open(fileUrl, '_blank')
    },
    // 상단 공지 > 특정 일자 까지만 표시하는 로직
    set_top_alert() {
      console.log('set_top_alert')
      const target_time = dayjs(this.top_alert_due)
      const now = dayjs()
      if (now.isAfter(target_time)) {
        this.top_alert = false
      } else {
        this.top_alert = true
      }
      console.log('top_alert', this.top_alert)
    },

    // 리컬럼 로고 클릭
    middleClickNavLogo() {
      const path = this.isMarketingRoute || !this.$store.getters.isLoggedIn ? '/' : '/workspace'
      window.open(path, '_blank')
    },
    clickNavLogo($event) {
      console.log('clickNavLogo')
      if ($event && ($event.metaKey || $event.ctrlKey)) {
        const path = this.isMarketingRoute || !this.$store.getters.isLoggedIn ? '/' : '/workspace'
        window.open(path, '_blank', 'noopener')
        return
      }
      if (this.isMarketingRoute || !this.$store.getters.isLoggedIn) {
        this.$router.push('/')
        .then(() => { window.scrollTo(0,0) })
        .catch(() => { this.$router.go(0) })
      } else {
        if (this.$route.path === '/workspace') {
          this.$router.go(0)
        } else {
          this.goWorkSpace()
        }
      }
    },
    // 제품 > 상세 페이지 이동
    goProductPage(value) {
      console.log('goProductPage', value)
      this.$router.push(value)
      .then(() => { window.scrollTo(0,0) })
      .catch(() => {})
    },
    // 제품 > 솔루션 페이지 이동
    goSolutionPage(value) {
      console.log('goSolutionPage', value)
      this.$router.push(value)
      .then(() => { window.scrollTo(0,0) })
      .catch(() => {})
    },
    // 고객사례 페이지 이동
    goCustomerExample() {
      console.log('goCustomerExample')
      this.$router.push('/customer-example')
      .then(() => { window.scrollTo(0,0) })
      .catch(() => {})
    },
    // 플랜안내 페이지 이동
    goPlanGuide() {
      console.log('goPlanGuide')
      this.$router.push('/plan-guide')
      .then(() => { window.scrollTo(0,0) })
      .catch(() => {})
    },
    // 자주 묻는 질문 페이지 이동
    goFAQ() {
      console.log('goFAQ')
      // this.$router.push('/faq')
      // .then(() => { window.scrollTo(0,0) })
      // .catch(() => {})
    },
    // 뉴스룸 페이지 이동
    goNewsRoom() {
      console.log('goNewsRoom')
      this.$router.push('/news-room')
      .then(() => { window.scrollTo(0,0) })
      .catch(() => {})
    },
    // 바우처 페이지 이동
    goVoucher() {
      console.log('goVoucher')
      this.$router.push('/voucher')
      .then(() => { window.scrollTo(0,0) })
      .catch(() => {})
    },

    // 리컬럼 소개서 다운로드 버튼 클릭
    clickManualDownloadBtn() {
      console.log('clickManualDownloadBtn')
      console.log('manualDownloadDialog_language', this.manualDownloadDialog_language)
      console.log('manualDownloadDialog_nameInput', this.manualDownloadDialog_nameInput)
      console.log('manualDownloadDialog_emailInput', this.manualDownloadDialog_emailInput)
      console.log('manualDownloadDialog_companyInput', this.manualDownloadDialog_companyInput)
      console.log('manualDownloadDialog_positionInput', this.manualDownloadDialog_positionInput)
      console.log('manualDownloadDialog_phoneNumberInput', this.manualDownloadDialog_phoneNumberInput)
      console.log('manualDownloadDialog_privacyPolicy', this.manualDownloadDialog_privacyPolicy)
      console.log('manualDownloadDialog_marketingReception', this.manualDownloadDialog_marketingReception)
      // 문의하기 api(리컬럼 소개서 다운로드와 동시 사용) 호출
      this.postProductInquiry2().then(res => {
        console.log('postProductInquiry2 res', res)
        this.manualDownloadDialog = false
      })
      // pdf 다운로드
      let fileUrl = '' // public 기준 경로
      let fileName = '' // 다운로드될 파일명
      if (this.manualDownloadDialog_language === '한글(KOR)') {
        fileUrl = '/recolumn_service_introduction_kor.pdf'
        fileName = '[리컬럼] 서비스 소개서.pdf'
      }
      if (this.manualDownloadDialog_language === '영어(ENG)') {
        fileUrl = '/recolumn_service_introduction_eng.pdf'
        fileName = '[Recolumn] Service Overview.pdf'
      }
      const link = document.createElement('a')
      link.href = fileUrl
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    postProductInquiry2() {
      return new Promise((resolve, reject) => {
        console.log('postProductInquiry2')
        let body = {
          type: 'service_introduction',
          name: this.manualDownloadDialog_nameInput,
          email: this.manualDownloadDialog_emailInput,
          org_name: this.manualDownloadDialog_companyInput,
          position: this.manualDownloadDialog_positionInput,
          phone: this.manualDownloadDialog_phoneNumberInput,
          is_agree_policy: this.manualDownloadDialog_privacyPolicy,
          is_agree_marketing: this.manualDownloadDialog_marketingReception,
          contents: [],
        }
        http
        .post('account/post-product-inquiry/', body, { headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
          console.log('postProductInquiry2 err', err)
          console.log('postProductInquiry2 err.response', err.response)
          if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
            this.methodRecall()
            .then(msg => {
              console.log(msg)
              this.postProductInquiry2() // method 재호출
            })
            .catch(err_msg => {
              this.$store.commit('setOverlay', false)
              this.$store.commit('setOverlayText', '')
              console.log(err_msg)
              if (err_msg === 0) {
                console.log('BE에 access token 저장 실패')
              } else { // err_msg === 1
                console.log('refresh token 만료(access token 갱신 실패)')
                // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
                this.stopAsyncTaskStatusListPanel({ refreshDataList: false })
                this.$store.commit('logout')
                this.$router.push('/').catch(() => {})
              }
            })
          }
        })
      })
    },

    // 2주 무료체험 버튼 (dialog) 클릭
    clickDemoBtn() {
      console.log('clickDemoBtn')
      this.emailInput = ''
      this.sendTrialEmailFlag = 0
      this.demoRequestDialog = true
    },
    // 2주 무료체험 버튼 (이메일 발송) 클릭
    clickTrialBtn(emailInput) {
      console.log('clickTrialBtn', emailInput)
      this.requestTrial(emailInput).then(res => {
        console.log('requestTrial res', res)
        // 무료체험 신청 기록이 없는 경우
        if (res.data === 'success') {
          this.sendTrialEmailFlag = 1
        }
        // 무료체험 신청 기록이 있는 경우
        if (res.data === 'already requested') {
          this.sendTrialEmailFlag = 2
        }
      })
    },
    // 무료체험(trial) 신청 이메일 수집 api
    requestTrial(emailInput) {
      return new Promise((resolve, reject) => {
        console.log('requestTrial', emailInput)
        let body = {
          email: emailInput,
        }
        http
        .post('account/request-trial/', body, { headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
          console.log('requestTrial err', err.response)
          if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
            this.methodRecall()
            .then(msg => {
              console.log(msg)
              this.requestTrial(emailInput) // method 재호출
            })
            .catch(err_msg => {
              this.isLoadingMultiTableData = false
              console.log(err_msg)
              if (err_msg === 0) {
                console.log('BE에 access token 저장 실패')
              } else { // err_msg === 1
                console.log('refresh token 만료(access token 갱신 실패)')
                // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
                this.$store.commit('logout')
                this.$router.push('/').catch(() => {})
              }
            })
          }
        })
      })
    },
    // 채널톡으로 문의하기 버튼 클릭
    contactChannelTalk() {
      console.log('contactChannelTalk')
      let btn_el = document.querySelector('.channel-talk-btn-3')
      setTimeout(() => {
        console.log('btn_el', btn_el)
        btn_el.click()
      }, 100);
    },
    // 문의하기 버튼 클릭
    clickContactBtn() {
      console.log('clickContactBtn')
      if (this.window_innerWidth > 440) {
        this.contactDialog = true
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.contactDialog_inquiryInput.focus()
          }, 0);
        })
      } else {
        this.$router.push('/contact')
        .then(() => { window.scrollTo(0,0) })
        .catch(() => {})
      }
    },
    // 소개서 다운로드 버튼 클릭
    clickShowManualDownloadDialogBtn() {
      console.log('clickShowManualDownloadDialogBtn')
      if (this.window_innerWidth > 440) {
        this.manualDownloadDialog = true
      } else {
        this.$router.push('/manual-download')
        .then(() => {
          window.scrollTo(0,0)
          this.isShowHamburgerMenu = false
        })
        .catch(() => {})
      }
    },

    // 코그콤 링크드인 버튼 클릭
    goLinkedInPage() {
      console.log('goLinkedInPage')
      window.open('https://www.linkedin.com/company/cogcom-inc/')
    },
    // 코그콤 홈페이지 버튼 클리
    goHomepage() {
      console.log('goHomepage')
      window.open('https://www.cogcom.kr')
    },

    // 이메일 유효 검사 로직
    checkEmailValid(email) {
      // console.log('checkEmailValid', email)
      if (!email) return false
      let isValid = true
      email = email.trim()
      let email_first_section = ''
      let email_second_section = ''
      let email_third_section = ''
      try {
        email_first_section = email.split('@')[0]
        email_second_section = email.split('@')[1].split('.')[0]
        email_third_section = email.split('@')[1].split('.')[1]
        // console.log(email_first_section, email_second_section, email_third_section)
        if (!email_first_section || !email_second_section || !email_third_section) {
          console.log('checkEmailValid catch error-1')
          isValid = false
          return isValid
        }
      }
      catch {
        console.log('checkEmailValid catch error-2')
        isValid = false
        return isValid
      }
      // console.log(email_first_section, email_second_section, email_third_section)
      if (email_first_section.length <= 64) {
        isValid = true
      } else {
        isValid = false
      }
      return isValid
    },
    // 이메일, 연락처 클릭 - 텍스트 복사
    copyText(text) {
      console.log('copyText', text)
      const t = document.createElement("textarea")
      document.body.appendChild(t)
      t.value = text
      t.select()
      document.execCommand('copy')
      document.body.removeChild(t)
      this.showAlert = true
    },

    // 로그인 dialog open
    openLoginDialog() {
      if (this.$store.state.userEmailInput_remembered) {
        this.userEmailInput = this.$store.state.userEmailInput_remembered
      } else {
        this.userEmailInput = ''
      }
      this.userPasswordInput = ''
      this.loginDialog = true
    },
    // 구글 로그인
    googleSocialLogin() {
      console.log('googleSocialLogin')
      if (!this.googleLoginEnabled) return
      let self = this
      // auth2 로드
      window.gapi.load("auth2", function() {
        // GoogleAuth객체 생성
        let gauth = window.gapi.auth2.init({
          client_id: process.env.VUE_APP_CLIENT_ID,
          scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile openid',
          plugin_name: "ReColumn",
        });
        gauth.then(
          // GoogleAuth 초기화 성공
          () => {
            gauth.grantOfflineAccess().then(
              // 로그인 성공
              res => {
                // getGoogleRefreshToken 함수를 호출
                self.getGoogleRefreshToken(res.code)
              },
              // 로그인 실패
              err => {
                if (err.error !== 'popup_closed_by_user' && err.error.name !== 'NetworkError') {
                  self.$store.commit('swalToast', {title: '로그인에 실패하였습니다.', type: 'warning'})
                }
              }
            )
          },
          // GoogleAuth 초기화 실패
          () => {
            self.$store.commit('swalToast', {title: '로그인에 실패하였습니다.', type: 'warning'})
          }
        );
      });
    },
    getGoogleRefreshToken(code) {
      // 받은 코드를 바탕으로 access_token 및 refresh_token 요청
      if (code) {
        this.$store.commit('setOverlayText', '로그인 중...')
        this.$store.commit('setOverlay', true)
        this.loginDialog = false
        const url = "https://oauth2.googleapis.com/token"
        const query = {
          code: code,
          client_id: process.env.VUE_APP_CLIENT_ID,
          client_secret: process.env.VUE_APP_CLIENT_SECRET,
          redirect_uri: "postmessage",
          grant_type: "authorization_code"
        }
        axios
        .post(url, query)
        .then(res1 => {
          // 이미 회원가입된(우리 db에 있는) 사용자인지 아닌지 판단
          http
          .get('/account/google-oauth/', { headers: { Authorization: 'Bearer ' + res1.data.access_token } })
          .then(res2 => {
            if (res2.data.is_exist) { // is_exist === true -> 이미 회원가입된(우리 db에 있는) 사용자 -> 서비스 사용 가능
              console.log('already exist')
              if (res1.data.refresh_token) this.$store.commit('setRefreshToken', res1.data.refresh_token)
              this.$store.commit('setAccessToken', res1.data.access_token)
              if (res1.data.id_token) this.$store.commit('setIdToken', res1.data.id_token)
              this.updateTokenAndGetUserData(res1.data.access_token)
            } else { // is_exist === false -> 회원가입되지 않은(우리 db에 없는) 사용자 -> 회원가입 페이지로 이동
              this.$store.commit('setOverlay', false)
              this.$store.commit('setOverlayText', '')
              Swal.fire({
                icon: "warning",
                text: "가입되지 않은 계정입니다.",
                confirmButtonText: "도입문의",
                preConfirm: () => {
                  this.clickContactBtn()
                }
              })
            }
          })
          .catch(() => {
            this.$store.commit('swalToast', {title: '로그인에 실패하였습니다.', type: 'warning'})
            this.$store.commit('logout')
            this.$store.commit('setOverlay', false)
            this.$store.commit('setOverlayText', '')
          })
        })
        .catch(() => {
          this.$store.commit('swalToast', {title: '로그인에 실패하였습니다.', type: 'warning'})
          this.$store.commit('setOverlay', false)
          this.$store.commit('setOverlayText', '')
        })
      }
    },
    // 토큰 및 유저정보 갱신 - 구글 로그인
    updateTokenAndGetUserData(access_token) {
      this.$store.commit('setOverlayText', '로그인 중...')
      this.$store.commit('setOverlay', true)
      // get update-token
      http
      .get('account/update-token/', { headers: {Authorization: 'Bearer ' + access_token} })
      .then(() => {
        this.$store.state.is_token_updated = true
        // get user
        http
        .get('account/user/', { headers: {Authorization: 'Bearer ' + access_token} })
        .then(res2 => {
          if (!res2.data.sort_json) {
            res2.data.sort_json = {}
          }
          if (!res2.data.language) {
            res2.data.language = 'ko'
          }
          i18n.locale = res2.data.language
          i18n.fallbackLocale  = res2.data.language
          // 기한 만료 n일 이내인 경우
          if (res2.data.license_block >= 0) {
            if (!res2.data.sort_json) {
              res2.data.sort_json = {}
            }
            // 무료체험 계정인 경우
            if (res2.data.plan === 'trial') {
              res2.data.sort_json.expireDateEndDialog = true
              res2.data.sort_json.expireDateEndAlert = true
            }
            // 엔터프라이즈 계정인 경우
            else {
              res2.data.sort_json.expireDateEndDialog = false
              res2.data.sort_json.expireDateEndAlert = true
            }
            this.$store.commit('setUserInfo', res2.data)
          }
          this.loginDialog = false
          this.$nextTick(() => {
            this.goWorkSpace()
          })
        })
        .catch(() => {
          this.$store.commit('setOverlay', false)
          this.$store.commit('setOverlayText', '')
          this.$store.commit('logout')
        })
      })
      .catch(() => {
        this.$store.commit('logout')
        this.$store.commit('setOverlay', false)
        this.$store.commit('setOverlayText', '')
      })
    },
    // 일반 로그인
    async commonLogin(userEmailInput, userPasswordInput) {
      try {
        const accessToken = await loginWithPassword({
          email: userEmailInput,
          password: userPasswordInput,
        })
        this.loginDialog = false
        this.$store.commit('setUserEmailInput_remembered', userEmailInput)
        await this.updateTokenAndGetUserData2(accessToken)
      } catch (err) {
        const errorCode = normalizeAuthErrorCode(err)
        const authErrorMessage = getAuthErrorMessage(err)

        this.$store.commit('setOverlay', false)
        this.$store.commit('setOverlayText', '')

        if (errorCode === '1001185') {
          this.$store.commit('swalToast', { title: authErrorMessage, type: 'warning' })
          this.loginDialog = false
          this.userEmailInput = userEmailInput
          this.findPasswordDialog = true
        } else if (authErrorMessage) {
          this.$store.commit('swalToast', { title: authErrorMessage, type: 'warning' })
        } else if (errorCode === '1001058') {
          this.$store.commit('swalToast', { title: '이메일 또는 비밀번호를 다시 확인해주세요.', type: 'warning' })
        } else if (err.response && err.response.status === 501) {
          this.loginDialog = false
          this.userEmailInput = err.response.data.email
          this.accountActivateDialog = true
        } else {
          this.$store.commit('swalToast', { title: '로그인에 실패하였습니다.', type: 'warning' })
        }
      }
    },
    // 토큰 및 유저정보 갱신 - 일반 로그인
    async updateTokenAndGetUserData2(access_token) {
      this.$store.commit('setOverlayText', '로그인 중...')
      this.$store.commit('setOverlay', true)

      try {
        this.$store.state.is_token_updated = true
        const res = await http.get('account/user-recolumn/', { headers: {Authorization: 'Bearer ' + access_token} })
        if (!res.data.sort_json) res.data.sort_json = {}
        if (!res.data.language) res.data.language = 'ko'
        i18n.locale = res.data.language
        i18n.fallbackLocale = res.data.language

        if (res.data.license_block >= 0) {
          if (res.data.plan === 'trial') {
            res.data.sort_json.expireDateEndDialog = true
            res.data.sort_json.expireDateEndAlert = true
          } else {
            res.data.sort_json.expireDateEndDialog = false
            res.data.sort_json.expireDateEndAlert = true
          }
          this.$store.commit('setUserInfo', res.data)
        }
        this.loginDialog = false
        this.$nextTick(() => this.goWorkSpace())
      } catch (error) {
        this.$store.commit('setOverlay', false)
        this.$store.commit('setOverlayText', '')
        this.$store.commit('logout')
        throw error
      }
    },
    // 계정 활성화 메일 재발송
    reSendAccountActivateEmail() {
      console.log('reSendAccountActivateEmail')
      let body = {
        email: this.userEmailInput,
      }
      this.$store.commit('setOverlayText', '메일 발송 중...')
      this.$store.commit('setOverlay', true)
      http
      .post('account/repeat-email/', body, { headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
      .then(res => {
        console.log('reSendAccountActivateEmail res', res)
        this.$store.commit('setOverlay', false)
        this.$store.commit('setOverlayText', '')
        this.$store.commit('swalToast', {title: '이메일이 재발송되었습니다.', type: 'success'})
      })
      .catch(err => {
        console.log('reSendAccountActivateEmail err', err.response)
        if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
          this.methodRecall()
          .then(msg => {
            console.log(msg)
            this.reSendAccountActivateEmail() // method 재호출
          })
          .catch(err_msg => {
            this.$store.commit('setOverlay', false)
            this.$store.commit('setOverlayText', '')
            console.log(err_msg)
            if (err_msg === 0) {
              console.log('BE에 access token 저장 실패')
            } else { // err_msg === 1
              console.log('refresh token 만료(access token 갱신 실패)')
              // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
              this.$store.commit('logout')
              this.$router.push('/').catch(() => {})
            }
          })
        }
      })
    },
    // 비밀번호 찾기 이메일 발송
    sendFindPasswordEmail(userEmailInput) {
      let body = {
        email: userEmailInput,
      }
      this.$store.commit('setOverlayText', '메일 발송 중...')
      this.$store.commit('setOverlay', true)
      http
      .post('account/send-reset-password/', body, { skipAuth: true })
      .then(() => {
        this.$store.commit('setOverlay', false)
        this.$store.commit('setOverlayText', '')
        this.$store.commit('swalToast', {title: '이메일이 발송되었습니다.', type: 'success'})
        this.findPasswordDialog = false
      })
      .catch(() => {
        this.$store.commit('setOverlay', false)
        this.$store.commit('setOverlayText', '')
      })
    },
    // 태그 관리 페이지 이동
    goTagManagement() {
      console.log('goTagManagement')
      this.$router.push('/tag-management')
      .then(() => { window.scrollTo(0,0) })
      .catch(() => {})
    },
    // 휴지통 페이지 이동
    goTotalTrashCan() {
      console.log('goTotalTrashCan')
      this.$router.push('/total-trash-can')
      .then(() => { window.scrollTo(0,0) })
      .catch(() => {})
    },
    // 도입 문의하기 버튼 클릭
    clickContactBtnInDialog() {
      console.log('clickContactBtnInDialog')
      // 문의하기 api 호출
      this.postProductInquiry().then(res => {
        console.log('postProductInquiry res', res)
        this.contactDialog = false
        this.contactDialog_success = true
      })
    },
    // 문의하기 api
    postProductInquiry() {
      return new Promise((resolve, reject) => {
        console.log('postProductInquiry')
        let body = {
          contents: {
            contactDialog_inquiryInput: this.contactDialog_inquiryInput, // 문의 내용
            contactDialog_answerPath: this.contactDialog_answerPath, // 원하시는 답변 경로
            contactDialog_ableTimeInput: this.contactDialog_ableTimeInput, // 통화 가능한 시간
            contactDialog_contactInput: this.contactDialog_contactInput, // 연락처(전화번호, 이메일)
            contactDialog_privacyPolicy: this.contactDialog_privacyPolicy, // 개인정보처리방침 동의
          },
        }
        http
        .post('account/post-product-inquiry/', body, { headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
          console.log('postProductInquiry err', err)
          console.log('postProductInquiry err.response', err.response)
          if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
            this.methodRecall()
            .then(msg => {
              console.log(msg)
              this.postProductInquiry() // method 재호출
            })
            .catch(err_msg => {
              this.$store.commit('setOverlay', false)
              this.$store.commit('setOverlayText', '')
              console.log(err_msg)
              if (err_msg === 0) {
                console.log('BE에 access token 저장 실패')
              } else { // err_msg === 1
                console.log('refresh token 만료(access token 갱신 실패)')
                // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
                this.$store.commit('logout')
                this.$router.push('/').catch(() => {})
              }
            })
          }
        })
      })
    },
    // 관리자에게 문의 버튼 클릭
    clickContactAdminBtn() {
      console.log('clickContactAdminBtn')
      window.open('https://recolumn.channel.io/')
    },

    // 마이페이지 관련
    showMypageDialog() {
      console.log('showMypageDialog')
      // 수정 가능 변수 설정
      // 내 프로필 > 이름
      if (this.$store.state.user_info && this.$store.state.user_info.name) {
        this.userInfo_name = JSON.parse(JSON.stringify(this.$store.state.user_info.name))
      } else {
        this.userInfo_name = ''
      }
      console.log('userInfo_name', this.userInfo_name)
      // 세부 설정 > 언어
      if (this.$store.state.user_info && this.$store.state.user_info.language !== null && this.$store.state.user_info.language !== undefined) {
        this.userInfo_language = JSON.parse(JSON.stringify(this.$store.state.user_info.language))
      } else {
        this.userInfo_language = 'ko'
      }
      console.log('userInfo_language', this.userInfo_language)
      // 세부 설정 > 마케팅 정보 수신 동의
      if (this.$store.state.user_info && this.$store.state.user_info.marketing_allowed !== null && this.$store.state.user_info.marketing_allowed !== undefined) {
        this.userInfo_marketingAllowed = JSON.parse(JSON.stringify(this.$store.state.user_info.marketing_allowed))
      } else {
        this.userInfo_marketingAllowed = false
      }
      console.log('userInfo_marketingAllowed', this.userInfo_marketingAllowed)
      this.userInfo_consoleDebugEnabled = this.isSuperAdminUser && isConsoleDebugEnabled()
      // dialog 표시
      this.clickedBtnGroupIdx_mypageDialog = 0
      console.log('clickedBtnGroupIdx_mypageDialog', this.clickedBtnGroupIdx_mypageDialog)
      this.mypageDialog = true
    },
    setMypageDialog(value) {
      console.log('setMypageDialog', value)
      if (value) {
        this.showMypageDialog()
      }
    },
    openPasswordChangeDialog() {
      if (this.canChangePassword) this.passwordChangeDialog = true
    },
    handlePasswordChanged() {
      this.$store.commit('swalToast', {
        title: '비밀번호가 변경되었습니다.',
        type: 'success',
      })
    },
    // 이름 수정 관련
    clickModifyUserName() {
      console.log('clickModifyUserName')
    },
    closeModifyUserName() {
      console.log('closeModifyUserName')
      this.userInfo_name = this.$store.state.user_info.name
      console.log('userInfo_name', this.userInfo_name)
    },
    // 로그아웃
    async clickLogoutBtn() {
      this.mypageDialog = false
      this.stopAsyncTaskStatusListPanel({ refreshDataList: false })
      try {
        await logoutDjangoSession()
      } catch (error) {
        console.warn('logout request failed', {
          status: error && error.response && error.response.status,
          url: error && error.config && error.config.url,
        })
      } finally {
        this.$router.push('/').catch(() => {})
      }
    },
    // 회원탈퇴
    askWithdrawal() {
      console.log('askWithdrawal')
      this.isWritingWithdrawalCheckText = true
      console.log('isWritingWithdrawalCheckText', this.isWritingWithdrawalCheckText)
      Swal.fire({
        width: 600,
        icon: 'question',
        title: "탈퇴하시겠습니까? <br> 탈퇴하시려면 '회원탈퇴'를 입력해 주세요.",
        text: '탈퇴 시 모든 기록이 삭제됩니다.',
        input: 'text',
        confirmButtonText: '예',
        showDenyButton: true,
        denyButtonText: '아니오',
        showCloseButton: true,
        focusConfirm: false,
        focusDeny: false,
        focusCancel: false,
        inputValidator: (value) => {
          if (value !== '회원탈퇴') return '문구를 정확히 입력해 주세요.'
        },
        preConfirm: (text) => {
          console.log(text)
          if (text === '회원탈퇴') {
            console.log('회원탈퇴 api 실행')
            this.withdrawal()
          }
        },
        didClose: () => { // 닫기
          this.isWritingWithdrawalCheckText = false
          console.log('isWritingWithdrawalCheckText', this.isWritingWithdrawalCheckText)
          return false
        },
      })
    },
    withdrawal() {
      console.log('withdrawal')
      http
      .delete('account/withdrawal/', { headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
      .then(res => {
        console.log(res)
        this.$store.commit('logout')
        this.$router.push('/').catch(() => {})
        this.mypageDialog = false
      })
      .catch(err => {
        console.log(err)
        console.log(err.response)
        if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
          this.methodRecall()
          .then(msg => {
            console.log(msg)
            this.withdrawal() // method 재호출
          })
          .catch(err_msg => {
            console.log(err_msg)
            if (err_msg === 0) {
              console.log('BE에 access token 저장 실패')
            } else { // err_msg === 1
              console.log('refresh token 만료(access token 갱신 실패)')
              // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
              this.$store.commit('logout')
              this.$router.push('/').catch(() => {})
            }
          })
        }
      })
    },
    // 마케팅 정보 수신 동의 토글 클릭
    changeMarketingAllowedToggle(userInfo_marketingAllowed) {
      console.log('changeMarketingAllowedToggle', userInfo_marketingAllowed)
    },
    changeConsoleDebugToggle(value) {
      if (!this.isSuperAdminUser) {
        this.userInfo_consoleDebugEnabled = false
        setConsoleDebugEnabled(false)
      } else {
        setConsoleDebugEnabled(value)
      }
      applyConsolePolicy(this.$store.state.user_info?.organization_permission)
    },
    // 유저 정보 수정
    modifyUserInfo() {
      console.log('modifyUserInfo')
      console.log('userInfo_name', this.userInfo_name)
      console.log('userInfo_language', this.userInfo_language)
      console.log('userInfo_marketingAllowed', this.userInfo_marketingAllowed)
      let form = new FormData()
      form.append('name', this.userInfo_name)
      form.append('language', this.userInfo_language)
      form.append('marketing_allowed', this.userInfo_marketingAllowed)
      http
      .put(`account/user/${this.$store.state.user_info.pk || this.$store.state.user_info.id}/`, form, { headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
      .then(res => {
        console.log('modifyUserInfo res', res)
        // this.$store.commit('setUserInfo', res.data)
        this.$store.commit('SET_USER_INFO', res.data)

        // this.$store.state.user_info.name = this.userInfo_name
        // this.$store.state.user_info.language = this.userInfo_language
        // this.$store.state.user_info.marketing_allowed = this.userInfo_marketingAllowed
        i18n.locale = this.userInfo_language
        i18n.fallbackLocale  = this.userInfo_language

        if (this.$store.state.user_info.marketing_allowed !== this.userInfo_marketingAllowed) {
          let now = dayjs().add(9, 'hour') // 한국 시간(KST, UTC+9) 기준 
          Swal.fire({
            icon: 'success',
            html: `
              <div style="font-size: 14px; font-weight: 500; line-height: 20px; color: #414458">
                ${now.year()}년 ${now.month()+1}월 ${now.date()}일에 리컬럼의 마케팅 정보 ${this.userInfo_marketingAllowed ? '수신에 동의' : '수신 동의를 해제'}하신 <br> 내역이 정상적으로 처리되었습니다.
              </div>
            `,
            confirmButtonText: '확인',
          })
        } else {
          Swal.fire({
            icon: 'success',
            text: '회원정보를 수정하였습니다.',
            confirmButtonText: '확인',
          })
        }
      })
      .catch(err => {
        console.log(err)
        console.log(err.response)
        if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
          this.methodRecall()
          .then(msg => {
            console.log(msg)
            this.modifyUserInfo() // method 재호출
          })
          .catch(err_msg => {
            console.log(err_msg)
            if (err_msg === 0) {
              console.log('BE에 access token 저장 실패')
            } else { // err_msg === 1
              console.log('refresh token 만료(access token 갱신 실패)')
              // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
              this.$store.commit('logout')
              this.$router.push('/').catch(() => {})
            }
          })
        }
      })
    },

    // 프로젝트 검색 관련 (navbar, drawer 공통)
    searchProject(searchPjtNameInput, type) { // type - 'navbar' or 'drawer'
      console.log('searchProject', searchPjtNameInput, type)
      if (!searchPjtNameInput) {
        console.log('input empty')
        return false
      }
      if (type === 'navbar') {
        if (this.$refs.routerView) {
          this.$refs.routerView.getProjectList(true).then(res => {
            console.log(res)
            this.searchedPjtName = searchPjtNameInput
            this.isSearchingPjt = true
          })
        }
      }
      if (type === 'drawer') {
        this.getProjectListSimple().then(res => {
          console.log(res)
          this.searchedPjtName = searchPjtNameInput
          this.isSearchingPjt = true
        })
      }
    },
    clearSearchInput(type) { // type - 'navbar' or 'drawer'
      console.log('clearSearchInput', type)
      this.searchPjtNameInput = ''
      this.searchedPjtName = ''
      if (this.isSearchingPjt) {
        this.isSearchingPjt = false
        if (type === 'navbar') {
          if (this.$refs.routerView) {
            this.$nextTick(() => {
              this.$refs.routerView.getProjectList(true)
            })
          }
        }
        if (type === 'drawer') {
          this.getProjectListSimple()
        }
      }
    },
    clickSearchedChip() {
      console.log('clickSearchedChip')
      this.isSearchingPjt = false
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.searchPjtNameInput.$refs.input.focus()
        }, 0);
      })
    },
    clickOutsidePjtSearchInput() {
      // console.log('clickOutsidePjtSearchInput')
      if (this.searchedPjtName) {
        this.isSearchingPjt = true
        this.searchPjtNameInput = this.searchedPjtName
      }
    },

    // 워크플로우 검색 관련
    searchWorkflow(searchWorkflowNameInput) {
      console.log('searchWorkflow', searchWorkflowNameInput)
      if (!searchWorkflowNameInput) {
        console.log('input empty')
        return false
      }

      this.getRpaList(this.$store.state.current_project_pk, searchWorkflowNameInput)

      this.searchedWorkflowName = searchWorkflowNameInput
      this.isSearchingWorkflow = true
    },
    clearSearchInput2() {
      console.log('clearSearchInput2')
      this.searchWorkflowNameInput = ''
      this.searchedWorkflowName = ''
      if (this.isSearchingWorkflow) {
        this.isSearchingWorkflow = false
        this.getRpaList(this.$store.state.current_project_pk)
      }
    },
    clickSearchedChip2() {
      console.log('clickSearchedChip2')
      this.isSearchingWorkflow = false
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.searchWorkflowNameInput.$refs.input.focus()
        }, 0);
      })
    },
    clickOutsideWorkflowSearchInput() {
      // console.log('clickOutsideWorkflowSearchInput')
      if (this.searchedWorkflowName) {
        this.isSearchingWorkflow = true
        this.searchWorkflowNameInput = this.searchedWorkflowName
      }
    },
    // navbar > 워크플로우 dropdown > 워크플로우 아이템 클릭
    clickWorkflowItem(workflow_item) {
      console.log('clickWorkflowItem', workflow_item)
      this.$router.push(`/rpa/${this.$store.state.current_project_pk}/${workflow_item.id}`).catch(() => {})
    },

    // 인사이트 목록 관련
    getInsightList() {
      return new Promise((resolve, reject) => {
        console.log('getInsightList')
        this.isLoadingInsightList = true
        let params = {
          project: this.$store.state.current_project_pk,
          order: this.insightListOrder,
          name: this.searchedInsightName,
        }
        console.log('params', params)
        http
        .get('annotation/insight-db/', { params: params, headers: { Authorization: 'Bearer ' + this.$store.state.access_token }})
        .then(res => {
          console.log('getInsightList res', res)
          this.insightList = res.data.items
          this.folderList = res.data.folders || []
          console.log('insightList', this.insightList)
          this.isLoadingInsightList = false
          resolve(res)
        })
        .catch(err => {
          console.log(err)
          console.log(err.response)
          reject(err)
          if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
            this.methodRecall()
            .then(msg => {
              console.log(msg)
              this.getInsightList() // method 재호출
            })
            .catch(err_msg => {
              this.isLoadingInsightList = false
              console.log(err_msg)
              if (err_msg === 0) {
                console.log('BE에 access token 저장 실패')
              } else { // err_msg === 1
                console.log('refresh token 만료(access token 갱신 실패)')
                // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
                this.$store.commit('logout')
                this.$router.push('/').catch(() => {})
              }
            })
          } else {
            this.isLoadingInsightList = false
          }
        })
      })
    },
    // 인사이트 검색 관련
    searchInsight(searchInsightNameInput) {
      console.log('searchInsight', searchInsightNameInput)
      if (!searchInsightNameInput) {
        console.log('input empty')
        return false
      }
      this.searchedInsightName = searchInsightNameInput
      this.isSearchingInsight = true
      this.getInsightList()
    },
    clearSearchInput3() {
      console.log('clearSearchInput3')
      this.searchInsightNameInput = ''
      this.searchedInsightName = ''
      if (this.isSearchingInsight) {
        this.isSearchingInsight = false
        this.getInsightList()
      }
    },
    clickSearchedChip3() {
      console.log('clickSearchedChip3')
      this.isSearchingInsight = false
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.searchInsightNameInput.$refs.input.focus()
        }, 0);
      })
    },
    clickOutsideInsightSearchInput() {
      if (this.searchedInsightName) {
        this.isSearchingInsight = true
        this.searchInsightNameInput = this.searchedInsightName
      }
    },
    // navbar > 인사이트 dropdown > 인사이트 아이템 클릭
    clickInsightItem(insight_item) {
      console.log('clickInsightItem', insight_item)
      this.$store.commit('set_current_insight_folder', null)
      this.$store.commit('set_current_insight', insight_item)
      this.$router.push(`/insight/${this.$store.state.current_project_pk}/${insight_item.id}`).catch(() => {})
      this.insightDropdownMenu = false
    },
    // navbar > 인사이트 dropdown > 폴더 아이템 클릭 (InsightList.vue의 clickFolder와 동일 동작)
    async clickFolderItem(folder) {
      console.log('clickFolderItem', folder)
      this.$store.commit('set_current_insight_folder', { ...folder })
      let dashboards = []
      try {
        const res = await http.get('annotation/insight-db/', {
          params: { project: this.$store.state.current_project_pk, folder: folder.id, order: 'created_at' },
          headers: { Authorization: 'Bearer ' + this.$store.state.access_token },
        })
        dashboards = res.data.items || []
      } catch (e) {
        // 오류 시 빈 폴더와 동일하게 처리
      }
      if (dashboards.length > 0) {
        this.$store.commit('set_current_insight', dashboards[0])
        this.$router.push(`/insight/${this.$store.state.current_project_pk}/${dashboards[0].id}`).catch(() => {})
      } else {
        this.$store.commit('set_current_insight', null)
        this.$router.push(`/insight/${this.$store.state.current_project_pk}`).catch(() => {})
      }
      this.insightDropdownMenu = false
    },


    // Drawer 관련
    getMenuIcon(menu_value, on_off_value) {
      // console.log('getMenuIcon', menu_value, on_off_value)
      try {
        return `/assets/menu_icon/${menu_value}_${on_off_value}.svg`;
      } catch (e) {
        // 파일이 없을 경우 기본 이미지 반환
        return `/assets/menu_icon/help_${on_off_value}.svg`;
      }
    },
    // 프로젝트 이름 관련
    mouseenterMenuHeader() {
      console.log('mouseenterMenuHeader')
      let el = document.querySelector('.pjt-title')
      if (el) {
        console.log('el.clientWidth', el.clientWidth, 'el.scrollWidth', el.scrollWidth)
        if (el.clientWidth < el.scrollWidth) { // text-overflow: ellipsis
          this.showPjtFullName = true
          this.isHoverHeaderMenu = true
        } else {
          this.showPjtFullName = false
          this.isHoverHeaderMenu = false
        }
        console.log('showPjtFullName', this.showPjtFullName)
        console.log('isHoverHeaderMenu', this.isHoverHeaderMenu)
      }
    },
    mouseleaveMenuHeader() {
      console.log('mouseleaveMenuHeader')
      this.isHoverHeaderMenu = false
      console.log('isHoverHeaderMenu', this.isHoverHeaderMenu)
      setTimeout(() => {
        if (!this.isHoverHeaderMenu) {
          this.showPjtFullName = false
          console.log('showPjtFullName', this.showPjtFullName)
        }
      }, 1);
    },
    // 프로젝트 목록 호출
    getProjectListSimple() {
      return new Promise((resolve, reject) => {
        console.log('getProjectListSimple')
        let params = {
          order: this.projectListOrder,
          limit: 9999,
          page: 1,
        }
        if (this.searchPjtNameInput) {
          params.name = this.searchPjtNameInput
        }
        console.log('params', params)
        this.loadingProjectList = true
        http
        .get('annotation/get-project-list-simple/', { params: params, headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
        .then(async res => {
          console.log('getProjectListSimple res', res)
          let favorite_items = res.data.items.filter(v => v.favorite)
          let none_favorite_items = res.data.items.filter(v => !v.favorite)
          let result = [...favorite_items, ...none_favorite_items]
          this.projectList = result.map(v => {
            // 대표 이미지 관련
            if (v.icon_url) {
              v.icon_url = normalizeAuthorizedDownloadUrl(v.icon_url)
            }
            return v
          })
          const projectIconImageUrlSet = new Set(this.$store.state.project_icon_image_urls || [])
          const preloadTargetUrls = this.projectList
            .map(v => v.icon_url)
            .filter(url => !projectIconImageUrlSet.has(normalizeAuthorizedDownloadUrl(url)))
          await this.preloadProjectImageUrls(preloadTargetUrls)
          console.log('projectList', this.projectList)
          this.loadingProjectList = false
          resolve(res)
        })
        .catch(err => {
          reject(err)
          console.log(err)
          console.log(err.response)
          if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
            this.methodRecall()
            .then(msg => {
              console.log(msg)
              this.getProjectListSimple() // method 재호출
            })
            .catch(err_msg => {
              console.log(err_msg)
              if (err_msg === 0) {
                console.log('BE에 access token 저장 실패')
              } else { // err_msg === 1
                console.log('refresh token 만료(access token 갱신 실패)')
                // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
                this.$store.commit('logout')
                this.$router.push('/').catch(() => {})
              }
            })
          } else {
            this.loadingProjectList = false
          }
        })
      })
    },
    // 프로젝트 클릭
    clickProjectItem(project) {
      console.log('clickProjectItem', project)
      if (!project) {
        console.log('project 없음')
        return false
      }
      if (project.pk === this.$store.state.current_project_pk) {
        console.log('동일 project - 이동 x')
        return false
      }

      // 무료체험(trial) 사용자 전용 로직
      if (this.$store.state.user_info.plan === 'trial') {
        this.$router.push(`/data-management/${project.pk}`)
        .then(() => { window.scrollTo(0,0) })
        .catch(() => {})
      }
      // 기존 사용자 로직
      else {
        const firstMenu = getFirstAccessibleProjectMenu(this.$store.state.menuPermissionList, this.$store.state.user_info, project)
        const route = getProjectMenuRoute(firstMenu, project.pk)
        if (route) {
          this.$gtag.event('click', {
            event_category: 'go',
            event_label: 'project',
            value: 'go_project',
          })
          this.$router.push(route)
          .then(() => { window.scrollTo(0,0) })
          .catch(() => {})
        }
      }
    },
    // drawer 메뉴 휠 클릭 (cmd/ctrl + 클릭과 동일하게 새 창 열기)
    middleClickMenu(route) {
      window.open(route, '_blank', 'noopener')
    },
    // 메뉴 클릭
    clickMenu(routeName, route, $event) {
      console.log('clickMenu', routeName, route)
      if ($event && ($event.metaKey || $event.ctrlKey)) {
        window.open(route, '_blank', 'noopener')
        return
      }
      if (shouldReloadNavigation({
        source: 'menu-click',
        currentRouteName: this.$route.name,
        targetRouteName: routeName,
      })) {
        this.$router.go(0)
        return
      }
      if (routeName === 'Extraction') {
        this.getProject().then(res => {
          if (res.data.tasks > 0) {
            this.$store.commit('setStepLevel', 2)
            this.$router.push(`/extraction/${this.$store.state.current_project_pk}/2`)
            .then(() => { window.scrollTo(0,0) })
            .catch(() => {})
          } else {
            this.$store.commit('setStepLevel', 1)
            this.$router.push(`/extraction/${this.$store.state.current_project_pk}/1`)
            .then(() => { window.scrollTo(0,0) })
            .catch(() => {})
          }
        })
      }
      else if (routeName === 'Keyword') {
        this.getProject().then(res => {
          if (res.data.tasks > 0) {
            this.$store.commit('setStepLevel', 2)
            this.$router.push(`/keyword/${this.$store.state.current_project_pk}/2`)
            .then(() => { window.scrollTo(0,0) })
            .catch(() => {})
          } else {
            this.$store.commit('setStepLevel', 1)
            this.$router.push(`/keyword/${this.$store.state.current_project_pk}/1`)
            .then(() => { window.scrollTo(0,0) })
            .catch(() => {})
          }
        })
      }
      else if (routeName === 'Summary') {
        this.getProject().then(res => {
          if (res.data.tasks > 0) {
            this.$store.commit('setStepLevel', 2)
            this.$router.push(`/summary/${this.$store.state.current_project_pk}/2`)
            .then(() => { window.scrollTo(0,0) })
            .catch(() => {})
          } else {
            this.$store.commit('setStepLevel', 1)
            this.$router.push(`/summary/${this.$store.state.current_project_pk}/1`)
            .then(() => { window.scrollTo(0,0) })
            .catch(() => {})
          }
        })
      }
      else {
        // 튜토리얼 진행 중일 경우
        if (this.$store.state.tutorialStep === 2) {
          this.$store.commit('setTutorialStep', 3)
        }
        // 튜토리얼 진행 중일 경우
        if (this.$store.state.tutorialStep === 7) {
          this.$store.commit('setTutorialStep', 8)
        }
        this.$router.push(route)
        .then(() => { window.scrollTo(0,0) })
        .catch(() => {})
      }
    },
    getProject() {
      return new Promise((resolve, reject) => {
        console.log('getProject')
        http
        .get(`annotation/get-project-list/${this.$store.state.current_project_pk}/`, { headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
        .then(res => {
          console.log('getProject res', res)
          resolve(res)
        })
        .catch(err => {
          reject(err)
          console.log('getProject err', err.response)
          if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
            this.methodRecall()
            .then(msg => {
              console.log(msg)
              this.getProject() // method 재호출
            })
            .catch(err_msg => {
              console.log(err_msg)
              if (err_msg === 0) {
                console.log('BE에 access token 저장 실패')
              } else { // err_msg === 1
                console.log('refresh token 만료(access token 갱신 실패)')
                // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
                this.$store.commit('logout')
                this.$router.push('/').catch(() => {})
              }
            })
          }
        })
      })
    },
    // 이용약관 페이지 이동
    goTermsOfUse() {
      this.$router.push('/terms')
      .then(() => { window.scrollTo(0,0) })
      .catch(() => {})
    },
    // 개인정보 처리방침 페이지 이동
    goPrivacyPolicy() {
      this.$router.push('/privacy-policy')
      .then(() => { window.scrollTo(0,0) })
      .catch(() => {})
    },
    // 개인정보 처리방침 페이지 새 창으로 열기
    openPrivacyPolicy() {
      let routeData = this.$router.resolve({name: 'PrivacyPolicy', path: '/privacy-policy'})
      window.open(routeData.href, '_blank')
    },
    goWorkSpace() {
      console.log('goWorkSpace')
      this.$router.push('/workspace')
      .then(() => {
        this.$store.commit('leaveProject')
        window.scrollTo(0,0)
      })
      .catch(() => {})
    },

    // 튜토리얼 시작 dialog 표시
    showTutorialStartDialog() {
      console.log('showTutorialStartDialog')
      this.tutorialStartDialog = true
    },
    // 튜토리얼 프로젝트로 이동하기 위한 프로젝트 목록 호출
    findTutorialPjt() {
      return new Promise((resolve, reject) => {
        let params = {
          order: '-created_at',
          limit: 9999,
          page: 1,
        }
        console.log('params', params)

        http
        .get('annotation/get-project-list/', { params: params, paramsSerializer: params => { return qs.stringify(params, {arrayFormat: 'repeat'}) }, headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
        .then(res => {
          console.log('findTutorialPjt res', res)
          // 튜토리얼 시 하이라이트될 아이템 관련
          let tutorial_pjt_pk = null
          let temp_tutorial_pjt_arr = JSON.parse(JSON.stringify(res.data.items.filter(v => v.name.includes('(튜토리얼)'))))
          if (temp_tutorial_pjt_arr.length === 1) { // 이름에 '(튜토리얼)'이 들어간 프로젝트가 1개일 경우 -> 해당 프로젝트를 하이라이트
            tutorial_pjt_pk = temp_tutorial_pjt_arr[0].pk
          }
          else if (temp_tutorial_pjt_arr.length > 1) { // 이름에 '(튜토리얼)'이 들어간 프로젝트가 1개 초과일 경우 -> 생성일자가 빠른 프로젝트를 하이라이트
            temp_tutorial_pjt_arr = temp_tutorial_pjt_arr.sort((a, b) => {
              return dayjs(a.created_at).isBefore(dayjs(b.created_at)) ? -1 : 1
            })
            tutorial_pjt_pk = temp_tutorial_pjt_arr[0].pk
          }
          console.log('tutorial_pjt_pk', tutorial_pjt_pk)
          let tutorial_pjt = null
          res.data.items.forEach(pjt => {
            if (pjt.pk === tutorial_pjt_pk) {
              tutorial_pjt = pjt
            }
          });
          console.log('tutorial_pjt', tutorial_pjt)
          resolve(tutorial_pjt)
        })
        .catch(err => {
          reject(err)
          console.log(err)
          console.log(err.response)
          if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
            this.methodRecall()
            .then(msg => {
              console.log(msg)
              this.findTutorialPjt() // method 재호출
            })
            .catch(err_msg => {
              console.log(err_msg)
              if (err_msg === 0) {
                console.log('BE에 access token 저장 실패')
              } else { // err_msg === 1
                console.log('refresh token 만료(access token 갱신 실패)')
                // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
                this.$store.commit('logout')
                this.$router.push('/').catch(() => {})
              }
            })
          }
        })
      })
    },
    // 기본 튜토리얼 클릭
    clickBasicTutorial() {
      console.log('clickBasicTutorial')
      this.tutorialStartDialog = false
      // 튜토리얼 시작
      this.$store.commit('setTutorialStep', 1)
      // 워크스페이스로 이동
      this.goWorkSpace()
    },
    // 워크플로우 튜토리얼 (워크플로우 프로세스 둘러보기) 클릭
    clickRpaTutorial() {
      console.log('clickRpaTutorial')
      this.tutorialStartDialog = false
      // 튜토리얼 프로젝트 탐색
      this.findTutorialPjt().then(tutorial_pjt => {
        console.log('tutorial_pjt', tutorial_pjt)
        // 튜토리얼 프로젝트가 있는 경우
        if (tutorial_pjt) {
          // 튜토리얼 rpa 탐색
          this.getRpaList(tutorial_pjt.pk).then(_rpa_list => {
            console.log('_rpa_list', _rpa_list)
            // 튜토리얼 rpa 탐색 (생성일자가 느린 순서로 정렬되어있으므로 for문 탐색 시 '01. [고객 사례] 국내 오픈마켓 매출 데이터를 더존 ERP 양식으로 변환하여 업로드 사례'이라는 문자열이 들어간 rpa 중 생성일자가 가장 빠른 rpa 탐색)
            let tutorial_rpa = null
            _rpa_list.forEach(_rpa => {
              if (_rpa.name.includes('01. [고객 사례] 국내 오픈마켓 매출 데이터를 더존 ERP 양식으로 변환하여 업로드 사례')) {
                tutorial_rpa = _rpa
              }
            });
            console.log('tutorial_rpa', tutorial_rpa)
            // 튜토리얼 rpa가 있는 경우
            if (tutorial_rpa) {
              // 현재 프로젝트를 튜토리얼 프로젝트로 설정
              this.$store.commit('setCurrentProject', tutorial_pjt)
              this.$store.commit('setCurrentProjectTitle', tutorial_pjt.name)
              this.$store.commit('setCurrentProjectPk', tutorial_pjt.pk)
              // rpa 튜토리얼 시작
              this.$store.commit('setRpaTutorialStep', 1)
              // 튜토리얼 rpa로 이동
              this.$store.commit('setCurrentRpa', tutorial_rpa)
              this.$router.push(`/rpa/${this.$store.state.current_project_pk}/${tutorial_rpa.id}`)
              .then(() => { window.scrollTo(0,0) })
              .catch(() => {})
              .finally(() => {
                console.log('this.$refs', this.$refs)
                if (this.$refs.routerView && this.$refs.routerView.$vnode && this.$refs.routerView.$vnode.tag && this.$refs.routerView.$vnode.tag.includes('RpaMain')) {
                  this.$refs.routerView.initialSetting()
                }
              })
            } else {
              console.log('tutorial_rpa 없음')
            }
          })
        } else {
          console.log('tutorial_pjt 없음')
        }
      })
    },
    // 튜토리얼 rpa를 찾기 위한 rpa 목록 호출
    getRpaList(pjt_pk, searchWorkflowNameInput) {
      return new Promise((resolve, reject) => {
        console.log('getRpaList', pjt_pk, searchWorkflowNameInput)
        let params = {
          order: this.rpaListOrder,
          page: 1,
          limit: 9999,
          version_major: 2,
        }
        console.log('params', params)
        this.loadingWorkflowList = true
        http
        .get(`annotation/get-rpa-list/${pjt_pk}/`, { params: params, headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
        .then(res => {
          console.log('getRpaList res', res)
          let _rpa_list = []
          // 객체 반환
          if (typeof res.data === 'object' && !Array.isArray(res.data)) {
            _rpa_list = res.data.data
          }
          // 배열 반환
          else {
            _rpa_list = res.data
          }
          _rpa_list = _rpa_list.filter(v => v)
          console.log('_rpa_list', _rpa_list)

          // navbar 워크플로우 dropdown 검색 관련
          if (searchWorkflowNameInput) {
            _rpa_list = _rpa_list.filter(v => v.name.includes(searchWorkflowNameInput))
          }
          this.workflowList = _rpa_list
          console.log('workflowList', this.workflowList)
          this.loadingWorkflowList = false

          resolve(_rpa_list)
        })
        .catch(err => {
          reject(err)
          console.log(err)
          console.log(err.response)
          if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
            this.methodRecall()
            .then(msg => {
              console.log(msg)
              this.getRpaList(pjt_pk, searchWorkflowNameInput) // method 재호출
            })
            .catch(err_msg => {
              console.log(err_msg)
              if (err_msg === 0) {
                console.log('BE에 access token 저장 실패')
              } else { // err_msg === 1
                console.log('refresh token 만료(access token 갱신 실패)')
                // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
                this.$store.commit('logout')
                this.$router.push('/').catch(() => {})
              }
            })
          } else {
            this.loadingWorkflowList = false
          }
        })
      })
    },
    // 데이터 모드 튜토리얼 (데이터 보기 모드 및 서식 보기 모드) 클릭
    clickDataModeTutorial() {
      console.log('clickDataModeTutorial')
      this.tutorialStartDialog = false
      // 튜토리얼 프로젝트 탐색
      this.findTutorialPjt().then(tutorial_pjt => {
        console.log('tutorial_pjt', tutorial_pjt)
        // 튜토리얼 프로젝트가 있는 경우
        if (tutorial_pjt) {
          // 현재 프로젝트를 튜토리얼 프로젝트로 설정
          this.$store.commit('setCurrentProject', tutorial_pjt)
          this.$store.commit('setCurrentProjectTitle', tutorial_pjt.name)
          this.$store.commit('setCurrentProjectPk', tutorial_pjt.pk)
          // 데이터 튜토리얼 시작
          this.$store.commit('setDataModeTutorialStep', 1)
          // 데이터로 이동
          this.$router.push(`/data-management/${this.$store.state.current_project_pk}`)
          .then(() => { window.scrollTo(0,0) })
          .catch(() => {})
          .finally(() => {
            console.log('this.$refs', this.$refs)
            this.$refs.routerView.$children.forEach(_vue_component => {
              if (_vue_component.$vnode && _vue_component.$vnode.data && _vue_component.$vnode.data.ref === 'FolderList') {
                _vue_component.initialSetting()
              }
            });
          })
        } else {
          console.log('tutorial_pjt 없음')
        }
      })

    },

    getAccessToken() {
      return new Promise((resolve, reject) => {
        console.log('getAccessToken')
        axios
        .post('https://oauth2.googleapis.com/token', {
          client_id: process.env.VUE_APP_CLIENT_ID,
          client_secret: process.env.VUE_APP_CLIENT_SECRET,
          refresh_token: this.$store.state.refresh_token,
          grant_type: 'refresh_token',
        })
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
      })
    },

    scrollBlurLogic() {
      let el = document.querySelector(`.drawer-scroll-list`)
      if (el && el.scrollTop+1 >= el.scrollHeight - el.clientHeight) {
        this.isShowScrollBlur = false
      } else {
        this.isShowScrollBlur = true
      }
    },

    // 사용 기한 만료 dialog 내용 복사
    copyDateExpirationDialogContent() {
      console.log('copyDateExpirationDialogContent')
      const t = document.createElement("textarea")
      document.body.appendChild(t)
      t.value = `사용 기한이 만료된 계정에 대해 문의드립니다.\n\n`
      t.value += `이름 ${this.$store.state.user_info.name}\n`
      t.value += `이메일 ${this.$store.state.user_info.email}\n`
      t.value += `조직 ${this.$store.state.user_info.organization_root_name}`
      if (this.$store.state.user_info.organization_root !== this.$store.state.user_info.organization_sub) {
        t.value += ` > ${this.$store.state.user_info.organization_sub_name}\n`
      } else {
        t.value += `\n`
      }
      let date = this.$store.state.user_info.paid_expire_date.split('T')[0]
      let yyyy = date.split('-')[0]
      let mm1 = date.split('-')[1]
      let dd = date.split('-')[2]
      let result = yyyy + '-' + mm1 + '-' + dd
      t.value += `만료일 ${result}`
      t.select()
      document.execCommand('copy')
      document.body.removeChild(t)
      this.showCopyCompleteSnackbar = true
    },

    // web 인지 mobile 인지 판별
    checkDevice() {
      let userAgent = navigator.userAgent.toLowerCase()
      this.isMobile = /iphone|ipad|ipod|android|blackberry|opera mini|iemobile|wpdesktop/.test(userAgent)
      console.log('isMobile', this.isMobile)
    },
    // resize 탐지
    resizeWindow() {
      console.log('App.vue resizeWindow', window.innerWidth, window.innerHeight)

      this.window_innerWidth = window.innerWidth
      console.log('window_innerWidth', this.window_innerWidth)
      this.checkDevice()
      // if (this.window_innerWidth > 768) {
      //   this.top_alert_height = '70px'
      // } else {
      //   this.top_alert_height = '86px'
      // }

      this.window_innerHeight = window.innerHeight
      console.log('window_innerHeight', this.window_innerHeight)
    },

    isAsyncTaskStatusListSessionActive(session = this.asyncTaskPanelSession) {
      return !this._isDestroyed && !this._isBeingDestroyed
        && session === this.asyncTaskPanelSession
        && shouldRunWorkspaceServices(this.$route, this.$store.getters.isLoggedIn)
    },
    ensureAsyncTaskStatusListRefreshInterval() {
      if (!this.isAsyncTaskStatusListSessionActive()) return
      if (this.asyncTaskStatusListRefreshInterval != null) return
      const session = this.asyncTaskPanelSession
      this.asyncTaskStatusListRefreshInterval = setInterval(() => {
        if (!this.isAsyncTaskStatusListSessionActive(session)) return
        this.getAsyncTaskStatusList().catch(() => {})
      }, this.asyncTaskStatusListRefreshDelay)
    },
    stopAsyncTaskStatusListPolling() {
      clearInterval(this.asyncTaskStatusListRefreshInterval)
      this.asyncTaskStatusListRefreshInterval = null
      // Replacing the session also invalidates in-flight requests and queued timer callbacks.
      this.asyncTaskPanelSession = stopAsyncTaskPanelSession(this.asyncTaskPanelSession)
      this.asyncTaskStatusListPreviousInProgressKeys = []
    },
    stopAsyncTaskStatusListPanel({ refreshDataList = true } = {}) {
      this.stopAsyncTaskStatusListPolling()
      this.showAsyncTaskStatusListPanel = false
      if (!refreshDataList) return
      this.$store.commit('set_getDataListInterval', true)
      setTimeout(() => {
        this.$store.commit('set_getDataListInterval', false)
      }, 500);
    },
    syncAsyncTaskStatusListPanel() {
      if (!this.isAsyncTaskStatusListSessionActive()) return false
      if (!hasInProgressAsyncTasks(this.asyncTaskStatusList_filtered)) {
        this.stopAsyncTaskStatusListPolling()
        return false
      }
      this.showAsyncTaskStatusListPanel = true
      this.expandAsyncTaskStatusListPanel = true
      this.ensureAsyncTaskStatusListRefreshInterval()
      return true
    },
    openAsyncTaskStatusListPanel(options = {}) {
      if (!this.isAsyncTaskStatusListSessionActive()) return Promise.resolve(null)
      const resetTransitionHistory = shouldResetAsyncTaskTransitionHistory(this.asyncTaskPanelSession, options.projectPk)
      clearInterval(this.asyncTaskStatusListRefreshInterval)
      this.asyncTaskStatusListRefreshInterval = null
      this.asyncTaskPanelSession = startAsyncTaskPanelSession(this.asyncTaskPanelSession, options.projectPk)
      if (resetTransitionHistory) {
        this.asyncTaskStatusListPreviousInProgressKeys = []
      }
      this.ensureAsyncTaskStatusListRefreshInterval()
      return this.getAsyncTaskStatusList()
    },
    asyncTaskStatusKey(async_item = {}) {
      return String(async_item.pk || async_item.id || async_item.task_id || '')
    },
    emitWorkManagementAsyncTaskUpdated(async_item = {}) {
      if (async_item.task_type !== 'rpa') return
      this.$root.$emit('work-management-rpa-async-task-updated', async_item)
    },
    handleAsyncTaskStatusListTransitions(list = []) {
      const previousInProgressKeys = new Set(this.asyncTaskStatusListPreviousInProgressKeys || [])
      const currentInProgressKeys = new Set()
      list.forEach(async_item => {
        const key = this.asyncTaskStatusKey(async_item)
        if (!key) return
        if (isAsyncTaskInProgress(async_item)) {
          if (async_item.task_type !== 'rpa') return
          currentInProgressKeys.add(key)
          return
        }
        if (previousInProgressKeys.has(key)) {
          this.emitWorkManagementAsyncTaskUpdated(async_item)
        }
      })
      previousInProgressKeys.forEach(key => {
        if (currentInProgressKeys.has(key)) return
        if (!list.some(async_item => this.asyncTaskStatusKey(async_item) === key)) {
          this.$root.$emit('work-management-rpa-async-task-updated', { task_type: 'rpa', pk: key })
        }
      })
      this.asyncTaskStatusListPreviousInProgressKeys = Array.from(currentInProgressKeys)
    },

    // 비동기 작업 목록 조회 api 호출 interval 관련
    checkGetAsyncTaskStatusListInterval() {
      return new Promise((resolve) => {
        console.log('checkGetAsyncTaskStatusListInterval')
        this.getAsyncTaskStatusList().then(res => {
          console.log('getAsyncTaskStatusList res', res)
          console.log('asyncTaskStatusList_filtered', this.asyncTaskStatusList_filtered)
          resolve(hasInProgressAsyncTasks(this.asyncTaskStatusList_filtered) ? 1 : 0)
        })
      })
    },
    // 비동기 작업 목록 조회
    getAsyncTaskStatusList() {
      const session = this.asyncTaskPanelSession
      if (!this.isAsyncTaskStatusListSessionActive(session)) return Promise.resolve(null)
      return new Promise((resolve, reject) => {
        console.log('getAsyncTaskStatusList')
        let params = {
          order: this.$store?.state?.user_info?.sort_json?.aiAgentCurrentOrder ?? '-created_at',
          limit: 9999,
          is_read: false,
          // status: ['Running', 'Finished', 'Initialize Fail', 'Failed', 'Starting Error', 'Engine Error'], // 'CANCELED'
        }
        const projectPk = this.asyncTaskPanelSession.status === 'tracking'
          ? this.asyncTaskPanelSession.projectPk
          : this.$store.state.current_project_pk || this.$route.params.pk
        if (projectPk) {
          params.project = projectPk
        } else {
          params.user = this.$store.state.user_info.pk
        }
        console.log('params', params)

        http
        .get('annotation/async-task-status/', { params: params, paramsSerializer: params => { return qs.stringify(params, {arrayFormat: 'repeat'}) }, headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
        .then(res => {
          if (!this.isAsyncTaskStatusListSessionActive(session)) return resolve(null)
          console.log('getAsyncTaskStatusList res', res)
          this.asyncTaskStatusList = res?.data
          this.handleAsyncTaskStatusListTransitions(this.asyncTaskStatusList || [])
          console.log('asyncTaskStatusList', this.asyncTaskStatusList)
          console.log('asyncTaskStatusList_filtered', this.asyncTaskStatusList_filtered)
          this.syncAsyncTaskStatusListPanel()
          resolve(res)
        })
        .catch(err => {
          if (!this.isAsyncTaskStatusListSessionActive(session)) return resolve(null)
          reject(err)
          console.log(err)
          console.log(err.response)
          if (err.authRetryExhausted) {
            this.stopAsyncTaskStatusListPanel({ refreshDataList: false })
          }
          if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
            this.methodRecall()
            .then(msg => {
              if (!this.isAsyncTaskStatusListSessionActive(session)) return
              console.log(msg)
              this.getAsyncTaskStatusList().catch(() => {}) // method 재호출
            })
            .catch(err_msg => {
              if (!this.isAsyncTaskStatusListSessionActive(session)) return
              console.log(err_msg)
              if (err_msg === 0) {
                console.log('BE에 access token 저장 실패')
              } else { // err_msg === 1
                console.log('refresh token 만료(access token 갱신 실패)')
                // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
                this.stopAsyncTaskStatusListPanel({ refreshDataList: false })
                this.$store.commit('logout')
                this.$router.push('/').catch(() => {})
              }
            })
          }
        })
      })
    },
    // 비동기 작업 목록 아이템 클릭
    async clickAsyncItem(async_item) {
      console.log('clickAsyncItem', async_item)

      // 실행 중
      if (async_item.status === 'Running') { // 취소하기
        // this.removeAsyncTask(async_item)
      }
      // 완료
      else if (async_item.status === 'Finished') { // 결과 보기
        // 프로젝트 복사 관련
        if (async_item.task_type === 'project') {
          // 결과가 있는 경우
          if (async_item?.result?.[0]?.id) {
            // 읽음 처리
            this.readAsyncTask(async_item).then(() => {
              this.getAsyncTaskStatusList()
            })
            // 해당 프로젝트로 이동
            let project = this.$store.state.project_list.filter(v => v.pk === async_item?.result?.[0]?.id)[0]
            if (project) {
              this.goProject(project)
            } else {
              this.$router.push(`/dashboard/${async_item?.result?.[0]?.id}`).catch(() => {})
            }
          }
          // 결과가 없는 경우
          else {
            this.$store.commit('swalToast', {title: '결과가 없습니다.', type: 'warning'})
          }
        }
        // 비동기 다운로드 관련
        else if (async_item.task_type === 'export') {
          this.downloadAsyncExcelExport(async_item.pk)
          // 읽음 처리
          this.readAsyncTask(async_item).then(() => {
            this.getAsyncTaskStatusList()
          })
        }
        // 이외
        else {
          // 결과가 있는 경우
          if (async_item?.result?.[0]?.id) {
            // 읽음 처리
            this.readAsyncTask(async_item).then(() => {
              this.getAsyncTaskStatusList()
            })
            // 테이블 파일인 경우 (category === 'master')
            if (async_item?.result?.[0]?.category === 'master') {
              // 테이블 메뉴가 아닌 경우
              if (this.$route.name !== 'Table') {
                // 테이블 메뉴 이동 > 해당 파일 클릭
                this.$router.push({ path: `/table/${this.$store.state.current_project_pk}`, query: {async_item_id: async_item?.result?.[0]?.id} })
                .then(() => { window.scrollTo(0,0) })
                .catch(() => {})
              }
              // 테이블 메뉴인 경우
              else {
                // 해당 파일 클릭
                console.log('this.$refs', this.$refs)
                this.$refs.routerView.$children.forEach(_vue_component => {
                  if (_vue_component.$vnode && _vue_component.$vnode.data && _vue_component.$vnode.data.ref === 'FolderList') {
                    _vue_component.refreshAndOpenFile(async_item?.result?.[0]?.id)
                  }
                });
              }
            }
            // 테이블 파일이 아닌 경우
            else {
              // 데이터 메뉴가 아닌 경우
              if (this.$route.name !== 'DataManagement') {
                // 데이터 메뉴 이동 > 해당 파일 클릭
                this.$router.push({ path: `/data-management/${this.$store.state.current_project_pk}`, query: {async_item_id: async_item?.result?.[0]?.id} })
                .then(() => { window.scrollTo(0,0) })
                .catch(() => {})
              }
              // 데이터 메뉴인 경우
              else {
                // 해당 파일 클릭
                console.log('this.$refs', this.$refs)
                this.$refs.routerView.$children.forEach(_vue_component => {
                  if (_vue_component.$vnode && _vue_component.$vnode.data && _vue_component.$vnode.data.ref === 'FolderList') {
                    _vue_component.refreshAndOpenFile(async_item?.result?.[0]?.id)
                  }
                });
              }
            }
          }
          // 결과가 없는 경우
          else {
            this.$store.commit('swalToast', {title: '결과가 없습니다.', type: 'warning'})
          }
        }
      }
      // 오류
      else if (async_item.status?.includes('Error') || async_item.status?.includes('Fail')) { // 확인하기
        // 읽음 처리
        this.readAsyncTask(async_item).then(() => {
          let project_pk = null
          if (async_item.task_type === 'project') {
            project_pk = async_item.project
          }
          this.getAsyncTaskStatusList(project_pk)
        })
        // 워크플로우
        if (async_item.task_type === 'rpa') {
          if (async_item.parent_id) {
            let asyncTaskLogList = await this.getAsyncTaskLogList(async_item)
            console.log('asyncTaskLogList', asyncTaskLogList)
            let rpa_id = null
            let block_id = null
            asyncTaskLogList.forEach(log_item => {
              if (log_item && log_item.msg === 'error') {
                if (log_item.data) {
                  if (log_item.data.fail_type === 'run_rpa' && log_item.data.error) {
                    rpa_id = log_item.data.error.rpa_id
                    block_id = log_item.data.error.fail
                  } else {
                    rpa_id = async_item.parent_id
                    block_id = log_item.data.fail
                  }
                } else {
                  let blockIdMatch = log_item.log?.match(/RPA Activity ID\s+(\S+)/)
                  if (blockIdMatch?.[1]) {
                    rpa_id = async_item.parent_id
                    block_id = blockIdMatch[1]
                  }
                }
              }
            });
            console.log('rpa_id', rpa_id)
            console.log('block_id', block_id)
            if (rpa_id && block_id) {
              console.log('set_async_error_block_id', block_id)
              this.$store.commit("set_async_error_block_id", block_id)
              // 워크플로우 설계창으로 이동
              this.$router.push({ path: `/rpa/${this.$store.state.current_project_pk}/${rpa_id}` }).catch(() => {})
            } else {
              this.$store.commit('swalToast', {title: '워크플로우로 이동할 수 없습니다.(1)', type: 'warning'})
            }
          } else {
            this.$store.commit('swalToast', {title: '워크플로우로 이동할 수 없습니다.(2)', type: 'warning'})
          }
        }
        else {
          let swal_text = ''
          if (async_item.task_type === 'project') { // 프로젝트 복사
            swal_text = `'${async_item.name}' 프로젝트 복사 도중 오류가 발생했습니다. <br> 자세한 사항은 아래 버튼을 통해 문의해 주세요.`
          }
          else if (async_item.task_type === 'data') { // 데이터
            swal_text = `'${async_item.name}' 파일을 업로드할 수 없습니다. <br> 자세한 사항은 아래 버튼을 통해 문의해 주세요.`
          }
          else if (async_item.task_type === 'crawler') { // 크롤러
            swal_text = `'${async_item.name}'에서 오류가 발생했습니다. <br> 자세한 사항은 아래 버튼을 통해 문의해 주세요.`
          }
          else if (async_item.task_type === 'text-ie') { // PDF 분류
            swal_text = `'${async_item.name}' PDF 분류 도중 오류가 발생했습니다. <br> 자세한 사항은 아래 버튼을 통해 문의해 주세요.`
          }
          Swal.fire({
            icon: 'warning',
            html: `
              <div style="display: flex; flex-direction: column; align-items: center">
                <div style="font-size: 16px; font-weight: 500; line-height: 23px; color: #414458">
                  ${swal_text}
                </div>
              </div>
            `,
            confirmButtonText: '채널톡 문의하기',
            focusConfirm: true,
            showCancelButton: true,
            cancelButtonText: '취소',
            reverseButtons: true,
            preConfirm: () => {
              console.log('ChannelService.shutdown')
              ChannelService.shutdown()
              console.log('ChannelService.boot - 비동기 작업 > 채널톡 문의하기')
              ChannelService.boot({
                pluginKey: process.env.VUE_APP_CHANNEL_SERVICE_PLUGIN_ID,
                memberId: this.$store.state.user_info.pk,
                profile: { name: this.$store.state.user_info.name },
                customLauncherSelector: async_item.task_type === 'project' ? ".channel-talk-btn-3" : ".channel-talk-btn-1",
                hideChannelButtonOnBoot: true
              });
              let btn_el = async_item.task_type === 'project' ? document.querySelector('.channel-talk-btn-3') : document.querySelector('.channel-talk-btn-1')
              setTimeout(() => {
                console.log('btn_el', btn_el)
                btn_el.click()
              }, 100);
            }
          })
        }
      }
    },
    // 비동기 다운로드 (GET download-async-excel-export)
    downloadAsyncExcelExport(async_pk) {
      return new Promise((resolve, reject) => {
        console.log('downloadAsyncExcelExport', async_pk)
        http.get(`annotation/download-async-excel-export/${async_pk}/`,
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.state.access_token, 'Content-Type': 'multipart/form-data',
            },
            responseType: 'blob',
          }
        )
        .then(async response => {
          console.log('downloadAsyncExcelExport response', response)
          await downloadBlobResponse(response)
          resolve(response)
        })
        .catch(err => {
          this.isLoadingTree = false
          if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) {
            this.methodRecall()
            .then(() => this.downloadAsyncExcelExport(async_pk))
            .catch(e => { if (e === 1) { this.$store.commit('logout'); this.$router.push('/').catch(() => {}) } })
          }
          reject(err)
        })
      })
    },
    // 비동기 작업 > 로그 호출
    getAsyncTaskLogList(asyncTaskStatus) {
      return new Promise((resolve, reject) => {
        console.log('getAsyncTaskLogList', asyncTaskStatus)
        let params = {
          order: '-created_at',
          async_task: asyncTaskStatus.id ? asyncTaskStatus.id : asyncTaskStatus.pk,
        }
        params.page = 1
        console.log('params', params)
        http
        .get('annotation/async-task-log/', { params: params, headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
        .then(res => {
          console.log('getAsyncTaskLogList res', res)
          let _currentAsyncTaskLogList = res?.data?.items
          if (_currentAsyncTaskLogList) {
            _currentAsyncTaskLogList = _currentAsyncTaskLogList.map(v => {
              if (v.data && typeof v.data === 'string') {
                v.data = JSON.parse(v.data)
              }
              return v
            })
          } else {
            _currentAsyncTaskLogList = []
          }
          console.log('setCurrentAsyncTaskLogList', _currentAsyncTaskLogList)
          resolve(_currentAsyncTaskLogList)
        })
        .catch(err => {
          reject(err)
          console.log(err)
          console.log(err.response)
          if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
            this.methodRecall()
            .then(msg => {
              console.log(msg)
              this.getAsyncTaskLogList(asyncTaskStatus) // method 재호출
            })
            .catch(err_msg => {
              this.isLoadingAsyncTaskLogList = false
              console.log(err_msg)
              if (err_msg === 0) {
                console.log('BE에 access token 저장 실패')
              } else { // err_msg === 1
                console.log('refresh token 만료(access token 갱신 실패)')
                // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
                this.$store.commit('logout')
                this.$router.push('/').catch(() => {})
              }
            })
          }
        })
      })
    },
    // 비동기 작업 목록 패널 > close btn 클릭
    async clickCloseBtn_asyncTaskStatusListPanel() {
      console.log('clickCloseBtn_asyncTaskStatusListPanel')
      console.log('asyncTaskStatusList_filtered', this.asyncTaskStatusList_filtered)
      // 모든 항목 읽음 처리
      for await (let async_item of this.asyncTaskStatusList_filtered) {
        if (async_item.status !== 'Running') {
          this.readAsyncTask(async_item)
        }
      }
      this.stopAsyncTaskStatusListPanel()
    },
    // 비동기 작업 읽음 처리
    readAsyncTask(async_item) {
      return new Promise((resolve, reject) => {
        console.log('readAsyncTask', async_item)
        let form = new FormData()
        form.append('is_read', true)
        http
        .put(`annotation/async-task-status/${async_item.pk}/`, form, { headers: { Authorization: 'Bearer ' + this.$store.state.access_token }})
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
          console.log(err)
          console.log(err.response)
          if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
            this.methodRecall()
            .then(msg => {
              console.log(msg)
              this.readAsyncTask(async_item) // method 재호출
            })
            .catch(err_msg => {
              console.log(err_msg)
              if (err_msg === 0) {
                console.log('BE에 access token 저장 실패')
              } else { // err_msg === 1
                console.log('refresh token 만료(access token 갱신 실패)')
                // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
                this.$store.commit('logout')
                this.$router.push('/').catch(() => {})
              }
            })
          }
        })
      })
    },
    // 비동기 작업 취소하기(삭제)
    removeAsyncTask(async_item) {
      console.log('removeAsyncTask', async_item)
      http
      .delete(`annotation/async-task-status/${async_item.pk}/`, { headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
      .then(res => {
        console.log('removeAsyncTask res', res)
        this.getAsyncTaskStatusList()
      })
      .catch(err => {
        console.log(err)
        console.log(err.response)
        if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
          this.methodRecall()
          .then(msg => {
            console.log(msg)
            this.removeAsyncTask(async_item) // method 재호출
          })
          .catch(err_msg => {
            console.log(err_msg)
            this.$store.commit('setOverlay', false)
            this.$store.commit('setOverlayText', '')
            if (err_msg === 0) {
              console.log('BE에 access token 저장 실패')
            } else { // err_msg === 1
              console.log('refresh token 만료(access token 갱신 실패)')
              // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
              this.$store.commit('logout')
              this.$router.push('/').catch(() => {})
            }
          })
        }
      })
    },
    // 프로젝트 이동
    goProject(project) {
      console.log('goProject', project)
      if (!project) {
        console.log('project 없음')
        return false
      }
      this.$store.commit('setCurrentProject', project)
      this.$store.commit('setCurrentProjectTitle', project.name)
      this.$store.commit('setCurrentProjectPk', project.pk)

      this.$store.commit('setOverlay', false)
      this.$store.commit('setOverlayText', '')

      // 무료체험(trial) 사용자 전용 로직
      if (this.$store.state.user_info.plan === 'trial') {
        this.$router.push(`/data-management/${project.pk}`).catch(() => {})
        // 튜토리얼 진행 중일 경우
        if (project.is_tutorial && this.$store.state.tutorialStep === 1) {
          this.$store.commit('setTutorialStep', 2)
        }
      }
      // 기존 사용자 로직
      else {
        const firstMenu = getFirstAccessibleProjectMenu(this.$store.state.menuPermissionList, this.$store.state.user_info, project)
        const route = getProjectMenuRoute(firstMenu, project.pk)
        if (route) {
          this.$gtag.event('click', {
            event_category: 'go',
            event_label: 'project',
            value: 'go_project',
          })
          this.$router.push(route).catch(() => {})
        }
      }
    },
  },

  created() {
    console.log('App.vue created')
    // 상단 공지 > 특정 일자 까지만 표시하는 로직
    this.set_top_alert()
  },

  mounted() {
    console.log('App.vue mounted')

    console.log('i18n.locale', i18n.locale)
    console.log('NODE_ENV', process.env.NODE_ENV)

    const runWorkspaceServices = shouldRunWorkspaceServices(this.$route, this.$store.getters.isLoggedIn)

    if (!runWorkspaceServices) {
      this.bootPublicChannelService()
    }

    if (runWorkspaceServices) {
      this.ensureProjectIconImages().catch(err => {
        console.log('ensureProjectIconImages error', err)
      })
      this.refreshLeadBadgeCountIfNeeded()
      this.refreshNotificationSummaryIfNeeded().catch(() => {})
    }

    if (runWorkspaceServices && this.navbarActionRoute) {
      console.log('ChannelService.boot - 회원 - navbar > 문의하기 버튼 - mounted')
      ChannelService.boot({
        pluginKey: process.env.VUE_APP_CHANNEL_SERVICE_PLUGIN_ID, // fill your plugin key
        memberId: this.$store.state.user_info.pk, // fill user's member id
        profile: { // fill user's profile
          name: this.$store.state.user_info.name, // fill user's name
          // mobileNumber: "USER_MOBILE_NUMBER", // fill user's mobile number
          // CUSTOM_VALUE_1: "VALUE_1", // custom property
          // CUSTOM_VALUE_2: "VALUE_2" // custom property
        },
        customLauncherSelector: ".channel-talk-btn-1",
        hideChannelButtonOnBoot: true
      });
      if (typeof window.ChannelIO === "function") {
        window.ChannelIO("onChatCreated", () => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: "channel_talk" });
        });
        window.ChannelIO("onShowMessenger", () => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: "channel_talk" });
        });
      }
    }

    if (document.fonts) {
      document.fonts.ready.then(() => {
        this.fontReady = true;
      });
    } else {
      // fallback: 폰트 API 없는 브라우저는 그냥 보여줌
      this.fontReady = true;
    }

    document.title = this.projectTitle
    this.$root.$on('open-async-task-status-list-panel', this.openAsyncTaskStatusListPanel)
    window.addEventListener('resize', this.resizeWindow)
    this.resizeWindow()
    setTimeout(() => {
      this.resizeWindow()
    }, 1000);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollBlurLogic)
    this.$root.$off('open-async-task-status-list-panel', this.openAsyncTaskStatusListPanel)
    this.stopAsyncTaskStatusListPanel({ refreshDataList: false })
  },

  watch: {
    mypageDialog(isOpen) {
      if (!isOpen) this.passwordChangeDialog = false
    },
    $route(to, from) {
      console.log('watch $route', to, from)
      const runWorkspaceServices = shouldRunWorkspaceServices(to, this.$store.getters.isLoggedIn)

      // 랜딩·인증 영역에서는 로그인 여부와 관계없이 워크스페이스 서비스를 중지한다.
      if (!runWorkspaceServices) {
        console.log('ChannelService.boot - 공개 영역')
        this.showLlmChatPanel = false
        notificationCenterStore.reset()
        this.bootPublicChannelService()
        // 비동기 작업 목록 관련
        this.stopAsyncTaskStatusListPanel({ refreshDataList: false })
        this.$store.commit('set_getDataListInterval', true)
        setTimeout(() => {
          this.$store.commit('set_getDataListInterval', false)
        }, 500);
        return
      }

      // 테이블 선택 상태의 URL 동기화는 페이지 이동이 아니므로 공통 서비스를 재조회하지 않는다.
      if (isTableViewStateOnlyChange(to, from)) return

      this.ensureProjectIconImages().catch(err => {
        console.log('ensureProjectIconImages error', err)
      })

      // 프로젝트 외부로 나온 경우
      if (!this.mainRouter || !this.$store.state.current_project_pk) {
        this.$store.commit('leaveProject')
      }

      console.log('permissionLevel', this.$store.getters.permissionLevel)
      this.projectDropdownMenu = false

      // 리드 관리 알림 개수
      this.refreshLeadBadgeCountIfNeeded(to.name)

      // 통합 알림 미읽음 개수
      this.refreshNotificationSummaryIfNeeded().catch(() => {})

      // 비동기 작업 목록 관련
      this.getAsyncTaskStatusList()

      // ChannelService 관련
      if (!this.navbarActionRoute) {
        console.log('ChannelService.boot - 회원 - 기본 버튼(우측 하단)')
        ChannelService.boot({
          pluginKey: process.env.VUE_APP_CHANNEL_SERVICE_PLUGIN_ID, // fill your plugin key
          memberId: this.$store.state.user_info.pk, // fill user's member id
          profile: { // fill user's profile
            name: this.$store.state.user_info.name, // fill user's name
            // mobileNumber: "USER_MOBILE_NUMBER", // fill user's mobile number
            // CUSTOM_VALUE_1: "VALUE_1", // custom property
            // CUSTOM_VALUE_2: "VALUE_2" // custom property
          },
        })
      } else {
        console.log('ChannelService.boot - 회원 - navbar > 문의하기 버튼 - watch')
        ChannelService.boot({
          pluginKey: process.env.VUE_APP_CHANNEL_SERVICE_PLUGIN_ID, // fill your plugin key
          memberId: this.$store.state.user_info.pk, // fill user's member id
          profile: { // fill user's profile
            name: this.$store.state.user_info.name, // fill user's name
            // mobileNumber: "USER_MOBILE_NUMBER", // fill user's mobile number
            // CUSTOM_VALUE_1: "VALUE_1", // custom property
            // CUSTOM_VALUE_2: "VALUE_2" // custom property
          },
          customLauncherSelector: ".channel-talk-btn-1",
          hideChannelButtonOnBoot: true
        });
      }
    },
    projectTitle(projectTitle) {
      console.log('watch projectTitle', projectTitle)
      document.title = projectTitle
    },
    projectDropdownMenu(projectDropdownMenu) {
      console.log('watch projectDropdownMenu', projectDropdownMenu)
      if (!projectDropdownMenu) {
        this.searchPjtNameInput = ''
        this.searchedWorkflowName = ''
        this.isSearchingPjt = false
      }
    },
    workflowDropdownMenu(workflowDropdownMenu) {
      console.log('watch workflowDropdownMenu', workflowDropdownMenu)
      if (!workflowDropdownMenu) {
        this.searchWorkflowNameInput = ''
        this.searchedWorkflowName = ''
        this.isSearchingWorkflow = false
      }
    },
    insightDropdownMenu(insightDropdownMenu) {
      console.log('watch insightDropdownMenu', insightDropdownMenu)
      if (!insightDropdownMenu) {
        this.searchInsightNameInput = ''
        this.searchedInsightName = ''
        this.isSearchingInsight = false
      }
    },
    tutorialAndContactMenu(tutorialAndContactMenu) {
      console.log('watch tutorialAndContactMenu', tutorialAndContactMenu)
      if (tutorialAndContactMenu) {
        console.log('ChannelService.shutdown')
        ChannelService.shutdown()
        console.log('ChannelService.boot - 좌측 사이드바 > 문의하기 버튼 - 2')
        ChannelService.boot({
          pluginKey: process.env.VUE_APP_CHANNEL_SERVICE_PLUGIN_ID, // fill your plugin key
          memberId: this.$store.state.user_info.pk, // fill user's member id
          profile: { // fill user's profile
            name: this.$store.state.user_info.name, // fill user's name
            // mobileNumber: "USER_MOBILE_NUMBER", // fill user's mobile number
            // CUSTOM_VALUE_1: "VALUE_1", // custom property
            // CUSTOM_VALUE_2: "VALUE_2" // custom property
          },
          customLauncherSelector: ".channel-talk-btn-1",
          hideChannelButtonOnBoot: true
        });
      }
    },
    contactDialog(contactDialog) {
      console.log('watch contactDialog', contactDialog)
      if (contactDialog) {
        this.manualDownloadDialog = false
      }
      this.contactDialog_inquiryInput = ''
      this.contactDialog_answerPath = '전화'
      this.contactDialog_ableTimeInput = ''
      this.contactDialog_contactInput = ''
      this.contactDialog_privacyPolicy = false
      if (this.window_innerWidth <= 440) {
        window.scrollTo(0,0)
      }
    },
    manualDownloadDialog(manualDownloadDialog) {
      console.log('watch manualDownloadDialog', manualDownloadDialog)
      if (manualDownloadDialog) {
        this.contactDialog = false
      }
      this.manualDownloadDialog_nameInput = ''
      this.manualDownloadDialog_emailInput = ''
      this.manualDownloadDialog_companyInput = ''
      this.manualDownloadDialog_positionInput = ''
      this.manualDownloadDialog_phoneNumberInput = ''
      this.manualDownloadDialog_privacyPolicy = false
      this.manualDownloadDialog_marketingReception = false
      if (this.window_innerWidth <= 440) {
        window.scrollTo(0,0)
      }
    },
  }
}
</script>

<style>
/* <---- 반응형 관련 */
@media (min-width: 1441px) { /* 1441px 이상 */
  .nav-bar {
    width: 1200px;
  }
  .plan-guide-section {
    width: 1240px;
  }
  .customer-example-detail-section {
    width: 1000px;
    margin-top: 64px;
  }
  .customer-example-detail-title-font {
    font-size: 40px;
  }
  .customer-example-detail-sub-font {
    font-size: 17px;
  }
  .newsroom-detail-section {
    width: 1000px;
  }
  .newsroom-detail-title-font {
    font-size: 40px;
  }
  .newsroom-detail-content-font {
    font-size: 17px;
    line-height: 145%;
  }
}
@media (min-width: 1025px) and (max-width: 1440px) { /* 1025px ~ 1440px */
  .show-over-911-under-1440 { display: block !important; }
  .show-over-701-under-1440 { display: block !important; }

  .show-over-1025-under-1440 { display: block !important; }
  .show-over-769-under-1440 { display: block !important; }
  .show-over-481-under-1440 { display: block !important; }
  .show-over-320-under-1440 { display: block !important; }

  .nav-bar {
    width: 825px;
  }
  .plan-guide-section {
    width: calc(100vw - calc(100px * 2));
  }
  .customer-example-detail-section {
    width: 825px;
    margin-top: 64px;
  }
  .customer-example-detail-title-font {
    font-size: 40px;
  }
  .customer-example-detail-sub-font {
    font-size: 17px;
  }
  .newsroom-detail-section {
    width: 825px;
  }
  .newsroom-detail-title-font {
    font-size: 40px;
  }
  .newsroom-detail-content-font {
    font-size: 17px;
    line-height: 145%;
  }
}
@media (min-width: 769px) and (max-width: 1024px) { /* 769px ~ 1024px */
  .show-over-911-under-1440 { display: block !important; }
  .show-over-701-under-1440 { display: block !important; }
  .show-over-441-under-1440 { display: block !important; }
  .show-over-911-under-1024 { display: block !important; }
  .show-over-701-under-1024 { display: block !important; }
  .show-over-441-under-1024 { display: block !important; }

  .show-over-769-under-1440 { display: block !important; }
  .show-over-481-under-1440 { display: block !important; }
  .show-over-320-under-1440 { display: block !important; }
  .show-over-769-under-1024 { display: block !important; }
  .show-over-481-under-1024 { display: block !important; }
  .show-over-320-under-1024 { display: block !important; }

  .nav-bar {
    width: calc(100vw - calc(16px * 2));
  }
  .plan-guide-section {
    width: calc(100vw - calc(100px * 2));
  }
  .customer-example-detail-section {
    width: 669px;
    margin-top: 64px;
  }
  .customer-example-detail-title-font {
    font-size: 40px;
  }
  .customer-example-detail-sub-font {
    font-size: 17px;
  }
  .newsroom-detail-section {
    width: 669px;
  }
  .newsroom-detail-title-font {
    font-size: 40px;
  }
  .newsroom-detail-content-font {
    font-size: 17px;
    line-height: 145%;
  }
}
@media (min-width: 481px) and (max-width: 768px) { /* 481px ~ 768px */
  .show-over-701-under-1440 { display: block !important; }
  .show-over-441-under-1440 { display: block !important; }
  .show-over-701-under-1024 { display: block !important; }
  .show-over-441-under-1024 { display: block !important; }
  .show-over-701-under-910 { display: block !important; }
  .show-over-441-under-910 { display: block !important; }

  .show-over-481-under-1440 { display: block !important; }
  .show-over-320-under-1440 { display: block !important; }
  .show-over-481-under-1024 { display: block !important; }
  .show-over-320-under-1024 { display: block !important; }
  .show-over-481-under-768 { display: block !important; }
  .show-over-320-under-768 { display: block !important; }

  .nav-bar {
    width: calc(100vw - calc(16px * 2));
  }
  .customer-example-detail-section {
    width: calc(100vw - calc(16px * 2));
    margin-top: 40px;
  }
  .customer-example-detail-title-font {
    font-size: 30px;
  }
  .customer-example-detail-sub-font {
    font-size: 18px;
  }
  .newsroom-detail-section {
    width: calc(100vw - calc(16px * 2));
  }
  .newsroom-detail-title-font {
    font-size: 30px;
  }
  .newsroom-detail-content-font {
    font-size: 18px;
    line-height: 160%;
  }
}
@media (min-width: 320px) and (max-width: 480px) { /* 320px ~ 480px */
  .show-over-441-under-1440 { display: block !important; }
  .show-over-441-under-1024 { display: block !important; }
  .show-over-441-under-910 { display: block !important; }
  .show-over-441-under-700 { display: block !important; }

  .show-over-320-under-1440 { display: block !important; }
  .show-over-320-under-1024 { display: block !important; }
  .show-over-320-under-768 { display: block !important; }
  .show-over-320-under-480 { display: block !important; }

  .nav-bar {
    width: calc(100vw - calc(16px * 2));
  }
  .plan-guide-section {
    width: 392px;
  }
  .customer-example-detail-section {
    width: calc(100vw - calc(16px * 2));
    margin-top: 40px;
  }
  .customer-example-detail-title-font {
    font-size: 30px;
  }
  .customer-example-detail-sub-font {
    font-size: 18px;
  }
  .newsroom-detail-section {
    width: calc(100vw - calc(16px * 2));
  }
  .newsroom-detail-title-font {
    font-size: 30px;
  }
  .newsroom-detail-content-font {
    font-size: 18px;
    line-height: 160%;
  }
}
@media (max-width: 319px) { /* 319px 이하 */
  .nav-bar {
    width: calc(100vw - calc(16px * 2));
  }
  .plan-guide-section {
    width: 392px;
  }
  .customer-example-detail-section {
    width: calc(100vw - calc(16px * 2));
    margin-top: 40px;
  }
  .customer-example-detail-title-font {
    font-size: 30px;
  }
  .customer-example-detail-sub-font {
    font-size: 18px;
  }
  .newsroom-detail-section {
    width: calc(100vw - calc(16px * 2));
  }
  .newsroom-detail-title-font {
    font-size: 30px;
  }
  .newsroom-detail-content-font {
    font-size: 18px;
    line-height: 160%;
  }
}
/* 기본적으로 모든 요소는 숨김 처리 */
.show-over-911-under-1440 { display: none; }
.show-over-701-under-1440 { display: none; }
.show-over-441-under-1440 { display: none; }
.show-over-911-under-1024 { display: none; }
.show-over-701-under-1024 { display: none; }
.show-over-441-under-1024 { display: none; }
.show-over-701-under-910 { display: none; }
.show-over-441-under-910 { display: none; }
.show-over-441-under-700 { display: none; }

.show-over-1025-under-1440 { display: none; }
.show-over-769-under-1440 { display: none; }
.show-over-481-under-1440 { display: none; }
.show-over-320-under-1440 { display: none; }
.show-over-769-under-1024 { display: none; }
.show-over-481-under-1024 { display: none; }
.show-over-320-under-1024 { display: none; }
.show-over-481-under-768 { display: none; }
.show-over-320-under-768 { display: none; }
.show-over-320-under-480 { display: none; }
/* 1440px 기준 */
@media (min-width: 1441px) { /* 1441px 이상 */
  .show-over-1441 { display: block; }
  .show-under-1440 { display: none; }
}
@media (max-width: 1440px) { /* 1440px 이하 */
  .show-over-1441 { display: none; }
  .show-under-1440 { display: block; }
}
/* 1024px 기준 */
@media (min-width: 1025px) { /* 1025px 이상 */
  .show-over-1025 { display: block; }
  .show-under-1024 { display: none; }
}
@media (max-width: 1024px) { /* 1024px 이하 */
  .show-over-1025 { display: none; }
  .show-under-1024 { display: block; }
}
/* 910px 기준 */
@media (min-width: 911px) { /* 911px 이상 */
  .show-over-911 { display: block; }
  .show-under-910 { display: none; }
  .customer-example-wrapper {
    padding-top: 50px;
  }
}
@media (max-width: 910px) { /* 910px 이하 */
  .show-over-911 { display: none; }
  .show-under-910 { display: block; }
  .customer-example-wrapper {
    padding-top: 24px;
  }
}
/* 768px 기준 */
@media (min-width: 769px) { /* 769px 이상 */
  .show-over-769 { display: block; }
  .show-under-768 { display: none; }
}
@media (max-width: 768px) { /* 768px 이하 */
  .show-over-769 { display: none; }
  .show-under-768 { display: block; }
}
/* 700px 기준 */
@media (min-width: 701px) { /* 701px 이상 */
  .show-over-701 { display: block; }
  .show-under-700 { display: none; }
  .bottom-section {
    height: 395px;
  }
  .customer-example-detail-content-div {
    width: calc(100% - 40px);
  }
  .customer-example-detail-title-font-1 {
    font-size: 40px;
    line-height: 56px;
  }
  .customer-example-detail-title-font-2 {
    font-size: 30px;
    line-height: 40x;
  }
}
@media (max-width: 700px) { /* 700px 이하 */
  .show-over-701 { display: none; }
  .show-under-700 { display: block; }
  .bottom-section {
    height: 274px;
  }
  .customer-example-detail-content-div {
    width: calc(100% - 8px);
  }
  .customer-example-detail-title-font-1 {
    font-size: 32px;
    line-height: 44px;
  }
  .customer-example-detail-title-font-2 {
    font-size: 24px;
    line-height: 34px;
  }
}
/* 480px 기준 */
@media (min-width: 481px) { /* 481px 이상 */
  .show-over-481 { display: block; }
  .show-under-480 { display: none; }
}
@media (max-width: 480px) { /* 480px 이하 */
  .show-over-481 { display: none; }
  .show-under-480 { display: block; }
}
/* 440px 기준 */
@media (min-width: 441px) { /* 441px 이상 */
  .show-over-441 { display: block; }
  .show-under-440 { display: none; }
}
@media (max-width: 440px) { /* 440px 이하 */
  .show-over-441 { display: none; }
  .show-under-440 { display: block; }
}
/* 428px 기준 */
@media (min-width: 429px) { /* 429px 이상 */
  .show-over-429 { display: block; }
  .show-under-428 { display: none; }
}
@media (max-width: 428px) { /* 428px 이하 */
  .show-over-429 { display: none; }
  .show-under-428 { display: block; }
}
/* 419px 기준 */
@media (min-width: 420px) { /* 420px 이상 */
  .show-over-420 { display: block; }
  .show-under-419 { display: none; }
}
@media (max-width: 419px) { /* 419px 이하 */
  .show-over-420 { display: none; }
  .show-under-419 { display: block; }
}
/* 388px 기준 */
@media (min-width: 389px) { /* 389px 이상 */
  .show-over-389 { display: block; }
  .show-under-388 { display: none; }
}
@media (max-width: 388px) { /* 388px 이하 */
  .show-over-389 { display: none; }
  .show-under-388 { display: block; }
}
/* 반응형 관련 ----> */


/* <---- 공통 */
* {
  text-transform: none !important;
}
html {
  overflow: auto !important;
}
body {
  padding-right: 0 !important;
}
.notification-main-content {
  min-height: 0;
  overflow: clip;
}
.notification-main-content > .v-main,
.notification-main-content > .v-main > .v-main__wrap {
  height: 100%;
  min-height: 0;
  overflow: clip;
}
.font-noto-sans * {
  font-family: "Noto Sans KR" !important;
}
.font-pretendard * {
  font-family: "Pretendard Variable" !important;
}
.height-100vh {
  height: calc(100vh);
}
.cursor-pointer {
  cursor: pointer;
}
.top-0 {
  top: 0px;
}
.top-44 {
  top: 44px;
}
.top-48 {
  top: 48px;
}

.menu-box:hover .menu-icon-box {
  background-color: #E8EAF2;
}

.hover-color:hover {
  color: var(--hover-color);
}
.hover-color-important:hover {
  color: var(--hover-color) !important;
}
.hover-bg-color:hover {
  background-color: var(--hover-bg-color);
}
.navbar-workflow-dropdown-item-default:hover {
  background-color: #F8F9FB;
}
.navbar-workflow-dropdown-item-hidden {
  background-color: #F8F9FB;
}
.navbar-workflow-dropdown-item-hidden:hover,
.navbar-workflow-dropdown-item-selected,
.navbar-workflow-dropdown-item-selected:hover {
  background-color: #EFF0F6;
}
.hover-bg-color-important:hover {
  background-color: var(--hover-bg-color) !important;
}
.focus-bg-color:focus {
  background-color: var(--focus-bg-color);
}
.focus-bg-color-important:focus {
  background-color: var(--focus-bg-color) !important;
}
.hover-border-color:hover {
  border-color: var(--hover-border-color);
}
.hover-border-color-important:hover {
  border-color: var(--hover-border-color) !important;
}
.hover-border-width:hover {
  border-width: var(--hover-border-width);
}
.hover-border-width-important:hover {
  border-width: var(--hover-border-width) !important;
}
.hover-child-color-important:hover .v-icon {
  color: var(--hover-child-icon-color) !important;
  transition: none;
}
.hover-child-color-important:hover div {
  color: var(--hover-child-text-color) !important;
}

.hover-padding-bottom:hover {
  padding-bottom: var(--hover-padding-bottom);
}
.hover-padding-bottom-important:hover {
  padding-bottom: var(--hover-padding-bottom) !important;
}

.hover-box-shadow-1620501A:hover {
  box-shadow: 0px 16px 32px -4px #1620501A;
}
.hover-z-index-10:hover {
  z-index: 10;
}
.hover-color-687EFF:hover {
  color: #687EFF !important;
}
.hover-bg-color-F8F9FB:hover {
  background-color: #F8F9FB;
}
.hover-bg-color-F8F9FB-important:hover {
  background-color: #F8F9FB !important;
}
.hover-bg-color-E8EAF2:hover {
  background-color: #E8EAF2;
}
.hover-bg-color-EFF0F6:hover {
  background-color: #EFF0F6;
}
.hover-bg-color-0D0E170F:hover {
  background-color: #0D0E170F;
}
.hover-bg-color-FFFFFF1A:hover {
  background-color: #FFFFFF1A;
}

.focus-bg-color-F8F9FB:focus {
  background-color: #F8F9FB;
}
.focus-box-shadow-and-border-color-687EFF:focus {
  box-shadow: 0px 0px 16px 0px #687EFF33;
  border-color: #687EFF !important;
}

.gradient-border-box {
  border: 1px solid transparent;
  background-image: linear-gradient(#fff, #fff), linear-gradient(90deg, #687EFF -0.48%, #68B4FF 99.52%);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
.gradient-border-box-btn:hover {
  border-width: 0px !important;
  background: linear-gradient(90deg, #687EFF -0.48%, #68B4FF 99.52%) !important;
}
.gradient-border-box-btn:hover .v-icon, .gradient-border-box-btn:hover div {
  color: #ffffff !important;
}

/* input, textarea 관련 */
.input-area {
  resize: none;
}
.input-area:focus {
  outline: none;
}
.input-area::placeholder {
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  color: #ABAEC4;
}
/* input, textarea 관련 */
.input-area-2 {
  resize: none;
}
.input-area-2:focus {
  outline: none;
}
.input-area-2::placeholder {
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  color: #8A8DA8;
}
/* input, textarea 관련 */
.input-area-3 {
  resize: none;
}
.input-area-3:focus {
  outline: none;
}
.input-area-3::placeholder {
  font-size: 17px;
  font-weight: 400;
  line-height: 140%;
  color: #ABAEC4;
}
/* input, textarea 관련 */
.input-area-4 {
  resize: none;
}
.input-area-4:focus {
  outline: none;
}
.input-area-4::placeholder {
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
  color: #ABAEC4;
}

.focus-hide-placeholder-input:focus::placeholder {
  color: transparent;
}
/* 공통 ----> */

/* hover 시 우측 icon이 표시되는 버튼 (랜딩페이지 도입 문의하기 버튼) */
.hover-show-icon-btn:hover {
  background-color: #FFFFFFDB !important;
}
.hover-show-icon-btn .v-icon {
  display: inline-flex;
  overflow: hidden;
  width: 0;
  opacity: 0;
  transition: width 150ms ease-out, opacity 150ms ease-out;
}
.hover-show-icon-btn:hover .v-icon {
  width: 22px;
  opacity: 1;
}

/* 그라디언트 테마 배경 버튼 */
.default-gradient-theme-btn {
  background: linear-gradient(90deg, #687EFF -0.48%, #68B4FF 99.52%) !important;
  border-radius: 8px !important;
  cursor: pointer !important;
}
.default-gradient-theme-btn div, .default-gradient-theme-btn span {
  color: #FFFFFF !important;
  font-weight: 700 !important;
  word-break: keep-all !important;
}
.default-gradient-theme-btn .v-icon {
  color: #FFFFFF !important;
  animation-timing-function: ease-out;
  animation-duration: 300ms;
}
.default-gradient-theme-btn:hover .v-icon {
  transform: translateX(10px);
}
/* 그라디언트 테마2 배경 버튼 */
.gradient-theme2-btn {
  background: linear-gradient(98.12deg, #0F0C29 3.02%, #302B63 47.65%, #24243E 93.14%);
}
.gradient-theme2-btn::after {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  opacity: 0;
  transition: opacity none;
  pointer-events: none;
}
.gradient-theme2-btn:hover::after {
  opacity: 1;
}
/* 그라디언트 테마 텍스트 */
.gradient-theme-text {
  background: linear-gradient(90deg, #687EFF -0.48%, #68B4FF 99.52%);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
}
/* 그라디언트 테마2 텍스트 */
.gradient-theme2-text {
  background: linear-gradient(98.12deg, #0F0C29 3.02%, #302B63 47.65%, #24243E 93.14%);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
}

/* underline-menu (navbar(로그인 후) > 상단 메뉴 / 타임라인 > 탭 메뉴) */
.underline-menu:hover {
  border-bottom: 3px solid #E8EAF2 !important;
}
.underline-menu .v-icon {
  transition: none !important;
}

/* Swal 관련 */
.swal2-popup > .swal2-title {
  font-size: 20px !important;
}
.swal2-popup > .swal2-actions > button {
  height: 40px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  line-height: 20px !important;
  padding: 0px 14px !important;
  min-width: 48px !important;
}
/* .swal2-popup > .swal2-actions > .swal2-confirm.my-custom-confirm-button {
  background-color: transparent !important;
  font-weight: 500 !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  border: 1px solid #FFFFFF80 !important;
  height: 32px !important;
} */
.swal2-popup > .swal2-actions > .swal2-confirm {
  background-color: #687EFF !important;
  font-weight: 600 !important;
  color: #ffffff !important;
}
.swal2-popup > .swal2-actions > .swal2-confirm:focus {
  box-shadow: 0 0 0 3px #687EFF88 !important;
}
.swal2-popup > .swal2-actions > .swal2-cancel {
  border: 1px solid #E8EAF2 !important;
  background-color: #ffffff !important;
  font-weight: 500 !important;
  color: #414458 !important;
}
.swal2-popup > .swal2-actions > .swal2-cancel:focus {
  box-shadow: 0 0 0 3px #E8EAF288 !important;
}
.swal2-popup > .swal2-actions > .swal2-deny {
  border: 1px solid #E8EAF2 !important;
  background-color: #ffffff !important;
  font-weight: 500 !important;
  color: #414458 !important;
}
.swal2-popup > .swal2-actions > .swal2-deny:focus {
  box-shadow: 0 0 0 3px #E8EAF288 !important;
}
.swal2-popup.swal2-toast {
  padding: 8px !important;
}
.swal2-popup.swal2-toast .swal2-title {
  margin: 11px 1em;
}
.swal2-popup.my-custom-toast {
  height: 50px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: start !important;
  gap: 0px !important;
  padding: 0px 12px 0px 16px !important;
  border-radius: 8px !important;
}
.my-custom-text {
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 20px !important;
  color: #ffffff !important;
  white-space: pre-line !important;
  padding: 0px !important;
  margin: 0px !important;
}
.my-custom-actions {
  margin: 0px !important;
  padding: 0px 0px 0px 4px !important;
  display: flex !important;
  align-items: center !important;
}
.swal2-popup > .swal2-actions > .swal2-confirm.my-custom-confirm-button {
  background-color: transparent !important;
  font-weight: 500 !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  border: 1px solid #FFFFFF80 !important;
  height: 30px !important;
  padding: 0px 10px !important;
  margin: 0px 0px 0px 10px !important;
}

/* 리스트 아이템 */
.list-item {
  cursor: pointer;
}
.list-item:hover {
  background-color: #EFF0F6;
}
.list-item:hover > .list-item-text  {
  font-weight: 600 !important;
}

.check-list-item:hover {
  background-color: #F8F9FB;
}

/* 좌측 메뉴 헤더 */
.menu-header:hover {
  background-color: #EFF0F6;
}
/* 좌측 메뉴 헤더 > 프로젝트 아이템 */
.project-item:hover {
  background-color: #F8F9FB;
}
/* 좌측 메뉴 > 메뉴 아이템 */
.menu-item:hover {
  background-color: #EFF0F6;
}
.tutorial-menu-item:hover {
  background-color: #EFF0F6 !important;
}
/* 좌측 메뉴(접힌 상태) > 자식 메뉴 아이템 */
.child-menu-item:hover {
  background-color: #FFFFFF13;
}
/* 좌측 메뉴 접기/펼치기 버튼 */
.drawer-mini-btn:hover {
  background-color: #E8EAF2;
}

/* 좌측 메뉴 > 메뉴 아이템 */
.menu-item-2 {
  background-color: #ffffff;
}
.menu-item-2:hover {
  background-color: #EFF0F6;
}

/* 텍스트 드래그 방지 */
.drag-none {
  -ms-user-select: none; 
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}

/* 종스크롤 custom width */
.y-scroll-width-4px::-webkit-scrollbar {
  width: 4px; /* 스크롤 바 너비 조절 */
}

/* 스크롤 숨김 처리 */
.hide-scroll {
  -ms-overflow-style: none; /* IE, Edge */
  scrollbar-width: none; /* Firefox */
}
.hide-scroll::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

/* 횡스크롤 영역 */
.x-scroll::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 10px;
}
/* 횡스크롤 hover 시 표시 */
.x-scroll:hover::-webkit-scrollbar-thumb {
  background: #E8EAF2;
  border-radius: 10px;
}

/* navbar 관련 */
.v-toolbar__content {
  justify-content: center !important;
  padding: 4px 0px !important;
}
.theme--light.v-app-bar.v-toolbar.v-sheet {
  background-color: #FFFFFF4D !important;
  backdrop-filter: blur(40px) !important;
}
.notification-menu-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 12px;
  height: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 3.5px;
  border-radius: 999px;
  background: #FF3B30;
  color: #FFFFFF;
  font-size: 10px;
  font-weight: 700;
  line-height: 12px;
}

/* 좌측 메뉴 관련 */
.v-navigation-drawer__border {
  width: 0px !important;
}

/* expand btn icon 관련 */
.down {
  transition: all 0.3s !important;
}
.left {
  transform: rotate(90deg);
  transition: all 0.3s !important;
}
.right {
  transform: rotate(-90deg);
  transition: all 0.3s !important;
}
.up {
  transform: rotate(-180deg);
  transition: all 0.3s !important;
}

/* menu list 공통 */
.v-menu__content {
  border-radius: 8px !important;
  box-shadow: 4px 2px 12px 0px #0D0E1733 !important;
}
.v-menu__content.join-menu-content-1 {
  border-radius: 8px !important;
  box-shadow: 4px 6px 10px 0px #0D0E1733 !important;
}
.v-menu__content.join-menu-content-2 {
  border-radius: 8px !important;
  box-shadow: none !important;
}
.v-menu__content > .v-card {
  border-radius: 8px !important;
}
.v-menu__content > .v-card > .v-list > .v-item-group > .v-list-item {
  min-height: 10px !important;
  padding: 0px 12px;
  height: 24px;
}
.v-menu__content > .v-card > .v-list > .v-item-group > .v-list-item > .v-list-item__content {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  font-size: 12px;
}
.v-menu__content::-webkit-scrollbar-track {
  background: white;
}

/* drawer mini 상태에서 hover시 */
.v-navigation-drawer.v-navigation-drawer--is-mouseover .drawer-scroll-list {
  padding-right: 10px !important;
}
.v-navigation-drawer.v-navigation-drawer--is-mouseover .project-title {
  border: 1px solid #D8DDFF !important;
  color: #687EFF !important;
}
/* drawer 전체 스크롤바 표시x */
.v-navigation-drawer__content::-webkit-scrollbar {
  display: none;
}
/* drawer 스크롤 영역 */
.drawer-scroll-list::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 10px;
}
.drawer-scroll-list:hover::-webkit-scrollbar-thumb {
  background: #E8EAF2;
  border-radius: 10px;
}
/* drawer 스크롤 여부 관련 */
.drawer-scroll-blur {
  height: 32px;
  /* background: linear-gradient(to bottom, transparent 0%, white 100%); */
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.50) 20%, rgba(255, 255, 255, 0.80) 40%, rgba(255, 255, 255, 0.90) 60%, #FFF 80%);
}

/* (공통)메뉴의 title */
.v-list-item .v-list-item__title {
  line-height: 1.6 !important;
}

/* 클릭되지 않은 단일 메뉴 */
.deactive-menu {
  color: #414458;
  font-weight: 500;
}
/* 클릭되지 않은 단일 메뉴의 icon */
.deactive-menu-icon {
  color: #414458 !important;
}
/* 클릭되지 않은 단일 메뉴의 title */
.deactive-menu-title {
  color: #414458;
  font-weight: 500;
}
/* 클릭되지 않은 단일 메뉴 hover시 icon */
.deactive-menu:hover .deactive-menu-icon {
  color: #0D0E17 !important;
}
/* 클릭되지 않은 단일 메뉴 hover시 title */
.deactive-menu:hover .deactive-menu-title {
  color: #0D0E17;
  font-weight: 600;
}
/* 클릭된 메뉴 */
.active-menu {
  background-color: #F0F2FF;
}
/* 클릭된 메뉴의 icon */
.active-menu-icon {
  color: #687EFF !important;
}
/* 클릭된 메뉴의 title */
.active-menu-title {
  color: #687EFF !important;
  font-weight: 600 !important;
}

/* 그룹 메뉴 */
.v-list-group__header.v-list-item {
  min-height: 48px !important;
  max-height: 48px !important;
  padding: 0px 0px 0px 4px !important;
  margin: 0px 0px 4px 0px;
}
.v-list--nav .v-list-item:not(:last-child):not(:only-child) {
  margin-bottom: 4px !important;
}
/* 그룹 메뉴의 append-icon wrapper */
.v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
  min-width: 24px !important;
  margin-left: 0px !important;
  margin-right: 18px !important;
}

/* 닫힌 그룹 메뉴의 icon */
.v-list-group__header .v-list-item__icon .v-icon {
  color: #414458 !important;
}
/* 닫힌 그룹 메뉴의 title */
.v-list-group__header .v-list-item__content {
  color: #414458;
  font-weight: 500;
}
/* 닫힌 그룹 메뉴 hover시 icon(공통) */
.v-list-group__header:hover .v-list-item__icon .v-icon {
  color: #0D0E17 !important;
}
/* 닫힌 그룹 메뉴 hover시 title */
.v-list-group__header:hover .v-list-item__content .v-list-item__title {
  color: #0D0E17;
  font-weight: 600;
}

/* 닫힌 그룹 메뉴의 자식 메뉴 활성화 시 background */
.v-list-group.child-active .v-list-group__header {
  background-color: #f0f2ff !important;
}
/* 닫힌 그룹 메뉴의 자식 메뉴 활성화 시 icon */
.v-list-group.child-active .v-list-group__header .v-list-item__icon .v-icon {
  color: #687EFF !important;
}
/* 닫힌 그룹 메뉴의 자식 메뉴 활성화 시 title */
.v-list-group.child-active .v-list-group__header .v-list-item__content {
  color: #687EFF;
  font-weight: 600;
}
/* 닫힌 그룹 메뉴의 자식 메뉴 활성화 및 hover 시 icon */
.v-list-group.child-active .v-list-group__header:hover .v-list-item__icon .v-icon {
  color: #687EFF !important;
}
/* 닫힌 그룹 메뉴의 자식 메뉴 활성화 및 hover 시 title */
.v-list-group.child-active .v-list-group__header:hover .v-list-item__title {
  color: #687EFF;
  font-weight: 600;
}

/* 닫힌 그룹 메뉴 hover시 append-icon */
.v-list-group__header:hover .v-list-item__icon.v-list-group__header__append-icon .v-icon {
  transform: translateY(3px) !important;
}
/* 열린 그룹 메뉴 hover시 append-icon */
.v-list-group__header.v-list-item--active:hover .v-list-item__icon.v-list-group__header__append-icon .v-icon {
  transform: rotate(-180deg) !important;
}

/* 열린 그룹 메뉴의 icon */
.v-list-group__header.v-list-item--active .v-list-item__icon .v-icon {
  color: #687EFF !important;
}
/* 열린 그룹 메뉴의 title */
.v-list-group__header.v-list-item--active .v-list-item__content {
  color: #687EFF;
  font-weight: 600;
}
/* 열린 그룹 메뉴 hover시 icon */
.v-list-group__header.v-list-item--active:hover .v-list-item__icon .v-icon {
  color: #687EFF !important;
}
/* 열린 그룹 메뉴 hover시 title */
.v-list-group__header.v-list-item--active:hover .v-list-item__content .v-list-item__title {
  color: #687EFF;
  font-weight: 600;
}

/* 클릭되지 않은 자식 메뉴 */
.deactive-child-menu {
  color: #0D0E17;
  font-weight: 400;
}
/* 클릭되지 않은 자식 메뉴 hover시 */
.deactive-child-menu:hover * {
  color: #0D0E17;
  font-weight: 600;
}
/* 클릭된 자식 메뉴 */
.active-child-menu {
  background-color: #FFFFFF;
  font-weight: 600;
}

/* 비활성화 관련 */
.click-disabled {
  pointer-events: none;
}
.disabled-area {
  opacity: 0.5;
  pointer-events: none;
}
.disabled-area-E8EAF2 {
  pointer-events: none;
}
.disabled-area-E8EAF2 .v-icon {
  color: #E8EAF2 !important;
}
.disabled-area-E8EAF2 div {
  color: #E8EAF2 !important;
}
.disabled-area-opacity-40 {
  opacity: 0.4;
  pointer-events: none;
}
.disabled-area-opacity-30 {
  opacity: 0.3;
  pointer-events: none;
}
/* 비활성화 관련 */
.area-opacity-30 {
  opacity: 0.3;
}

/* key-value 관련 */
.key-text {
  font-size: 14px;
  font-weight: 800;
}

/* 스크롤바 관련 */
*::-webkit-scrollbar {
  width: 8px;
}
*::-webkit-scrollbar:horizontal {
  height: 8px;
}
*::-webkit-scrollbar-thumb {
  background: #E8EAF2;
  border-radius: 10px;
}
*::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
*::-webkit-scrollbar-track {
  background: transparent;
}

/* 테이블 탭 관련 */
.table-tab-list {
  scroll-behavior: smooth;
}
.table-tab-list::-webkit-scrollbar:horizontal {
  height: 0px;
}
.default-tab-inner-box:hover {
  background: #0D0E170F;
}
/* 테이블 탭 관련 */
.defalut-table-tab:hover {
  color: #0D0E17;
}
.defalut-table-tab {
  background-color: #F8F8FB;
  font-weight: 400;
  color: #414458;
  border: 1px solid #E8EAF2;
  transform: translateY(0px);
  height: 37px;
}
.active-table-tab {
  background-color: #FFFFFF;
  font-weight: 600;
  color: #687EFF;
  z-index: 9999 !important;
  border: 1px solid #E8EAF2;
  border-bottom: 1px solid white;
  transform: translateY(0px);
  height: 37px;
}

/* 기본 흰색 버튼 */
.default-white-btn {
  background-color: #FFFFFF !important;
  border: 1px solid #E8EAF2 !important;
  border-radius: 8px !important;
  color: #414458 !important;
  cursor: pointer !important;
  font-weight: 500 !important;
  word-break: keep-all !important;
  transition: none !important;
}
.default-white-btn .v-icon {
  color: #414458 !important;
  transition: none !important;
}
.default-white-btn div, .default-white-btn span {
  color: #414458 !important;
  font-weight: 500 !important;
  word-break: keep-all !important;
  transition: none !important;
}
/* 기본 흰색 버튼 - hover */
.default-white-btn:hover {
  background-color: #F8F8FB !important;
  color: #0D0E17 !important;
}
.default-white-btn:hover .v-icon {
  color: #0D0E17 !important;
}
.default-white-btn:hover div, .default-white-btn:hover span {
  color: #0D0E17 !important;
}
/* 기본 흰색 버튼 - disabled */
.disabled-white-btn {
  pointer-events: none !important;
  cursor: none !important;
  background-color: #FFFFFF !important;
  border: 1px solid #E8EAF2 !important;
  border-radius: 8px !important;
  color: #D8DAE9 !important;
  word-break: keep-all !important;
  transition: none !important;
}
.disabled-white-btn .v-icon {
  color: #D8DAE9 !important;
  transition: none !important;
}
.disabled-white-btn div, .disabled-white-btn span {
  color: #D8DAE9 !important;
  word-break: keep-all !important;
  transition: none !important;
}

/* 기본 흰색(on/off) 버튼 */
.on-off-box-btn {
  background-color: #FFFFFF !important;
  border: 1px solid #E8EAF2 !important;
  border-radius: 8px !important;
  cursor: pointer !important;
}
.on-off-box-btn .v-icon {
  color: #8A8DA8 !important;
  transition: none !important;
}
.on-off-box-btn div, .on-off-box-btn span {
  color: #414458 !important;
  font-weight: 500 !important;
  word-break: keep-all !important;
}
/* 기본 흰색(on/off) 버튼 - hover */
.on-off-box-btn:hover {
  background-color: #F8F8FB !important;
}
.on-off-box-btn:hover .v-icon {
  color: #0D0E17 !important;
}
.on-off-box-btn:hover div, .on-off-box-btn:hover span {
  color: #0D0E17 !important;
}
/* 기본 흰색 버튼 - active */
.active-on-off-box-btn {
  background-color: #F0F2FF !important;
  border: 1px solid #687EFF !important;
  border-radius: 8px !important;
  cursor: pointer !important;
}
.active-on-off-box-btn .v-icon {
  color: #687EFF !important;
  transition: none !important;
}
.active-on-off-box-btn div, .active-on-off-box-btn span {
  color: #687EFF !important;
  font-weight: 600 !important;
  word-break: keep-all !important;
}
/* 기본 흰색 버튼 - disabled */
.disabled-on-off-box-btn {
  pointer-events: none !important;
  cursor: none !important;
  background-color: #FFFFFF !important;
  border: 1px solid #E8EAF2 !important;
  border-radius: 8px !important;
}
.disabled-on-off-box-btn .v-icon {
  color: #D8DAE9 !important;
}
.disabled-on-off-box-btn div, .disabled-on-off-box-btn span {
  color: #D8DAE9 !important;
  word-break: keep-all !important;
}

/* 그룹 버튼 */
.default-group-btn {
  cursor: pointer !important;
}
.default-group-btn:hover {
  background-color: #0D0E170F !important;
}

/* 기본 테마 색상 버튼 */
.default-theme-btn {
  background-color: #687EFF !important;
  border-radius: 8px !important;
  color: #FFFFFF !important;
  cursor: pointer !important;
  font-weight: 600 !important;
  word-break: keep-all !important;
}
.default-theme-btn .v-icon {
  color: #FFFFFF !important;
  transition: none !important;
}
.default-theme-btn div, .default-theme-btn span {
  color: #FFFFFF !important;
  font-weight: 600 !important;
  word-break: keep-all !important;
}
/* 기본 테마 색상 버튼 - hover */
.default-theme-btn:hover {
  background-color: #5E71E5 !important;
}
/* 기본 테마 색상 버튼 - disabled */
.disabled-theme-btn {
  pointer-events: none !important;
  cursor: none !important;
  background-color: #D8DDFF !important;
  border-radius: 8px !important;
  color: #FFFFFF !important;
  font-weight: 600 !important;
  word-break: keep-all !important;
}
.disabled-theme-btn .v-icon {
  color: #FFFFFF !important;
}
.disabled-theme-btn div, .disabled-theme-btn span {
  color: #FFFFFF !important;
  font-weight: 600 !important;
  word-break: keep-all !important;
}

/* 기본 테마 색상 폰트 버튼 */
.default-theme-font-btn {
  background-color: #ffffff !important;
  border-radius: 8px !important;
  cursor: pointer !important;
}
.default-theme-font-btn div, .default-theme-font-btn span {
  color: #687EFF !important;
  font-weight: 600 !important;
  word-break: keep-all !important;
}
.default-theme-font-btn:hover {
  background-color: #F8F8FB !important;
}

/* 기본 테마 색상 테두리 버튼 */
.default-theme-outline-btn {
  border: 1px solid #687EFF;
  border-radius: 8px;
  background-color: #FFFFFF;
  cursor: pointer;
}
.default-theme-outline-btn:hover {
  background-color: #F0F2FF;
}

/* 기본 테마 색상(배경 투명) 테두리 버튼 */
.default-theme-outline-btn-transparent {
  border: 1px solid #687EFF;
  border-radius: 8px;
  background-color: transparent;
  cursor: pointer;
}
.default-theme-outline-btn-transparent:hover {
  background-color: #F0F2FF;
}

/* 배경 투명 버튼 */
.default-transparent-btn {
  background-color: transparent !important;
  border-radius: 8px;
  cursor: pointer;
}
.default-transparent-btn:hover {
  background-color: #0D0E170F !important;
}

/* 배경 투명 버튼 2 */
.default-transparent-btn-2 {
  background-color: transparent !important;
  border-radius: 8px;
  cursor: pointer;
}
.default-transparent-btn-2:hover {
  background-color: #EFF0F6 !important;
}

/* 배경 투명 버튼 3 */
.default-transparent-btn-3 {
  background-color: transparent !important;
}
.default-transparent-btn-3:hover {
  background-color: #FFFFFF1A !important;
}

/* 아이콘 버튼 */
.default-icon-btn {
  background-color: transparent !important;
  border-radius: 999px !important;
  cursor: pointer !important;
}
.default-icon-btn .v-icon {
  color: #414458 !important;
  transition: none !important;
}
/* 아이콘 버튼 - hover */
.default-icon-btn:hover {
  background-color: #0D0E170F !important;
}
/* 아이콘 버튼 - disabled */
.disabled-icon-btn {
  pointer-events: none !important;
  cursor: none !important;
  background-color: transparent !important;
}
.disabled-icon-btn .v-icon {
  color: #D8DAE9 !important;
  transition: none !important;
}
.disabled-icon-btn-2 {
  pointer-events: none !important;
  cursor: none !important;
  background-color: transparent !important;
}
.disabled-icon-btn-2 .v-icon {
  color: #E8EAF2 !important;
  transition: none !important;
}

/* 아이콘 버튼 2 */
.default-icon-btn-2 {
  background-color: #EFF0F6 !important;
  border-radius: 999px !important;
  cursor: pointer !important;
}
.default-icon-btn-2 .v-icon {
  color: #414458 !important;
  /* transition: none !important; */
}
/* 아이콘 버튼 - hover */
.default-icon-btn-2:hover {
  background-color: #0D0E170F !important;
}

/* 아이콘 버튼 */
.default-icon-btn-dark {
  background-color: transparent !important;
  border-radius: 999px !important;
  cursor: pointer !important;
}
.default-icon-btn-dark .v-icon {
  color: #ffffff !important;
  /* transition: none !important; */
}
/* 아이콘 버튼 - hover */
.default-icon-btn-dark:hover {
  background-color: #FFFFFF1A !important;
}

/* 테마 색상 아이콘 버튼 */
.default-theme-icon-btn {
  background-color: transparent !important;
  border-radius: 999px !important;
  cursor: pointer !important;
}
.default-theme-icon-btn .v-icon {
  color: #687EFF !important;
  transition: none !important;
}
/* 테마 색상 아이콘 버튼 - hover */
.default-theme-icon-btn:hover {
  background-color: #687EFF0F !important;
}
/* 테마 색상 아이콘 버튼 - disabled */
.disabled-theme-icon-btn {
  pointer-events: none !important;
  cursor: none !important;
  background-color: transparent !important;
}
.disabled-theme-icon-btn .v-icon {
  color: #D8DAE9 !important;
}

/* 배경 테마 색상 아이콘 버튼 */
.default-theme-background-icon-btn {
  border-radius: 999px !important;
  background-color: #687EFF !important;
  box-shadow: 4px 4px 8px 0px #0D0E1729 !important;
  cursor: pointer !important;
}
.default-theme-background-icon-btn .v-icon {
  color: #FFFFFF !important;
  transition: none !important;
}
/* 배경 테마 색상 아이콘 버튼 - hover */
.default-theme-background-icon-btn:hover {
  background-color: #5E71E5 !important;
}
/* 배경 테마 색상 아이콘 버튼 - disabled */
.disabled-theme-background-icon-btn {
  pointer-events: none !important;
  cursor: none !important;
  background-color: transparent !important;
}
.disabled-theme-background-icon-btn .v-icon {
  color: #D8DAE9 !important;
}

/* 기본 테두리 아이콘 버튼 */
.default-border-icon-btn {
  border-radius: 999px !important;
  background-color: #FFFFFF !important;
  border: 1px solid #E8EAF2 !important;
  box-shadow: 4px 4px 8px 0px #0D0E1729 !important;
  cursor: pointer !important;
}
.default-border-icon-btn .v-icon {
  color: #8A8DA8 !important;
  transition: none !important;
}
/* 기본 테두리 아이콘 버튼 - hover */
.default-border-icon-btn:hover {
  background-color: #F8F8FB !important;
}
/* 기본 테두리 아이콘 버튼 - disabled */
.disabled-border-icon-btn {
  pointer-events: none !important;
  border-radius: 999px !important;
  background-color: #FFFFFF !important;
  border: 1px solid #E8EAF2 !important;
  cursor: none !important;
}
.disabled-border-icon-btn .v-icon {
  color: #E8EAF2 !important;
}

/* 배경 흰색(투명도o) 아이콘 버튼 */
.default-white-opacity-icon-btn {
  border-radius: 999px !important;
  background-color: #FFFFFF1A !important;
  box-shadow: 0px 0px 10px 0px #0D0E1729 !important;
  backdrop-filter: blur(5px) !important;
  cursor: pointer !important;
}
/* 배경 흰색 아이콘 버튼 */
.default-white-icon-btn {
  border-radius: 999px !important;
  background-color: #FFFFFF !important;
  box-shadow: 4px 4px 8px 0px #0D0E1729 !important;
  backdrop-filter: blur(5px) !important;
  cursor: pointer !important;
}
/* 배경 흰색 아이콘 버튼 - hover */
.default-white-icon-btn:hover {
  border-radius: 999px !important;
  background-color: #0D0E170F !important;
  box-shadow: 4px 4px 8px 0px #0D0E1729 !important;
  backdrop-filter: blur(5px) !important;
  cursor: pointer !important;
}
/* 배경 흰색 아이콘 버튼 - disabled */
.disabled-white-icon-btn {
  pointer-events: none !important;
  cursor: none !important;
}
.disabled-white-icon-btn * {
  color: #E8EAF2 !important;
}

/* 기본 chip 버튼 */
.default-chip {
  background-color: #FFFFFF;
  border: 1px solid #E8EAF2;
  border-radius: 999px;
  cursor: pointer;
}
.default-chip .v-icon {
  color: #E8EAF2 !important;
  transition: none !important;
}
.default-chip div {
  font-weight: 500;
  color: #414458;
}
/* 기본 chip 버튼 - hover */
.default-chip:hover {
  background-color: #0D0E170F;
}
.default-chip:hover .v-icon {
  color: #0D0E17 !important;
  transition: none !important;
}
.default-chip:hover div {
  font-weight: 600;
  color: #0D0E17;
}
/* 기본 chip 버튼 - active */
.active-chip {
  background-color: #F0F2FF;
  border: 1px solid #687EFF;
  border-radius: 999px;
  cursor: pointer;
}
.active-chip .v-icon {
  color: #687EFF !important;
  transition: none !important;
}
.active-chip div {
  font-weight: 600;
  color: #687EFF;
}

/* 기본 체크박스 관련 */
.checkbox-btn {
  border-radius: 999px !important;
  cursor: pointer;
}
.checkbox-btn:hover {
  background: #0D0E170F;
}
.checkbox-btn .v-icon {
  transition: none !important;
}

/* 기본 라디오 관련 */
.radio-btn {
  border-radius: 999px !important;
  cursor: pointer;
}
.radio-btn .v-icon {
  transition: none !important;
}
.radio-btn:hover {
  background: #0D0E170F;
}

/* dropdown 목록 아이템 관련 */
.drop-down-item:hover {
  background-color: #F8F8FB;
  font-weight: 600;
}

/* dialog 관련 */
.v-dialog {
  overflow: hidden !important;
  border-radius: 16px !important;
}
.v-dialog .v-card {
  border-radius: 16px !important;
}

/* animation dots */
.animation-dots {
  /* width: 16px; */
  aspect-ratio: 2;
  --_g: no-repeat linear-gradient(#687EFF 0 0);
  background:
    var(--_g) 10% 50%,
    var(--_g) 50% 50%,
    var(--_g) 90% 50%;
  background-size: calc(100% / 5) 40%; /* 사각형 크기를 줄여서 간격을 생성 */
  animation: dots3 1s infinite linear;
}
@keyframes dots3 {
  20% { background-position: 10% 0%, 50%  50%, 90%  50%; }
  40% { background-position: 10% 100%, 50% 0%, 90%  50%; }
  60% { background-position: 10% 50%, 50% 100%, 90%  0%; }
  80% { background-position: 10% 50%, 50% 50%, 90% 100%; }
}

/* 텍스트 입력창 관련 */
.v-text-field >>> input::placeholder {
  color: #ABAEC4 !important;
  opacity: 1;
}
.text-input.v-text-field--outlined >>> fieldset {
  border-color: #E8EAF2 !important;
}
.text-input >>> .v-input__slot {
  padding: 0px 10px !important;
  min-height: 0px !important;
}
.text-input-px-4 >>> .v-input__slot {
  padding: 0px 16px !important;
  min-height: 0px !important;
}
.text-input >>> .v-input__icon--append > .v-icon {
  color: #D8DAE9 !important;
  font-size: 20px !important;
}
.text-input.v-input--is-focused {
  box-shadow: 0px 0px 16px 0px #687EFF33 !important;
}
.text-input.v-input--is-focused >>> fieldset {
  border-color: #687EFF !important;
  border-width: 1px !important;
}

/* btn-1 - 데이터 우상단 버튼 */
.btn-1 {
  border-radius: 8px;
  background-color: #EFF0F6;
  cursor: pointer;
}
/* btn-1 - 데이터 우상단 버튼 > 즐겨찾기 버튼 */
.btn-1-favorite svg path {
  fill: #EAC54F !important;
}
.btn-1 .v-icon {
  transition: none !important;
}
.btn-1:hover {
  background-color: #D8DAE9;
}
.btn-1:hover div
{
  color: #414458 !important;
}
.btn-1:hover .v-icon
{
  color: #414458 !important;
}
.btn-1:hover svg path
{
  fill: #414458;
}
.btn-1-disabled {
  pointer-events: none !important;
  cursor: none !important;
}
.btn-1-disabled .v-icon {
  color: #ABAEC4 !important;
}

/* btn-2 - 데이터 우상단 버튼 > 기능 목록 숨김/표시 버튼 */
.btn-2 {
  border-radius: 8px;
  background-color: #414458;
  cursor: pointer;
}

/* btn-3 - 데이터 우측 메뉴 목록 > 하단 버튼 그룹 */
.btn-3 {
  border-radius: 8px;
  background-color: #FFFFFF;
  cursor: pointer;
}
.btn-3:hover {
  background-color: #EFF0F6;
}
.disabled-btn-3 {
  pointer-events: none !important;
  cursor: none !important;
}
.disabled-btn-3 .v-icon {
  color: #E8EAF2 !important;
}
.disabled-btn-3 svg path {
  fill: #E8EAF2 !important;
}

/* Chrome, Safari, Edge, Opera */
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
.no-spinner[type="number"] {
  appearance: textfield;
  -moz-appearance: textfield;
}

/* 기본 입력창 (v-text-field) */
.default-text-input {
  font-size: 14px;
}
.default-text-input >>> fieldset {
  border-color: transparent;
}
.default-text-input >>> .v-input__control > .v-input__slot {
  min-height: 38px;
  height: 38px;
  padding: 0px !important;
}

/* hover 시 icon 움직이는 버튼 */
.hover-icon-slide-btn-4px .v-icon {
  animation-timing-function: ease-out;
  animation-duration: 300ms;
}
.hover-icon-slide-btn-4px:hover .v-icon {
  transform: translateX(4px);
}
.hover-icon-slide-btn-2px .v-icon {
  animation-timing-function: ease-out;
  animation-duration: 300ms;
}
.hover-icon-slide-btn-2px:hover .v-icon {
  transform: translateX(2px);
}

/* 검은 배경 버튼 */
.default-black-btn {
  background-color: #0D0E17 !important;
  border-radius: 8px !important;
  cursor: pointer !important;
}
.default-black-btn div, .default-black-btn span {
  color: #FFFFFF !important;
  font-weight: 700 !important;
  word-break: keep-all !important;
}
.default-black-btn .v-icon {
  color: #FFFFFF !important;
  animation-timing-function: ease-out;
  animation-duration: 300ms;
}
.default-black-btn:hover .v-icon {
  transform: translateX(10px);
}

/* 회색 배경 버튼 */
.default-grey-btn {
  cursor: pointer;
}
.default-grey-btn:hover {
  background-color: #EFF0F6 !important;
}
.default-grey-btn:hover .v-icon {
  transform: translateX(10px);
}

/* hover 시 icon 애니메이션 버튼 */
.hover-icon-transform-translateX-10px-btn:hover .v-icon {
  transform: translateX(10px);
}

/* enterprise-chip */
.enterprise-chip {
  background: linear-gradient(90deg, #687EFF -0.48%, #68B4FF 99.52%) !important;
  border-radius: 999px !important;
  justify-content: flex-start;
  overflow: hidden;
  position: relative;
  min-width: 30px;
  max-width: 30px;
  transition: min-width 0.4s ease-in-out, max-width 0.4s ease-in-out; /* 너비 변경 애니메이션 */
}
.enterprise-chip:hover {
  min-width: 92px !important;
  max-width: 92px !important;
}
.enterprise-chip div {
  /* animation-timing-function: ease-out;
  animation-duration: 300ms;
  display: none; */
  white-space: nowrap;
  transform: translateX(100%); /* 기본적으로 오른쪽 바깥으로 숨김 */
  transition: transform 0.5s ease-in-out;
}
.enterprise-chip:hover div {
  /* display: block; */
  transform: translateX(0); /* hover 시 텍스트가 나타남 */
}

/* 배경 어둡게 처리(프로세스 아이템 변경) */
.dark-overlay {
  background-color: rgba(0, 0, 0, 0.5); /* 검정색, 50% 투명도 */
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000; /* 다른 요소 위에 나타나도록 설정 */
}

/* 배경 어둡게 처리(기본 튜토리얼) */
.tutorial-dark-overlay {
  background-color: rgba(0, 0, 0, 0.4); /* 검정색, 40% 투명도 */
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000; /* 다른 요소 위에 나타나도록 설정 */
}

/* 배경 어둡게 처리(rpa 튜토리얼) */
.rpa-tutorial-dark-overlay {
  background-color: rgba(0, 0, 0, 0.4); /* 검정색, 40% 투명도 */
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000; /* 다른 요소 위에 나타나도록 설정 */
}

/* 튜토리얼 시작 dialog > 목록 item */
.tutorial-start-dialog-item:hover {
  background-color: #F8F9FB;
}
/* 튜토리얼 시 하이라이트 되는 아이템 */
.tutorial-item {
  z-index: 1001;
}
/* 튜토리얼 카드 */
.tutorial-card {
  box-shadow: 4px 2px 12px 0px #0D0E1733;
}
/* 튜토리얼 카드 말풍선의 꼬리(공통) */
.tutorial-card::after {
  content: '';
  position: absolute;
  background: #687EFF;
}
/* 튜토리얼 카드 말풍선의 꼬리(상단 좌측) */
.tutorial-card.polygon-top-left::after {
  width: 16px;
  height: 10px;
  top: -9px; /* 말풍선 꼬리 위치 */
  left: 14px; /* 말풍선 꼬리 좌우 위치 */
  clip-path: polygon(50% 0, 0% 100%, 100% 100%); /* 위를 향하는 삼각형 */
  transform: rotate(0deg);
}
/* 튜토리얼 카드 말풍선의 꼬리(상단 중앙) */
.tutorial-card.polygon-top-center::after {
  width: 16px;
  height: 10px;
  top: -9px; /* 말풍선 꼬리 위치 */
  left: calc(50% - calc(16px / 2)); /* 말풍선 꼬리 좌우 위치 */
  clip-path: polygon(50% 0, 0% 100%, 100% 100%); /* 위를 향하는 삼각형 */
  transform: rotate(0deg);
}
/* 튜토리얼 카드 말풍선의 꼬리(상단 우측) */
.tutorial-card.polygon-top-right::after {
  width: 16px;
  height: 10px;
  top: -9px; /* 말풍선 꼬리 위치 */
  right: 14px; /* 말풍선 꼬리 좌우 위치 */
  clip-path: polygon(50% 0, 0% 100%, 100% 100%); /* 위를 향하는 삼각형 */
  transform: rotate(0deg);
}
/* 튜토리얼 카드 말풍선의 꼬리(상단 우측) */
.tutorial-card.polygon-top-right-2::after {
  width: 16px;
  height: 10px;
  top: -9px; /* 말풍선 꼬리 위치 */
  right: 55px; /* 말풍선 꼬리 좌우 위치 */
  clip-path: polygon(50% 0, 0% 100%, 100% 100%); /* 위를 향하는 삼각형 */
  transform: rotate(0deg);
}
/* 튜토리얼 카드 말풍선의 꼬리(하단 중앙) */
.tutorial-card.polygon-bottom-center::after {
  width: 16px;
  height: 10px;
  bottom: -9px; /* 말풍선 꼬리 위치 */
  left: calc(50% - calc(16px / 2)); /* 말풍선 꼬리 좌우 위치 */
  clip-path: polygon(50% 0, 0% 100%, 100% 100%); /* 위를 향하는 삼각형 */
  transform: rotate(180deg);
}
/* 튜토리얼 카드 말풍선의 꼬리(좌측 중앙) */
.tutorial-card.polygon-left-center::after {
  width: 16px;
  height: 10px;
  top: calc(50% - calc(13px / 2)); /* 말풍선 꼬리 위치 */
  left: -13px; /* 말풍선 꼬리 좌우 위치 */
  clip-path: polygon(50% 0, 0% 100%, 100% 100%); /* 위를 향하는 삼각형 */
  transform: rotate(-90deg);
}
/* 튜토리얼 카드 말풍선의 꼬리(우측 중앙) */
.tutorial-card.polygon-right-center::after {
  width: 16px;
  height: 10px;
  top: calc(50% - calc(13px / 2)); /* 말풍선 꼬리 위치 */
  right: -13px; /* 말풍선 꼬리 좌우 위치 */
  clip-path: polygon(50% 0, 0% 100%, 100% 100%); /* 위를 향하는 삼각형 */
  transform: rotate(90deg);
}
/* 튜토리얼 카드 말풍선의 꼬리(우측 하단) */
.tutorial-card.polygon-right-bottom::after {
  width: 16px;
  height: 10px;
  bottom: 12px; /* 말풍선 꼬리 위치 */
  right: -13px; /* 말풍선 꼬리 좌우 위치 */
  clip-path: polygon(50% 0, 0% 100%, 100% 100%); /* 위를 향하는 삼각형 */
  transform: rotate(90deg);
}

/* 데이터 목록 > 데이터 드래그 영역 */
.drag-area {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5));
}

/* 멤버 목록 아이템 */
.user-item:hover {
  background-color: #F8F9FB;
}

.menu-content-overflow-hidden {
  overflow: hidden !important;
}

.z-index-3 {
  z-index: 3 !important;
}
.z-index-4 {
  z-index: 4 !important;
}
.z-index-100 {
  z-index: 100 !important;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 최대 줄 수 설정 */
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style scoped>
/* 입력창 관련 */
.default-input.v-text-field--outlined >>> fieldset {
  border-color: #E8EAF2;
}
.default-input >>> .v-input__slot {
  padding-left: 16px !important;
  min-height: 32px !important;
}
.default-input.v-input--is-focused {
  box-shadow: 0px 0px 16px 0px #687EFF33;
}
.default-input.v-input--is-focused >>> fieldset {
  border-color: #687EFF;
  border-width: 1px;
}

/* 입력창 관련 */
.default-input-2.v-text-field--outlined >>> fieldset {
  border-color: #E8EAF2;
}
.default-input-2 >>> .v-input__slot {
  padding-left: 12px !important;
  min-height: 32px !important;
}
.default-input-2.v-input--is-focused {
  box-shadow: 0px 0px 16px 0px #687EFF33;
}
.default-input-2.v-input--is-focused >>> fieldset {
  border-color: #687EFF;
  border-width: 1px;
}

/* 텍스트 입력창 관련 */
.v-text-field >>> input::placeholder {
  color: #ABAEC4 !important;
  opacity: 1;
}
.text-input.v-text-field--outlined >>> fieldset {
  border-color: #E8EAF2 !important;
}
.text-input >>> .v-input__slot {
  padding: 0px 10px !important;
  min-height: 0px !important;
}
.text-input-px-4 >>> .v-input__slot {
  padding: 0px 16px !important;
  min-height: 0px !important;
}
.text-input >>> .v-input__icon--append > .v-icon {
  color: #D8DAE9 !important;
  font-size: 20px !important;
}
.text-input.v-input--is-focused {
  box-shadow: 0px 0px 16px 0px #687EFF33 !important;
}
.text-input.v-input--is-focused >>> fieldset {
  border-color: #687EFF !important;
  border-width: 1px !important;
}

/* 검색창 (height 32px) 관련 */
.search-input-32.v-text-field--outlined >>> fieldset {
  border-color: #F8F9FB;
}
.search-input-32 >>> input::placeholder {
  color: #8A8DA8 !important;
}
.search-input-32 >>> .v-input__prepend-inner {
  margin-top: 6px !important;
  padding-right: 4px !important;
}
.search-input-32 >>> .v-input__icon--prepend-inner {
  min-width: 20px !important;
  width: 20px !important;
  height: 20px !important;
}
.search-input-32 >>> .v-input__icon--prepend-inner > .v-icon {
  font-size: 20px !important;
  color: #8A8DA8;
  transition: none;
}
.search-input-32 >>> .v-input__slot {
  min-height: 32px !important;
  padding-left: 14px !important;
  padding-right: 8px !important;
  transition: none;
}
.search-input-32.v-input--is-focused {
  box-shadow: 0px 0px 16px 0px #687EFF33;
}
.search-input-32.v-input--is-focused >>> .v-input__slot {
  background-color: #FFFFFF !important;
}
.search-input-32.v-input--is-focused >>> fieldset {
  border-color: #687EFF;
  border-width: 1px;
}

/* 검색창 (height 40px) 관련 */
.search-input-40.v-text-field--outlined >>> fieldset {
  border-color: #F8F9FB;
}
.search-input-40 >>> input::placeholder {
  color: #8A8DA8 !important;
}
.search-input-40 >>> .v-input__prepend-inner {
  margin-top: 8px !important;
  padding-right: 4px !important;
}
.search-input-40 >>> .v-input__icon--prepend-inner > .v-icon {
  color: #8A8DA8;
  transition: none;
}
.search-input-40 >>> .v-input__slot {
  padding-left: 14px !important;
  padding-right: 8px !important;
  transition: none;
}
.search-input-40.v-input--is-focused {
  box-shadow: 0px 0px 16px 0px #687EFF33;
}
.search-input-40.v-input--is-focused >>> .v-input__slot {
  background-color: #FFFFFF !important;
}
.search-input-40.v-input--is-focused >>> fieldset {
  border-color: #687EFF;
  border-width: 1px;
}

.hover-pjt-title {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.fade-enter-active,
.fade-leave-active {
  /* transition: opacity 0.5s ease; */
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.fade-enter, /* 들어올 때 초기 상태 */
.fade-leave-to { /* 나갈 때 마지막 상태 */
  opacity: 0;
}
</style>
